
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
// your main JavaScript file
// imports --------------------------------------------------------------------
var $d1dffb77f2e2cbfc$exports = {};

$parcel$export($d1dffb77f2e2cbfc$exports, "cookiesPrefix", () => $d1dffb77f2e2cbfc$export$da79f85e8b84a959);
$parcel$export($d1dffb77f2e2cbfc$exports, "cookiesAcceptIframes", () => $d1dffb77f2e2cbfc$export$b6695554533f9b1e);
$parcel$export($d1dffb77f2e2cbfc$exports, "initCookies", () => $d1dffb77f2e2cbfc$export$a2cf2b09102a656b);
$parcel$export($d1dffb77f2e2cbfc$exports, "openBanner", () => $d1dffb77f2e2cbfc$export$d9841960328045f4);
$parcel$export($d1dffb77f2e2cbfc$exports, "cookiesAddHTML", () => $d1dffb77f2e2cbfc$export$3d6d112e1c42474a);
$parcel$export($d1dffb77f2e2cbfc$exports, "cookiesDoSetIframes", () => $d1dffb77f2e2cbfc$export$d4ef740ab7d8e5af);
$parcel$export($d1dffb77f2e2cbfc$exports, "openIframes", () => $d1dffb77f2e2cbfc$export$9247c17b52f5af42);
// maybe remove cookies on language switch?
// localStorage.removeItem(cookiesPrefix + 'SetCookies');
// localStorage.removeItem(cookiesPrefix + 'Cookies');
// if using history navigation, do cookiesDoSetIframes in setPage!!!
// imports --------------------------------------------------------------------
// all your go to vars in one place
// imports --------------------------------------------------------------------
// set user variables ---------------------------------------------------------
// also change in css
const $183c77cc0773b3dc$export$36f2bcc84865b53b = true; // firefox sometimes has buggy view transitions
const $183c77cc0773b3dc$export$bc5e1f7fdf0656e1 = 200;
const $183c77cc0773b3dc$export$35a4a76088200152 = 400;
const $183c77cc0773b3dc$export$34977f05af4bf228 = 800;
const $183c77cc0773b3dc$export$e57b424cfcf1fb09 = 1000;
const $183c77cc0773b3dc$export$abb3878d4b973569 = 1600;
const $183c77cc0773b3dc$export$f09585a853dddd32 = 1400;
const $183c77cc0773b3dc$export$3c17b0e969a90510 = 1200;
const $183c77cc0773b3dc$export$74c1bba07084d12b = 1023;
const $183c77cc0773b3dc$export$85892fb6dad8d20d = 800;
const $183c77cc0773b3dc$export$1c4e7a9c31a6c071 = 599;
const $183c77cc0773b3dc$export$3488ed6e3b665cea = 374;
const $183c77cc0773b3dc$export$a49f1701c92af4f = 440;
let $183c77cc0773b3dc$export$507ba88fae84526c = false;
let $183c77cc0773b3dc$export$91babf9946b452e6 = false;
let $183c77cc0773b3dc$export$3e356d72a203df8 = false;
let $183c77cc0773b3dc$export$304e9ef5c0115306 = false;
let $183c77cc0773b3dc$export$8d64596ba1e90411 = false;
let $183c77cc0773b3dc$export$73e6618aa19ac9d5 = false;
let $183c77cc0773b3dc$export$26bd91a1ebe4bab5 = false;
let $183c77cc0773b3dc$export$535000180c47d75e = false;
let $183c77cc0773b3dc$export$5302e2a3cf8cbbaa = false;
let $183c77cc0773b3dc$export$6326feb87d4c7047 = false;
let $183c77cc0773b3dc$export$8eb131372814d7e3 = false;
let $183c77cc0773b3dc$export$e0fbcefc9dd1fa7 = false;
let $183c77cc0773b3dc$export$60de2f8f1539cec2 = true;
const $183c77cc0773b3dc$export$9c77cf683b3c1e05 = window.matchMedia('(min-width: ' + $183c77cc0773b3dc$export$e57b424cfcf1fb09 + 'px)');
const $183c77cc0773b3dc$export$9753f319f7585cb0 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$abb3878d4b973569 + 'px)');
const $183c77cc0773b3dc$export$f70805195fbb99f5 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$f09585a853dddd32 + 'px)');
const $183c77cc0773b3dc$export$a25adc3e4b57e050 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$3c17b0e969a90510 + 'px)');
const $183c77cc0773b3dc$export$83d079efc99ca320 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$74c1bba07084d12b + 'px)');
const $183c77cc0773b3dc$export$64334b5f702ba3ba = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$85892fb6dad8d20d + 'px)');
const $183c77cc0773b3dc$export$29bd02b533ce69bd = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$1c4e7a9c31a6c071 + 'px)');
const $183c77cc0773b3dc$export$81644d96c4abed35 = window.matchMedia('(max-width: ' + $183c77cc0773b3dc$export$3488ed6e3b665cea + 'px)');
const $183c77cc0773b3dc$export$2f3a650ac1036195 = window.matchMedia('(max-height: ' + $183c77cc0773b3dc$export$a49f1701c92af4f + 'px)');
const $183c77cc0773b3dc$export$e7766e37c74cc06c = window.matchMedia('(prefers-color-scheme: dark)');
const $183c77cc0773b3dc$export$dd32b77e25b56ab8 = window.matchMedia('(orientation: portrait)');
const $183c77cc0773b3dc$export$90d0ea046136e3ed = ()=>{
    // console.log('initVars');
    const ua = navigator.userAgent;
    // check for touch
    if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
        document.body.classList.add('body--touch');
        $183c77cc0773b3dc$export$507ba88fae84526c = true;
    }
    // check for scrollbar
    if ($183c77cc0773b3dc$var$realSize().width != window.innerWidth) {
        document.body.classList.add('body--scrollbar');
        $183c77cc0773b3dc$export$91babf9946b452e6 = true;
    }
    // check for android
    if (ua.toLowerCase().indexOf('android') > -1) {
        document.body.classList.add('body--android');
        $183c77cc0773b3dc$export$3e356d72a203df8 = true;
    }
    // check for ios
    if ([
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || ua.includes('Mac') && 'ontouchend' in document) {
        document.body.classList.add('body--ios');
        $183c77cc0773b3dc$export$304e9ef5c0115306 = true;
    }
    // check for ipad
    if (ua.indexOf('iPad') > -1) {
        document.body.classList.add('body--ipad');
        $183c77cc0773b3dc$export$8d64596ba1e90411 = true;
    }
    // check for safari
    if (ua.indexOf('Safari') != -1 && ua.indexOf('Chrome') == -1) {
        document.body.classList.add('body--safari');
        $183c77cc0773b3dc$export$73e6618aa19ac9d5 = true;
    }
    // check for firefox
    if (ua.toLowerCase().indexOf('firefox') > -1) {
        document.body.classList.add('body--firefox');
        $183c77cc0773b3dc$export$26bd91a1ebe4bab5 = true;
    }
    // check for ie
    if (window.document.documentMode) {
        document.body.classList.add('body--ie');
        $183c77cc0773b3dc$export$535000180c47d75e = true;
    }
    // check for edge
    if (ua.indexOf('Edge') > -1) {
        document.body.classList.add('body--edge');
        $183c77cc0773b3dc$export$5302e2a3cf8cbbaa = true;
    }
    // check for windows
    if (navigator.platform.indexOf('Win') > -1) {
        document.body.classList.add('body--windows');
        $183c77cc0773b3dc$export$6326feb87d4c7047 = true;
    }
    // check for chrome
    if (/Chrome/.test(ua) && /Google Inc/.test(navigator.vendor)) {
        document.body.classList.add('body--chrome');
        $183c77cc0773b3dc$export$8eb131372814d7e3 = true;
    }
    // check for blend modes
    if ('CSS' in window && 'supports' in window.CSS) {
        let support = window.CSS.supports('mix-blend-mode', 'soft-light');
        support = support ? 'body--mix-blend-mode' : 'body--no-mix-blend-mode';
        document.body.classList.add(support);
    }
    if ($183c77cc0773b3dc$export$26bd91a1ebe4bab5 && !$183c77cc0773b3dc$export$36f2bcc84865b53b || !('startViewTransition' in document)) {
        $183c77cc0773b3dc$export$60de2f8f1539cec2 = false;
        document.body.classList.add('body--no-view-transitions');
    }
    // check for retina
    const mq = window.matchMedia('only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)');
    if (mq && mq.matches || window.devicePixelRatio > 1) {
        document.body.classList.add('body--retina');
        $183c77cc0773b3dc$export$e0fbcefc9dd1fa7 = true;
    }
};
// used to get the realSize width including the scrollbar
// this is needed to get the same width as the mediaqueries in css
const $183c77cc0773b3dc$var$realSize = ()=>{
    let doc = window;
    let name = 'inner';
    if (!('innerWidth' in window)) {
        name = 'client';
        doc = document.documentElement || document.body;
    }
    return {
        width: doc[name + 'Width'],
        height: doc[name + 'Height']
    };
};


var $41264c54ad2c6427$exports = {};

$parcel$export($41264c54ad2c6427$exports, "windowWidth", () => $41264c54ad2c6427$export$c99e242bffb864af);
$parcel$export($41264c54ad2c6427$exports, "windowInnerWidth", () => $41264c54ad2c6427$export$c2f81cb82ec2bad8);
$parcel$export($41264c54ad2c6427$exports, "windowHeight", () => $41264c54ad2c6427$export$83c62512efb68338);
$parcel$export($41264c54ad2c6427$exports, "windowInnerHeight", () => $41264c54ad2c6427$export$5a628068c28e339f);
$parcel$export($41264c54ad2c6427$exports, "viewportHeight", () => $41264c54ad2c6427$export$b5aee153f48e3586);
$parcel$export($41264c54ad2c6427$exports, "fullTouch", () => $41264c54ad2c6427$export$f3ad53fe9668839f);
$parcel$export($41264c54ad2c6427$exports, "navbarHeight", () => $41264c54ad2c6427$export$95704ce82a7378af);
$parcel$export($41264c54ad2c6427$exports, "navbarPresent", () => $41264c54ad2c6427$export$a0f5451bfdace5c4);
$parcel$export($41264c54ad2c6427$exports, "navbarCurrentHeight", () => $41264c54ad2c6427$export$d9a4610da62f362e);
$parcel$export($41264c54ad2c6427$exports, "documentWidth", () => $41264c54ad2c6427$export$b3948ff9ea48227b);
$parcel$export($41264c54ad2c6427$exports, "documentHeight", () => $41264c54ad2c6427$export$47e578be7ea7065c);
$parcel$export($41264c54ad2c6427$exports, "maxBodyScrollTop", () => $41264c54ad2c6427$export$6d541604d001cc1d);
$parcel$export($41264c54ad2c6427$exports, "maxBodyScrollLeft", () => $41264c54ad2c6427$export$90901bcb70c82302);
$parcel$export($41264c54ad2c6427$exports, "blockResizeObserver", () => $41264c54ad2c6427$export$104dfeb21e8f6f17);
$parcel$export($41264c54ad2c6427$exports, "headerHeight", () => $41264c54ad2c6427$export$24f4c7f1d039d0b6);
$parcel$export($41264c54ad2c6427$exports, "afmHeight", () => $41264c54ad2c6427$export$19b14ce01af68523);
$parcel$export($41264c54ad2c6427$exports, "setBlockResizeObserver", () => $41264c54ad2c6427$export$6e2267417cad2903);
$parcel$export($41264c54ad2c6427$exports, "initResize", () => $41264c54ad2c6427$export$1a8cec7304e4a7df);
$parcel$export($41264c54ad2c6427$exports, "setResize", () => $41264c54ad2c6427$export$1871afb4a41ded14);
$parcel$export($41264c54ad2c6427$exports, "saveOffsets", () => $41264c54ad2c6427$export$11d57d7ff6599491);
// everything related to resizing, viewport, window, document, elements
// imports --------------------------------------------------------------------
// GetCoordinates v1.2
// returns element coordinates relative to the page or a scrollable container
// usage:
// import {getPageCoordinates, getRelativeCoordinates} from './GetCoordinates.js';
// const coords = getPageCoordinates(element);
// const coords = getRelativeCoordinates(element, container);
// returns:
// top, bottom, left, right
// notes:
// getPageCoordinates: converts viewport-relative values into page-relative coordinates
// that stay stable when the window scrolls
// do not use this for checking whether something is in view;
// for in-view checks, use getBoundingClientRect() directly because that is viewport-based
// sticky and fixed element coordinates change on scroll, so getPageCoordinates is not suitable for those
// getRelativeCoordinates: returns coordinates relative to a scrollable container element
// useful when animating scroll inside a non-body scroller (e.g. a popover)
// changelog:
// 1.0 initial version, extracted from resize helpers and renamed for clarity
// 1.1 remove width and height, because those are not page coordinates
// 1.2 add getRelativeCoordinates, rename module to GetCoordinates
const $e3efffc4d0edbc40$export$ccc55dee332fd8dd = (el)=>{
    const rect = el.getBoundingClientRect();
    const body = document.body;
    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;
    const top = rect.top + scrollTop - clientTop;
    const left = rect.left + scrollLeft - clientLeft;
    const bottom = top + rect.height;
    const right = left + rect.width;
    return {
        top: Math.round(top),
        bottom: Math.round(bottom),
        left: Math.round(left),
        right: Math.round(right)
    };
};
const $e3efffc4d0edbc40$export$548c45fd4a3ba736 = (el, container)=>{
    const elRect = el.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const top = elRect.top - containerRect.top + container.scrollTop;
    const left = elRect.left - containerRect.left + container.scrollLeft;
    const bottom = top + elRect.height;
    const right = left + elRect.width;
    return {
        top: Math.round(top),
        bottom: Math.round(bottom),
        left: Math.round(left),
        right: Math.round(right)
    };
};
var $e3efffc4d0edbc40$export$2e2bcd8739ae039 = $e3efffc4d0edbc40$export$ccc55dee332fd8dd;



var $56a526a578fe3239$exports = {};

$parcel$export($56a526a578fe3239$exports, "transitionDelay", () => $56a526a578fe3239$export$48c3efaeac751014);
$parcel$export($56a526a578fe3239$exports, "fader", () => $56a526a578fe3239$export$760c9eb46059594c);
$parcel$export($56a526a578fe3239$exports, "outFolder", () => $56a526a578fe3239$export$55a5c8f21be693ee);
$parcel$export($56a526a578fe3239$exports, "animator", () => $56a526a578fe3239$export$a424a0aa8f687495);
$parcel$export($56a526a578fe3239$exports, "smoothScrollInactive", () => $56a526a578fe3239$export$c60327b420936b9e);
$parcel$export($56a526a578fe3239$exports, "aim", () => $56a526a578fe3239$export$43aab11487ea38c9);
$parcel$export($56a526a578fe3239$exports, "switcher", () => $56a526a578fe3239$export$8987e38cfd004b13);
$parcel$export($56a526a578fe3239$exports, "splitter", () => $56a526a578fe3239$export$8cfde575cbd41e40);
$parcel$export($56a526a578fe3239$exports, "history", () => $56a526a578fe3239$export$55abd4691b317664);
$parcel$export($56a526a578fe3239$exports, "vtOutOfView", () => $56a526a578fe3239$export$8f2aa2ab7b76b0d5);
$parcel$export($56a526a578fe3239$exports, "horScroller", () => $56a526a578fe3239$export$510413726083552f);
$parcel$export($56a526a578fe3239$exports, "pageTypePrev", () => $56a526a578fe3239$export$bba485742287c13f);
$parcel$export($56a526a578fe3239$exports, "useHistoryNavigation", () => $56a526a578fe3239$export$9d68b6ad9acc2308);
$parcel$export($56a526a578fe3239$exports, "initOnce", () => $56a526a578fe3239$export$caa6e1ba6b757214);
$parcel$export($56a526a578fe3239$exports, "observerBlocker", () => $56a526a578fe3239$export$2f5ac5bcfd51f435);
$parcel$export($56a526a578fe3239$exports, "observerUnblocker", () => $56a526a578fe3239$export$5a0a8e9ff7c0e4a7);
// do these things only once
// even if you are using a history.js navigation
// imports --------------------------------------------------------------------
// import FixBody from '../js_vendor/FixBody.js';
// Fader V10.20.1
// used for fading in items, if needed after being loaded, based on scroll
// also copy _fader.scss
// init: fader = new Fader(); fader.init();
// usage: add fader class to items that should fade
// set fader and fader--loader class on loading element or a parent element
// every fader--loader lazyloads by default
// add fader--not-lazy on fader--loader to load it immediately
// loader can de used for a single image, video or background-image
// loader uses data-src and data-srcset instead of src(set)
// can use data-src(set)-mobile
// can use data-src-fullscreen with fader--fullscreen
// add fader--repeat to fade every time it crosses a fold
// add fader--no-top to only fade from the bottom fold, not the top
// add fader--out-of-view to fade elements that are outside the viewport (top/right/bottom/left)
// add fader--still to fade in without transform, just opacity
// add fader--no-fade for no transition, but just show the element
// add fader--clip to clip the element, instead of opacity
// add fader--clip-hor to clip the element from left to right, instead of top to bottom
// add fader--no-stagger to not stagger the fade in, can still use data-fader-delay
// add data-fader-duration="600" to set a custom fade duration in ms for that element
// fader--force is optional legacy support to force fade on in-view items during skipOnLoadInView
// required properties:
// none
// possible properties:
// fadeDur = 1200: set this to fader.scss fade speed, in ms
// stagger = 80: in ms
// maxFades = 40: max number of staggering items
// preFadeResizeDur = 0: for resizing used after knowing image size, in ms, set to image size transition duration
// afterLoadFunction = '': because now stuff has loaded and size is known call this function
// fadeScrollersSelector = '': what selectors uses scrolling except the body
// classesToRemove = []: what classes that you added should be removed from the element, for instance ['fader--grow']
// if you are looking on a horizontal mobile device. Probably set to false if using video that covers the viewport. Set to true if just using a smaller filesize
// mobileMq = '(max-width: 599px)': decides when the data-src(set)-mobile is used
// blockResizeObserver = false: block the observer from calling setFaders
// lazyFoldDiff = 1000: load images before they are visible for lazyFoldDiff pixels
// fadeOutOfView = false: fade elements regardless of viewport position
// fadeHorizontally = false: set to true to use horizontal viewport checks for fades and horizontal lazy preload using lazyFoldDiff
// addStaggerToFaderDelay = true: turn false to only use data-fader-delay instead of stagger ánd data-fader-delay (fader--no-stagger does the same)
// inViewFadeDelay = 600: set a custom delay for in-view items that are faded (outside VT context), so they fade after view transition
// listenToScroll = true: set to false to not listen to scroll for fading, use fader.fadeBlocks(document.body) manually
// getPosOnScroll = true: set to false to only measure element positions in setFaders() and derive scroll-time positions from a scroll-delta snapshot instead of getBoundingClientRect on every scroll
// methods:
// fader.init() attach listeners, observer and helper element
// fader.destroy() remove listeners, observer and helper element
// fader.setFaders() when new content is added to the page
// fader.setBlockResizeObserver(true/false) block the observer from calling setFaders
// fader.fadeBlocks(document.body) if scroll doesn't fire
// fader.fadeInHolderAgain(selector for single or element) to redo fade
// fader.fadeElementsAgain(selector for multiple or elements) to redo fade
// fader.resetLoaderElement(element) reset a loader element so it can be loaded/faded again
// fader.enableScrollListen() start listening to scroll for fading
// fader.disableScrollListen() stop listening to scroll for fading
// events on the element:
// fader:in dispatched on the element when it has faded in (after transition completes)
// Example: listen for fade-in completion
// document.querySelector('.fader').addEventListener('fader:in', (event) => {
//   console.log('Faded in:', event.target);
// });
// use .fader--loaded to remove temporary heights for images, for example:
// min-height: 0;
// transition: .2s min-height;
// &:not(.fader--loaded) {
//   min-height: 10rem;
// }
// changelog:
// 4.0 can switch between regular src and mobile src continuously
// 4.1 custom mobileWidth
// 4.1.1 fix for offscreen safari video
// 4.1.2 fix for unmuted videos not playing
// 4.2 switch media queries more nicely and only where needed
// 4.3 css support for clipping
// 4.4 fixes for changing variables
// 4.5 added resize observer
// 4.5.1 eslint
// 4.5.2 add blockResizeObserver fix, cleanup
// 4.5.3 fix resize observer
// 4.6 add no stagger option
// 4.6.2 fix for safari video, cleanup
// 4.6.2 new cover class
// 4.6.3 fix for cover video
// 4.7 new --no-fade, --still, --clip fixes, separate animation duration
// 4.7.1 fix bug with no fade for loaded elements
// 5.0 add lazyload option
// 6.0 no jquery
// 6.1 cleanup
// 6.1.1 use correct window sizes
// 6.2 two seperate fade again functions
// 6.2.1 fix for safari
// 6.2.2 fix wrong offset, add custom lazyFoldDiff
// 6.2.3 cleanup and bugfixes
// 6.2.4 cleanup of getAttribute code
// 6.3 add audio support
// 6.4 fix non-autoplay video autoplaying on ios
// 6.5 add fade below fold option (to hide fade / flash)
// 6.6 fix for faders in scrolling elements, cleanup
// 6.6.1 don't fade again if still fading
// 6.7 add fader repeat option
// 6.8 add top option to fade again
// 6.9 add option for different transition from above fold
// 6.9.1 fix for empty fadeScrollersSelector
// 6.10 add individual fade below option using fader--below-fold
// 6.11 don't fade invisible elements
// 6.12 add data-fader-delay option
// 6.13 new transform options
// 6.14 firefox animation improvements
// 6.15 fix stagger timing
// 6.16 add fader--fullscreen option, which uses data-src-fullscreen, fixes to resizing
// 6.16.1 only add load listeners to element with new src, call less fadeblocks after load
// 6.16.2 fix for loading fixed elements
// 6.17 fix for calling function after load
// 6.18 make resetLoaderElement public
// 6.19 check if src is set before loading with it
// 6.20 fix fadeOutOfView (was fadeBelowFold) with fader--loader
// 6.21 fix flicker from fader--loader
// 6.22 add retina firefox translate support
// 6.23 don't reload media when repeating fade
// 6.24 fix for weird html characters in src
// 6.25 fix for no js browsers
// 6.26 take transform into account for position
// 6.27 trim sources and fix weird characters
// 6.28 don't use LF scss/css vars
// 6.29 fix for no fade on elements that are in view on load
// 6.30 fixes for fcp/lcp
// 6.31 fix 'fade again' for in view on load elements
// 6.32 fix weird characters some more
// 6.33 fixes for skip on load in view
// 6.34 mobile check is now a media query instead of a width check + remove showMobileVideoSrcOnMobileHor
// 6.35 no stagger on test fader
// 6.36 no !important
// 6.37 add fader--force to force fade in when skipping on load in view
// 6.38 add addFaderDelayToStagger option to use data-fader-delay instead of stagger
// 6.39 fixes addFaderDelayToStagger => addStaggerToFaderDelay + fixes + maxFades to 40
// 7.0 can now fade again even when previous fade is not done, both via a function and via scroll
// 7.1 add delay on fader--force, so they fade after view transition
// 7.2 correctly check position for skipOnLoadInView
// 7.2.1 transition fixes in css
// 7.3 don't fade elements that have (parents with) visibility hidden
// 7.4 fadeInHolderAgain and fadeElementsAgain now also work with element(s) instead of selector
// 7.4.1 fix hidden elements in skipOnLoadInView
// 7.4.2 fix fader--force counting for fadersAnimating
// 8.0 take left/right fold into account for fades, no need for fader--top anymore, use fader--no-top for only fading from bottom
// 8.1 calculate hor and vert before skiponloadinview, so they are correct for that, and use hor for left/right fold calculations
// 8.2 respect fader--no-stagger for forced skipOnLoadInView delays, and only decrement fadersAnimating when it was incremented
// 8.3 add fader--clip-hor class for horizontal clip reveal (left to right)
// 8.4 do fadeblocks after 1 frame, so site specific positionings are done
// 8.5 add fadeHorizontally option so lazy loading and fades can ignore horizontal viewport checks
// 8.6 reverse lazy option: all fader--loader items lazyload, use fader--not-lazy to opt out
// 8.7 when fadeHorizontally is true, lazyload from the right edge plus lazyFoldDiff
// 8.8 split lazy fold thresholds into lazyFoldVertical and lazyFoldHorizontal
// 8.9 fade again fader--repeat elements when they become visibility: hidden, fix initializer typo
// 8.10 skipOnLoadInView is now a function, so it can be used with ajax content and view transitions
// 8.11 add listenToScroll option to skip scroll listener
// 8.12 add enableScrollListen and disableScrollListen methods
// 8.13 rename fader--below-fold to fader--out-of-view, rename fadeBelowFold to fadeOutOfView
// 9.0 BREAKING: when skipOnLoadInView runs, which is during a view-transition, in-view elements in a view-transition context skip fading; other in-view elements fade normally
// 9.0.1 cleanup
// 9.0.2 consider descendants too when checking view-transition context
// 9.0.3 rename forceDelay to inViewFadeDelay and remove forceDelay alias
// 10.0 BREAKING: move startup side effects out of the constructor into init(), add destroy(), and add setBlockResizeObserver(value)
// 10.1 remove fadeOnInit because init() now controls startup explicitly
// 10.2 normalize init/destroy internals with private fields and methods
// 10.3 init() now only attaches Fader infrastructure; page setup decides when to call doSkipOnLoadInView() and setFaders()
// 10.4 remove skipOnLoadInView option; callers now decide explicitly when page setup should prepare Fader for a view transition
// 10.5 move resetLoaderElement, fadeInHolderAgain, fadeElementsAgain out of the constructor into real class methods
// 10.6 convert all remaining constructor-local mutable state to private fields; convert all constructor-local helper functions to private class methods; setFaders, fadeBlocks, doSkipOnLoadInView become real class methods
// 10.7 add fader:in custom event on fade completion; add data-fader-duration per-element duration override
// 10.7.1 some console log options in skipOnLoadInView 
// 10.7.2 fix audio hearable on touch sometimes
// 10.8 ignore vert offset for fader--clip when ignoreVertIfClip is enabled
// 10.9 fix for switching mqMobile and reloading elements
// 10.9.1 don't remove src, because that would temporarily remove the width of the media element, which can cause a layout shift and incorrect position of other elements
// 10.10 add support for fader--mobile and fader--desktop classes. This is good, because each media can have correct width/height attributes, aspect ratio css and svg placeholder
// 10.11 make max height media take up vertical space
// 10.12 don't check visibility by default in fadeBlocks
// 10.13 don't re-add fader--loader class after load
// 10.14 add getPosOnScroll option to snapshot positions in setFaders and derive scroll-time positions from scroll deltas
// 10.15 on touch devices, skip setFaders on resize when only the height changed (address bar or keyboard)
// 10.15.1 extract window/lazy-fold dimension measurement into a shared private method, called synchronously from the resize handler so it's fresh before the resize observer's debounce runs
// 10.16 fix ReferenceError when a faded fader--repeat element became hidden (doSetFaders was unbound); re-fading an element now only preps that element instead of triggering a full setFaders() rescan
// 10.17 fixed/sticky elements (or fader elements inside one) no longer use the scroll-delta snapshot: fixed positions are measured once, sticky positions are always measured live
// 10.18 a "fixed" element inside a transformed/filtered/contained ancestor is no longer measured once, since such an ancestor becomes its containing block and its viewport position can still change with scroll; also stopped media load listeners (load/play/loadeddata) from stacking up on repeated src swaps
// 10.19 fix hidden elements fading in from fadeBlocks: visibility is now cached from setFaders and always checked (live too when checkVisibilityOnScroll is true) before fading
// 10.20 simplify getPositionMode: don't check ancestors for a new containing block, just element's own sticky/fixed position
// 10.20.1 fix getPositionMode wrongly freezing faders inside a position:fixed fadeScrollersSelector container (e.g. a fixed .popover): the ancestor walk now stops at the element's own scrollEl, since that scrollEl's own fixed/sticky position doesn't affect how its children move on its internal scroll
class $0b34a3644a6f4c48$export$2e2bcd8739ae039 {
    #initialized;
    #resizeObserver;
    #faderEl;
    #fadeBlocksTimeout;
    #boundFadeTimeout;
    #boundFadeSelector;
    #boundScroll;
    #boundObserverHandler;
    #boundResize;
    #fadersAnimating;
    #mqMobile;
    #prevMqMobileMatches;
    #isTouch;
    #fastLoadDuration;
    #windowWidth;
    #windowHeight;
    #prevObserverWidth;
    #prevObserverHeight;
    #innerHeight;
    #lazyFoldVertical;
    #lazyFoldHorizontal;
    #vert;
    #hor;
    #fadeBlocksCallCount;
    #fadeBlocksTotalMs;
    #positionSnapshots;
    #visibilityCache;
    #loadListeners;
    #playListeners;
    #loadedDataListeners;
    constructor({ fadeDur: fadeDur = 1200, stagger: stagger = 80, maxFades: maxFades = 40, preFadeResizeDur: preFadeResizeDur = 0, afterLoadFunction: afterLoadFunction = '', fadeScrollersSelector: fadeScrollersSelector = '', classesToRemove: classesToRemove = [], mobileMq: mobileMq = '(max-width: 599px)', blockResizeObserver: blockResizeObserver = false, lazyFoldDiff: lazyFoldDiff = 1000, fadeOutOfView: fadeOutOfView = false, inViewFadeDelay: inViewFadeDelay = 600, fadeHorizontally: fadeHorizontally = false, ignoreVertIfClip: ignoreVertIfClip = true, addStaggerToFaderDelay: addStaggerToFaderDelay = true, listenToScroll: listenToScroll = true, checkVisibilityOnScroll: checkVisibilityOnScroll = false, getPosOnScroll: getPosOnScroll = false } = ''){
        // console.log('Fader');
        // user variables ------------------------------------------------------------
        // can be changed based on a media query for instance and read
        this.fadeDur = fadeDur;
        this.stagger = stagger;
        this.maxFades = maxFades;
        this.preFadeResizeDur = preFadeResizeDur;
        this.afterLoadFunction = afterLoadFunction;
        this.fadeScrollersSelector = fadeScrollersSelector;
        this.classesToRemove = classesToRemove;
        this.blockResizeObserver = blockResizeObserver;
        this.lazyFoldDiff = lazyFoldDiff;
        this.fadeOutOfView = fadeOutOfView;
        this.inViewFadeDelay = inViewFadeDelay;
        this.fadeHorizontally = fadeHorizontally;
        this.ignoreVertIfClip = ignoreVertIfClip;
        this.addStaggerToFaderDelay = addStaggerToFaderDelay;
        this.listenToScroll = listenToScroll;
        this.checkVisibilityOnScroll = checkVisibilityOnScroll;
        this.getPosOnScroll = getPosOnScroll;
        this.#initialized = false;
        this.#resizeObserver = undefined;
        this.#faderEl = document.createElement('div');
        this.#fadeBlocksTimeout = undefined;
        this.#boundFadeTimeout = undefined;
        this.#boundFadeSelector = undefined;
        this.#boundScroll = undefined;
        this.#boundObserverHandler = undefined;
        this.#boundResize = undefined;
        // scope variables -----------------------------------------------------------
        this.#fadersAnimating = 0;
        this.#mqMobile = window.matchMedia(mobileMq);
        this.#prevMqMobileMatches = this.#mqMobile.matches;
        this.#isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
        const ua = navigator.userAgent;
        if (ua.toLowerCase().indexOf('firefox') > -1) document.body.classList.add('body--firefox');
        const mq = window.matchMedia('only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)');
        if (mq && mq.matches || window.devicePixelRatio > 1) document.body.classList.add('body--retina');
        this.#windowWidth = 0;
        this.#windowHeight = 0;
        this.#prevObserverWidth = 0;
        this.#prevObserverHeight = 0;
        this.#innerHeight = window.innerHeight; // must use innerHeight because of ios: is actual height of screen
        this.#lazyFoldVertical = this.#innerHeight + this.lazyFoldDiff; // load images before they are visible
        this.#lazyFoldHorizontal = window.innerWidth + this.lazyFoldDiff; // preload images before they enter from the right
        this.#fastLoadDuration = 100;
        this.#vert = 0;
        this.#hor = 0;
        this.#fadeBlocksCallCount = 0;
        this.#fadeBlocksTotalMs = 0;
        this.#positionSnapshots = new WeakMap(); // per-element position + scroll offset, used when getPosOnScroll is false
        this.#visibilityCache = new WeakMap(); // per-element hidden state, set in setFaders/#checkVisibility, reused by fadeBlocks when checkVisibilityOnScroll is false
        this.#loadListeners = new WeakMap(); // current 'load' handler per element, so it can be removed before a new one is added
        this.#playListeners = new WeakMap(); // current 'play' handler per element
        this.#loadedDataListeners = new WeakMap(); // current 'loadeddata' handler per element
        // bound handlers ------------------------------------------------------------
        this.#boundFadeTimeout = ()=>{
            // console.log('fadeTimeout');
            // resize after certain amount of time, when elements have resized
            // by default this is 100ms
            clearTimeout(this.#fadeBlocksTimeout);
            this.#fadeBlocksTimeout = setTimeout(()=>{
                // console.log('fadeTimeout fadeBlocks');
                this.fadeBlocks(document.body);
                if (this.fadeScrollersSelector !== '') {
                    const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
                    fadeScrollers.forEach((element)=>{
                        this.fadeBlocks(element);
                    });
                }
                // call after load function
                if (this.afterLoadFunction) this.afterLoadFunction();
            }, this.preFadeResizeDur);
        };
        this.#boundFadeSelector = (event)=>{
            // after possible site specific scroll calculations
            requestAnimationFrame(()=>{
                this.fadeBlocks(event.target);
            });
        };
        this.#boundScroll = (event)=>{
            // console.log('fader scrollHandler');
            // after possible site specific scroll calculations
            requestAnimationFrame(()=>{
                this.fadeBlocks(event.target);
            });
        };
        this.#boundObserverHandler = ()=>{
            // after possible site specific resize calculations
            if (!this.blockResizeObserver) setTimeout(()=>this.#observerResize(), 100);
        };
        this.#boundResize = ()=>{
            const prevWidth = this.#windowWidth;
            // keep these fresh immediately on resize, instead of waiting for the debounced setFaders
            this.#measureWindowDimensions();
            // on touch, skip resizes that are just the address bar or keyboard toggling (width unchanged)
            if (this.#isTouch && this.#windowWidth === prevWidth) return;
            // after possible site specific resize calculations
            setTimeout(()=>this.setFaders(), 100);
        };
    }
    // -------------------------------------------------------------------------
    // Private helpers
    // -------------------------------------------------------------------------
    #measureWindowDimensions() {
        this.#windowWidth = document.documentElement.clientWidth;
        this.#windowHeight = document.documentElement.clientHeight;
        this.#innerHeight = window.innerHeight;
        this.#lazyFoldVertical = this.#innerHeight + this.lazyFoldDiff;
        this.#lazyFoldHorizontal = this.#windowWidth + this.lazyFoldDiff;
    // console.log('measureWindowDimensions', {windowWidth: this.#windowWidth, windowHeight: this.#windowHeight, innerHeight: this.#innerHeight, lazyFoldVertical: this.#lazyFoldVertical, lazyFoldHorizontal: this.#lazyFoldHorizontal});
    }
    #setHorAndVert() {
        this.#measureWindowDimensions();
        this.#faderEl.setAttribute('class', '');
        // calculate --vert and --hor
        const startTop = this.#faderEl.getBoundingClientRect().top;
        this.#faderEl.classList.add('fader', 'fader--no-stagger');
        const endTop = this.#faderEl.getBoundingClientRect().top;
        this.#vert = startTop - endTop;
        const startLeft = this.#faderEl.getBoundingClientRect().left;
        this.#faderEl.classList.add('fader--left');
        const endLeft = this.#faderEl.getBoundingClientRect().left;
        this.#hor = startLeft - endLeft;
    // console.log({vert: this.#vert, hor: this.#hor});
    }
    #observerResize() {
        // console.log('observerResize', this.blockResizeObserver, {windowWidth: this.#windowWidth}, {prevObserverWidth: this.#prevObserverWidth}, {windowHeight: this.#windowHeight}, {prevObserverHeight: this.#prevObserverHeight});
        // observed a resize but browser did not resize, this means content changed, so call setResize
        if (this.#windowWidth == this.#prevObserverWidth && this.#windowHeight == this.#prevObserverHeight && this.#prevObserverWidth != 0 && this.#prevObserverHeight != 0) {
            if (!this.blockResizeObserver) this.setFaders();
        }
        this.#prevObserverWidth = this.#windowWidth;
        this.#prevObserverHeight = this.#windowHeight;
    }
    #getLoadElement(element) {
        // console.log('getLoadElement', {element});
        let loadableElement;
        if (element.tagName === 'IMG' || element.tagName === 'VIDEO' || element.tagName === 'AUDIO' || getComputedStyle(element).backgroundImage !== 'none') loadableElement = element;
        else {
            const selector = 'img[data-src], video[data-src], audio[data-src], *[style*="background-image:"]';
            const loadableElements = element.querySelectorAll(selector);
            loadableElements.forEach((el)=>{
                if (el.classList.contains('fader--mobile') && this.#mqMobile.matches) loadableElement = el;
                else if (el.classList.contains('fader--desktop') && !this.#mqMobile.matches) loadableElement = el;
            });
            // nothing yet? take the first one, if any
            if (!loadableElement && loadableElements.length > 0) loadableElement = loadableElements[0];
        }
        return loadableElement;
    }
    #loadElement(element) {
        // console.log('loadElement', {element});
        let loadEl = this.#getLoadElement(element);
        if (!loadEl) {
            // console.log('nothing to load, remove loader, just fade');
            element.classList.remove('fader--loader');
            return;
        }
        // if invisible and not audio, don't fade
        const position = window.getComputedStyle(element).getPropertyValue('position');
        if (element.offsetParent === null && position !== 'fixed' && element.tagName !== 'AUDIO' && loadEl.tagName !== 'AUDIO') return;
        // console.log('loadElement 2', {element}, {loadEl});
        const src = loadEl.dataset.src;
        const srcMobile = loadEl.dataset.srcMobile;
        if (loadEl.tagName === 'IMG') {
            // images ----------------------------
            const srcset = loadEl.dataset.srcset;
            const srcsetMobile = loadEl.dataset.srcsetMobile;
            if (srcMobile && this.#mqMobile.matches) this.#addImgLoadCheck(element, loadEl, srcMobile, srcsetMobile);
            else if (src) // not mobile
            this.#addImgLoadCheck(element, loadEl, src, srcset);
        } else if (loadEl.tagName === 'VIDEO' || loadEl.tagName === 'AUDIO') {
            // video and audio ----------------------------
            const srcFullscreen = loadEl.dataset.srcFullscreen;
            const isFullscreen = element.classList.contains('fader--fullscreen');
            if (srcMobile && this.#mqMobile.matches) // mobile
            this.#addVideoAudioLoadCheck(element, loadEl, srcMobile);
            else if (srcFullscreen && isFullscreen) // fullscreen
            this.#addVideoAudioLoadCheck(element, loadEl, srcFullscreen);
            else if (src) // not mobile or fullscreen
            this.#addVideoAudioLoadCheck(element, loadEl, src);
        } else {
            // background images ----------------------------
            const bgImg = getComputedStyle(element).backgroundImage;
            const imgUrl = bgImg.slice(4, -1).replace(/"/g, '');
            const img = new Image();
            img.addEventListener('load', ()=>{
                img.remove();
                element.style.backgroundImage = `url(${imgUrl}) !important`;
                this.#fadedAfterLoad(element);
            }, {
                once: true
            });
            img.src = imgUrl;
        }
    }
    #addImgLoadCheck(element, loadEl, src, srcset) {
        // console.log('addImgLoadCheck', {element}, {loadEl});
        // remove leading and ending spaces, and decode the url
        src = src.trim();
        src = decodeURIComponent(src);
        if (src == decodeURIComponent(loadEl.src)) return;
        // console.log('src is different, load it');
        this.resetLoaderElement(element, false);
        // uncomment this to see the img before the new src is added!
        // return;
        this.#setOnceListener(this.#loadListeners, loadEl, 'load', ()=>{
            this.#fadedAfterLoad(element);
        });
        element.classList.add('fader--loading');
        loadEl.src = src;
        if (srcset) {
            // remove leading and ending spaces, and decode the url
            srcset = srcset.trim();
            srcset = decodeURIComponent(srcset);
            loadEl.srcset = srcset;
        }
    }
    #addVideoAudioLoadCheck(element, loadEl, src) {
        // console.log('addVideoAudioLoadCheck', {element}, {loadEl});
        // remove leading and ending spaces, and decode the url
        src = src.trim();
        src = decodeURIComponent(src);
        if (src == loadEl.src) return;
        // all video's play to load
        // couldn't do from loadeddata event, because play sometimes starts after that and pause wouldn't work
        this.#setOnceListener(this.#playListeners, loadEl, 'play', ()=>{
            requestAnimationFrame(()=>{
                // in new frame because pause would sometimes not work on touch
                // console.log('playing', event, loadEl.dataset.mayplay);
                if (this.#isTouch && loadEl.dataset.autoplay === 'false' && loadEl.dataset.mayplay !== 'true') {
                    loadEl.autoplay = false;
                    loadEl.pause();
                    loadEl.currentTime = 0;
                    // only do this once, from initial play event used to load video
                    loadEl.dataset.mayplay = 'true';
                }
                if (loadEl.dataset.muted === 'false') loadEl.muted = false;
            });
        });
        this.#setOnceListener(this.#loadedDataListeners, loadEl, 'loadeddata', ()=>{
            this.#fadedAfterLoad(element);
        });
        const autoplay = loadEl.dataset.autoplay;
        if (this.#isTouch && !autoplay) {
            if (loadEl.muted === false) {
                loadEl.setAttribute('data-muted', 'false');
                loadEl.muted = true;
            } else loadEl.setAttribute('data-muted', 'true');
            if (loadEl.autoplay === false) {
                loadEl.setAttribute('data-autoplay', 'false');
                loadEl.autoplay = true;
            } else loadEl.setAttribute('data-autoplay', 'true');
        }
        this.resetLoaderElement(element);
        loadEl.src = src;
    }
    #fadedAfterLoad(element) {
        // console.log('fadedAfterLoad', {element});
        // you need all 3 to stop calling loadElement
        element.classList.remove('fader--loading');
        element.classList.remove('fader--loader');
        element.classList.add('fader--loaded');
        // once loaded, remove classes related to loading from dataset, so they don't get added again
        const dataClass = (element.dataset.class ?? '').split(/\s+/).filter(Boolean);
        const cleanedDataClass = dataClass.filter((className)=>![
                'fader--loader',
                'fader--loading'
            ].includes(className));
        if (!cleanedDataClass.includes('fader--loaded')) cleanedDataClass.push('fader--loaded');
        element.dataset.class = cleanedDataClass.join(' ').trim();
        this.#boundFadeTimeout();
        const customDuration = element.dataset.faderDuration ? parseInt(element.dataset.faderDuration, 10) : null;
        const duration = element.classList.contains('fader--fast-load') ? this.#fastLoadDuration : customDuration ?? this.fadeDur;
        setTimeout(()=>{
            element.dataset.fadeFromLoad = 'true';
            this.#tryRemoveFaderProperties(element);
        }, parseInt(element.dataset.delay, 10) + duration + this.preFadeResizeDur);
    }
    #getPos(element) {
        // calculate positions without transform
        const rect = element.getBoundingClientRect();
        let { top: top, bottom: bottom, left: left, right: right } = rect;
        if (element.classList.contains('fader')) {
            if (element.classList.contains('fader--up')) {
                // is transformed 100%, so add element height
                top -= rect.height;
                bottom += rect.height;
            } else if (element.classList.contains('fader--left')) {
                // is transformed left, so add hor to get natural position
                left += this.#hor;
                right += this.#hor;
            } else if (element.classList.contains('fader--right')) {
                // is transformed right, so subtract hor to get natural position
                left -= this.#hor;
                right -= this.#hor;
            } else if (!(this.ignoreVertIfClip && element.classList.contains('fader--clip'))) {
                // is transformed, so add vert
                top += this.#vert;
                bottom -= this.#vert;
            }
        }
        // console.log('getPos', {top}, {bottom}, {left}, {right}, {innerHeight: this.#innerHeight});
        return {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    }
    #getScrollElementFor(element) {
        if (this.fadeScrollersSelector !== '') {
            const scroller = element.closest(this.fadeScrollersSelector);
            if (scroller) return scroller;
        }
        return document.body;
    }
    #getScrollOffset(scrollEl) {
        if (scrollEl === document.body) return {
            scrollTop: window.scrollY,
            scrollLeft: window.scrollX
        };
        return {
            scrollTop: scrollEl.scrollTop,
            scrollLeft: scrollEl.scrollLeft
        };
    }
    // replace the previous handler for this element/event (if any), so reloading media (e.g. mobile/desktop src swaps) doesn't stack up duplicate listeners
    #setOnceListener(map, el, eventName, handler) {
        const previous = map.get(el);
        if (previous) el.removeEventListener(eventName, previous);
        el.addEventListener(eventName, handler);
        map.set(el, handler);
    }
    #getPositionMode(element, scrollEl) {
        // sticky/fixed elements (or fader elements inside one) don't move with their scrollEl's scroll the way a scroll-delta snapshot assumes
        // stop at scrollEl: its own fixed/sticky position (e.g. a fixed .popover) is irrelevant to how its children move when scrollEl itself is scrolled
        let el = element;
        let isFixed = false;
        let isSticky = false;
        while(el && el !== scrollEl && el !== document.documentElement){
            const position = window.getComputedStyle(el).getPropertyValue('position');
            if (position === 'sticky') isSticky = true;
            else if (position === 'fixed') isFixed = true;
            el = el.parentElement;
        }
        if (isSticky) return 'sticky'; // must always measure live
        if (isFixed) return 'fixed'; // truly viewport-fixed, measuring once is enough
        return 'normal';
    }
    #snapshotPos(element) {
        // remember position plus the scroll offset (per scrollable element) it was measured at
        const pos = this.#getPos(element);
        const scrollEl = this.#getScrollElementFor(element);
        const { scrollTop: scrollTop, scrollLeft: scrollLeft } = this.#getScrollOffset(scrollEl);
        const mode = this.#getPositionMode(element, scrollEl);
        this.#positionSnapshots.set(element, {
            ...pos,
            scrollEl: scrollEl,
            scrollTop: scrollTop,
            scrollLeft: scrollLeft,
            mode: mode
        });
        return pos;
    }
    #getPosFromSnapshot(element, offsetCache) {
        const snapshot = this.#positionSnapshots.get(element);
        if (!snapshot) return this.#snapshotPos(element); // no snapshot yet, take one now
        if (snapshot.mode === 'sticky') return this.#getPos(element); // sticky position isn't a scroll delta, always measure live
        if (snapshot.mode === 'fixed') return {
            top: snapshot.top,
            bottom: snapshot.bottom,
            left: snapshot.left,
            right: snapshot.right
        }; // fixed position never changes, reuse the snapshot taken once
        // reuse the scroll offset per scrollEl, so it's only read once per fadeBlocks call, not once per element
        let offset = offsetCache.get(snapshot.scrollEl);
        if (!offset) {
            offset = this.#getScrollOffset(snapshot.scrollEl);
            offsetCache.set(snapshot.scrollEl, offset);
        }
        const deltaTop = offset.scrollTop - snapshot.scrollTop;
        const deltaLeft = offset.scrollLeft - snapshot.scrollLeft;
        return {
            top: snapshot.top - deltaTop,
            bottom: snapshot.bottom - deltaTop,
            left: snapshot.left - deltaLeft,
            right: snapshot.right - deltaLeft
        };
    }
    #isVisibilityHidden(el) {
        while(el){
            if (window.getComputedStyle(el).visibility === 'hidden') return true;
            el = el.parentElement;
        }
        return false;
    }
    #hasOwnViewTransitionContext(el) {
        const styles = window.getComputedStyle(el);
        const transitionName = styles.getPropertyValue('view-transition-name').trim();
        const transitionClass = styles.getPropertyValue('view-transition-class').trim();
        const hasTransitionName = transitionName !== '' && transitionName !== 'none';
        const hasTransitionClass = transitionClass !== '' && transitionClass !== 'none' && transitionClass !== 'normal';
        return hasTransitionName || hasTransitionClass;
    }
    #hasViewTransitionContextTree(el) {
        // Ignore root-level UA context (e.g. html { view-transition-name: root }).
        let currentEl = el;
        while(currentEl && currentEl !== document.body && currentEl !== document.documentElement){
            if (this.#hasOwnViewTransitionContext(currentEl)) return true;
            currentEl = currentEl.parentElement;
        }
        const descendants = el.querySelectorAll('*');
        for(let i = 0; i < descendants.length; i++){
            if (this.#hasOwnViewTransitionContext(descendants[i])) return true;
        }
        return false;
    }
    #tryRemoveFaderProperties(element, force = false) {
        // console.log('tryRemoveFaderProperties', 'loaded: ' + element.dataset.fadeFromLoad, 'scrolled: ' + element.dataset.fadeFromScroll, element.classList[0], {force});
        // if faded from scroll and loaded
        // if faded from scroll and not loading
        // if faded from load and scrolling isn't relevant
        if (element.dataset.fadeFromScroll && element.dataset.fadeFromLoad || element.dataset.fadeFromScroll && !element.classList.contains('fader--loader') && !element.classList.contains('fader--loading') && !element.classList.contains('fader--loaded') || element.dataset.fadeFromLoad && element.classList.contains('fader--no-scroll') || force) {
            // console.log('remove fader properties', element.classList[0]);
            const defaultClassesToRemove = [
                'fader',
                'fader3',
                'fader--no-scroll',
                'fader--still',
                'fader--no-fade',
                'fader--clip',
                'fader--clip-hor',
                'fader--no-stagger',
                'fader--left',
                'fader--right',
                'fader--bl',
                'fader--br',
                'fader--shrink',
                'fader--top-start',
                'fader--up',
                'fader--fast-load',
                'fader--no-top'
            ];
            for(let i = 0; i < defaultClassesToRemove.length; i++)element.classList.remove(defaultClassesToRemove[i]);
            for(let i = 0; i < this.classesToRemove.length; i++)element.classList.remove(this.classesToRemove[i]);
            if (element.dataset.inViewFadeDelayApplied) {
                element.dataset.inViewFadeDelayApplied = '';
                // remove previously added delay for in-view delayed items
                let resetDelay = parseInt(element.dataset.faderDelay, 10) - this.inViewFadeDelay;
                if (resetDelay < 1) resetDelay = '';
                element.dataset.faderDelay = resetDelay;
            }
            element.dataset.delay = '';
            // leave fader--loaded and fader2 class because they're used elsewhere
            element.style.transitionDelay = '';
            element.style.removeProperty('--fader-duration');
        }
    }
    #fadeAgain(element) {
        // console.log('fadeAgain', element.classList[0]);
        this.#tryRemoveFaderProperties(element, true); // true = force remove fader properties
        element.dataset.faded = '';
        element.dataset.fadeFromScroll = '';
        // element.dataset.fadeFromLoad = ''; // don't reset fade from load, because it might be loaded
        element.setAttribute('class', element.dataset.class ?? ''); // reset class attr
    }
    // prep a single element to be fadeable again, without rescanning every .fader element like setFaders() does
    #prepareFaderElement(element) {
        if (!this.getPosOnScroll) this.#snapshotPos(element);
        let hasFastLoad = false;
        if (element.classList.contains('fader--fast-load')) {
            hasFastLoad = true;
            // don't add fast-load class to data-class
            // because its should only be used on page load
            element.classList.remove('fader--fast-load');
        }
        if (!element.dataset.class) element.dataset.class = element.getAttribute('class');
        if (hasFastLoad) element.classList.add('fader--fast-load');
        element.classList.add('fader2');
        if (element.dataset.faderDuration) element.style.setProperty('--fader-duration', parseInt(element.dataset.faderDuration, 10) + 'ms');
        // if above fold, add top transform (unless fader--no-top)
        if (!element.classList.contains('fader--no-top')) {
            const rect = element.getBoundingClientRect();
            if (rect.bottom < rect.height) element.classList.add('fader--top-start'); // not < 0, because a little wiggle room
        }
    }
    #refadeElement(element) {
        // console.log('refadeElement', element.classList[0]);
        this.#fadeAgain(element);
        this.#prepareFaderElement(element);
    }
    // determines and caches whether element is hidden; also refades a hidden fader--repeat element that had already faded
    #checkVisibility(element) {
        const position = window.getComputedStyle(element).getPropertyValue('position');
        const isHidden = element.offsetParent === null && position !== 'fixed' || this.#isVisibilityHidden(element);
        this.#visibilityCache.set(element, isHidden);
        let didRefade = false;
        if (isHidden && element.classList.contains('fader--repeat') && element.dataset.faded) {
            const random = Math.random().toString(36).substring(2, 15);
            element.dataset.initializer = random;
            this.#refadeElement(element);
            didRefade = true;
        }
        return {
            isHidden: isHidden,
            didRefade: didRefade
        };
    }
    // -------------------------------------------------------------------------
    // Public methods
    // -------------------------------------------------------------------------
    // when new fader content is added, call this
    setFaders = ()=>{
        // console.trace('setFaders');
        this.#setHorAndVert();
        if (this.fadeScrollersSelector !== '') {
            const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
            fadeScrollers.forEach((element)=>{
                element.removeEventListener('scroll', this.#boundFadeSelector);
                element.addEventListener('scroll', this.#boundFadeSelector);
            });
        }
        const faderElements = document.querySelectorAll('.fader');
        faderElements.forEach((element)=>{
            this.#checkVisibility(element);
            this.#prepareFaderElement(element);
        });
        const loaderElements = document.querySelectorAll('.fader--loaded.fader--not-lazy, .fader--loader.fader--not-lazy');
        loaderElements.forEach((element)=>{
            // console.log('loadElement not lazy', {element});
            this.#loadElement(element);
        });
        if (this.#prevMqMobileMatches !== this.#mqMobile.matches) {
            // console.log('mobile mode changed, reload elements');
            const loadedOrLoadingElements = document.querySelectorAll('.fader--loaded, .fader--loading');
            loadedOrLoadingElements.forEach((element)=>{
                this.#loadElement(element);
            });
        }
        this.#prevMqMobileMatches = this.#mqMobile.matches;
        this.#boundFadeTimeout();
    };
    fadeBlocks = (scrollEl)=>{
        const startTime = performance.now();
        this.#fadeBlocksCallCount++;
        // console.log('fadeBlocks', {scrollEl, vert: this.#vert, innerHeight: this.#innerHeight});
        let needsRecheck = false;
        const scrollOffsetCache = new Map(); // scrollEl -> {scrollTop, scrollLeft}, read once per scrollEl for this call
        // fade in the blocks when scrolling
        const faderElements = scrollEl.querySelectorAll('.fader2');
        faderElements.forEach((element, index)=>{
            // console.log(element.classList[0]);
            if (!element.classList.contains('fader') && !element.classList.contains('fader--repeat')) return;
            // checkVisibilityOnScroll: recheck visibility live; otherwise reuse the value cached during setFaders
            let isHidden;
            if (this.checkVisibilityOnScroll) {
                const result = this.#checkVisibility(element);
                isHidden = result.isHidden;
                if (result.didRefade) needsRecheck = true;
            } else isHidden = this.#visibilityCache.get(element) ?? false;
            if (isHidden) return;
            const pos = this.getPosOnScroll ? this.#getPos(element) : this.#getPosFromSnapshot(element, scrollOffsetCache);
            const inLazyLoadHorizontalView = !this.fadeHorizontally || pos.left < this.#lazyFoldHorizontal;
            // lazy load loader elements before they are visible (unless explicitly non-lazy)
            if (element.classList.contains('fader--loader') && !element.classList.contains('fader--not-lazy') && (pos.top < this.#lazyFoldVertical && inLazyLoadHorizontalView || this.fadeOutOfView)) // console.log('lazy load', {index, 'top': pos.top});
            this.#loadElement(element);
            // console.log(element.classList[0], {pos}, 'faded: ' + element.dataset.faded);
            const inViewVertical = pos.top < this.#innerHeight && (pos.bottom > 0 || element.classList.contains('fader--no-top')); // from top and bottom, unless fader--no-top
            const inViewHorizontal = !this.fadeHorizontally || pos.left < this.#windowWidth && pos.right > 0;
            // console.log({inViewVertical, inViewHorizontal});
            if (inViewVertical && inViewHorizontal || this.fadeOutOfView || element.classList.contains('fader--out-of-view')) {
                if (element.dataset.faded) return;
                // console.log('fade from scroll prev');
                // only do this once
                element.dataset.faded = 'true';
                // console.log(element.classList[0], this.#fadersAnimating);
                if (element.classList.contains('fader--no-fade')) {
                    // non-fading element
                    element.classList.add('fader3'); // visible
                    element.dataset.fadeFromScroll = 'true';
                    this.#tryRemoveFaderProperties(element);
                    element.dispatchEvent(new CustomEvent('fader:in', {
                        bubbles: true
                    }));
                } else {
                    // console.log('fade element: ', element.classList[0]);
                    // fading element
                    // add a delayed animation for the animating blocks
                    let extraDelay;
                    let delay;
                    let didIncrementFadersAnimating = false;
                    if (element.classList.contains('fader--fast-load')) {
                        extraDelay = 0;
                        delay = 0;
                    } else {
                        extraDelay = element.dataset.faderDelay ? parseInt(element.dataset.faderDelay, 10) : '';
                        // console.log({extraDelay});
                        if (this.addStaggerToFaderDelay || extraDelay === '') {
                            if (extraDelay == '') extraDelay = 0;
                            // add data-fader-delay to stagger
                            delay = this.stagger * this.#fadersAnimating + this.preFadeResizeDur + extraDelay;
                            // console.log(element.classList[0], {fadersAnimating: this.#fadersAnimating, extraDelay, delay});
                            // remember total fading blocks, to get them to not animate at the same time
                            if (!element.classList.contains('fader--no-stagger') && !element.classList.contains('fader--fast-load')) {
                                this.#fadersAnimating++;
                                didIncrementFadersAnimating = true;
                            }
                        } else // use only data-fader-delay
                        // doesn't update fadersAnimating, because the delay duration might not align with the default stagger
                        delay = extraDelay;
                    }
                    // console.log(element.classList[0], {delay});
                    element.style.transitionDelay = delay + 'ms';
                    element.dataset.delay = delay; // remember delay for loading media
                    element.classList.add('fader3'); // fade in
                    // maxFades so you don't have to wait too long when scrolling down fast
                    if (this.#fadersAnimating > this.maxFades) this.#fadersAnimating = this.maxFades;
                    // remove stagger
                    setTimeout(()=>{
                        // console.log('start ani');
                        if (didIncrementFadersAnimating) {
                            this.#fadersAnimating--;
                            if (this.#fadersAnimating < 0) this.#fadersAnimating = 0;
                        }
                    }, delay);
                    const customDuration = element.dataset.faderDuration ? parseInt(element.dataset.faderDuration, 10) : null;
                    const duration = element.classList.contains('fader--fast-load') ? this.#fastLoadDuration : customDuration ?? this.fadeDur;
                    // console.log('fade from scroll', element.classList[0], {duration}, {delay}, {fadersAnimating: this.#fadersAnimating});
                    // console.log({duration, delay});
                    // to prevent multiple setTimeout calls
                    // this can happen when fadeAgain is called
                    const random = Math.random().toString(36).substring(2, 15);
                    element.dataset.initializer = random;
                    // after fading in
                    setTimeout(()=>{
                        // if these are not the same, it means the element was faded again
                        // console.log(random, element.dataset.initializer);
                        if (random !== element.dataset.initializer) return;
                        element.dataset.fadeFromScroll = 'true';
                        this.#tryRemoveFaderProperties(element);
                        element.dispatchEvent(new CustomEvent('fader:in', {
                            bubbles: true
                        }));
                    }, duration + delay);
                }
            } else if (element.classList.contains('fader--repeat') && element.dataset.faded) {
                // check faded so it's only reset after having faded
                // this is a faded repeat element below bottom, or above top fold
                // console.log('above or below fold, fade again', index);
                // set new random, so code in timeout is not executed after going out of view
                const random = Math.random().toString(36).substring(2, 15);
                element.dataset.initializer = random;
                this.#refadeElement(element); // re-adds fader2, ready to fade in again on the next pass
                needsRecheck = true;
            }
        });
        this.#fadeBlocksTotalMs += performance.now() - startTime;
        this.#fadeBlocksCallCount > 0 && this.#fadeBlocksCallCount;
        // re-faded elements only need a fadeBlocks recheck, not the full setFaders() document rescan
        if (needsRecheck) this.#boundFadeTimeout();
    };
    // remove fade from elements in view on load that are visible and forced or in a vt context
    doSkipOnLoadInView = (doSetFaders = true)=>{
        const faderEls = document.querySelectorAll('.fader');
        // console.log('doSkipOnLoadInView', {doSetFaders});
        let forceTotal = 0;
        faderEls.forEach((faderEl, index)=>{
            // skip hidden items
            // if invisible, don't fade
            const position = window.getComputedStyle(faderEl).getPropertyValue('position');
            if (faderEl.offsetParent === null && position !== 'fixed') return;
            // console.log(index,this.#isVisibilityHidden(faderEl));
            if (this.#isVisibilityHidden(faderEl)) return;
            const pos = this.#getPos(faderEl);
            const inViewVertical = pos.top < this.#innerHeight && pos.bottom > 0;
            const inViewHorizontal = !this.fadeHorizontally || pos.left < this.#windowWidth && pos.right > 0;
            if (inViewVertical && inViewHorizontal) {
                // faderEl is in view
                const isInViewTransitionContext = this.#hasViewTransitionContextTree(faderEl);
                const shouldFadeInView = faderEl.classList.contains('fader--force') || !isInViewTransitionContext;
                if (shouldFadeInView) {
                    // add delay for in-view items that fade (so they fade after view transition)
                    let delay = this.inViewFadeDelay;
                    const shouldStagger = !faderEl.classList.contains('fader--no-stagger');
                    // get original data-fader-delay
                    if (faderEl.dataset.faderDelay) {
                        // console.log(faderEl.classList[0], 'hasFaderDelay');
                        delay += parseInt(faderEl.dataset.faderDelay, 10);
                        if (this.addStaggerToFaderDelay && shouldStagger) {
                            delay += forceTotal * this.stagger;
                            forceTotal++;
                        }
                    } else // no data-fader-delay, so add stagger based on current in-view delayed item
                    if (shouldStagger) {
                        delay += forceTotal * this.stagger;
                        forceTotal++;
                    }
                    // console.log(faderEl.className, 'in-view fade after', delay);
                    faderEl.dataset.faderDelay = delay;
                    faderEl.dataset.inViewFadeDelayApplied = 'true';
                } else if (faderEl.classList.contains('fader--loader')) // faderEl needs loading, so still do fade but faster
                faderEl.classList.add('fader--fast-load');
                else {
                    // faderEl doesn't need loading, so skip fade
                    if (!faderEl.dataset.class) faderEl.dataset.class = faderEl.getAttribute('class');
                    // console.log(faderEl.className, 'skip fade');
                    faderEl.classList.add('fader2');
                    faderEl.dataset.faded = 'true';
                    faderEl.dataset.fadeFromScroll = 'true';
                    this.#tryRemoveFaderProperties(faderEl);
                }
            }
        });
        if (doSetFaders) this.setFaders();
    };
    setBlockResizeObserver = (value)=>{
        this.blockResizeObserver = value;
    };
    resetLoaderElement = (element, removeSrc = true)=>{
        // console.log('resetLoaderElement', {element});
        this.#tryRemoveFaderProperties(element);
        element.classList.remove('fader--loaded');
        element.classList.remove('fader--loading');
        element.classList.add('fader');
        element.classList.add('fader--loader');
        element.dataset.fadeFromScroll = '';
        element.dataset.fadeFromLoad = '';
        element.dataset.faded = '';
        const loadEl = this.#getLoadElement(element);
        if (loadEl && (loadEl.tagName === 'IMG' || loadEl.tagName === 'VIDEO')) // sometimes, don't removeSrc, because that would remove the svg placeholder and make images not the correct size, which would in turn have media further down the page not be in the correct position to (not) fade in
        {
            if (removeSrc) {
                // console.log('remove src from loadEl');
                loadEl.setAttribute('src', '');
                loadEl.setAttribute('srcset', '');
            }
        }
    };
    fadeInHolderAgain = (holder)=>{
        // console.log('fadeInHolderAgain', holder);
        if (!holder) return;
        let holderEl;
        if (holder instanceof Element) holderEl = holder;
        else {
            holderEl = document.querySelector(holder);
            if (!holderEl) return;
        }
        const elements = holderEl.querySelectorAll('.fader2');
        elements.forEach((el)=>this.#fadeAgain(el));
        this.setFaders();
    };
    fadeElementsAgain = (selector)=>{
        // console.log('fadeElementsAgain', selector);
        if (!selector) return;
        let elements;
        if (selector instanceof NodeList) elements = selector;
        else if (selector instanceof Element) elements = [
            selector
        ];
        else {
            elements = document.querySelectorAll(selector);
            if (!elements) return;
        }
        elements.forEach((el)=>this.#fadeAgain(el));
        this.setFaders();
    };
    enableScrollListen = ()=>{
        if (this.listenToScroll) return;
        this.listenToScroll = true;
        document.addEventListener('scroll', this.#boundScroll);
    };
    disableScrollListen = ()=>{
        if (!this.listenToScroll) return;
        this.listenToScroll = false;
        document.removeEventListener('scroll', this.#boundScroll);
    };
    init = ()=>{
        // console.log('Fader init', {'#initialized': this.#initialized});
        if (this.#initialized) return false;
        this.#initialized = true;
        if (!this.#faderEl.isConnected) document.body.insertBefore(this.#faderEl, document.body.firstChild);
        this.#setHorAndVert();
        window.addEventListener('load', this.#boundFadeTimeout);
        if (this.listenToScroll) document.addEventListener('scroll', this.#boundScroll);
        window.addEventListener('resize', this.#boundResize);
        const el = document.querySelector('body');
        if (el) {
            this.#resizeObserver = new ResizeObserver(this.#boundObserverHandler);
            this.#resizeObserver.observe(el);
        }
        return true;
    };
    destroy = ()=>{
        if (!this.#initialized) return;
        this.#initialized = false;
        window.removeEventListener('load', this.#boundFadeTimeout);
        document.removeEventListener('scroll', this.#boundScroll);
        window.removeEventListener('resize', this.#boundResize);
        if (this.fadeScrollersSelector !== '') {
            const fadeScrollers = document.querySelectorAll(this.fadeScrollersSelector);
            fadeScrollers.forEach((element)=>{
                element.removeEventListener('scroll', this.#boundFadeSelector);
            });
        }
        if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = undefined;
        }
        clearTimeout(this.#fadeBlocksTimeout);
        if (this.#faderEl.isConnected) this.#faderEl.remove();
    };
}


// Fold Out V8.3
// perfect fold out and close animation, removes overflow hidden after animation
// also copy fold-out.scss
// adds data-active="1" attribute to button
// requires data-nr on button and fold-out, both are integers
// so it knows what button opens what foldout
// init: folder = new FoldOut(); folder.init();
// usage: init fold out as above with required property name
// do this only once per name
// close all foldouts using folder.closeFoldOuts()
// required properties:
// name: the name for the foldout, only closes others with the same name
// possible properties:
// transitionDuration = 600: in ms. Should match transition duration of fold-out.scss
// closeOthers = true: should other fold outs in the same holder be closed when opening one
// closeInOtherHolders = false: does what it says, only works if closeOthers is true
// scrollAfterSwitch = false, editable: should the page scroll to the clicked button, only works if closeOthers is true and the clicked button is below the previously clicked button
// scrollAfterSwitchOffset: in px, editable, negative. To where relative to the btn should the page scroll during fold out (normally so that the foldout btn is fully visible)
// startCallback = '': called before opening or closing a fold out
// duringCallback = '': called during opening or closing a fold out
// callback = '': called after opening and closing a fold out, returns the now visible fold-out element as first parameter or null when closed, and all affected fold-out elements as second parameter
// hasVideos = false: can it have <div class="video"> elements
// hasVideoEmbeds = false: can it have <div class="video-embed"> elements
// methods:
// foldout.init(): attach listeners
// foldout.destroy(): remove listeners
// foldout.closeFoldOuts(): no properties
// foldout.toggleFoldout(button): required button element
// foldout.openByNr(nr, holderEl): opens foldout by nr; optionally scoped to a holder element
// foldout.closeByNr(nr, holderEl): closes foldout by nr; optionally scoped to a holder element
// changelog:
// 4.0: perfect opening and closing
// 4.1 trigger a resize / callback, after / during opening or closing
// 4.2 fixed bug for clicking button not in holder (which should do nothing)
// 4.2.1 use animateScrollTop instead of animateScroll
// 4.3 fixed not using changed variables
// 4.3.1 eslint
// 4.4 remove jquery animate, use requestAnimationFrame
// 4.4.1 check for video functions
// 5.0 no jquery needed
// 5.1 fix for closing foldout in other holder with same nr
// 5.2 cleanup
// 5.3 fix for clicking on element in button, better element var names
// 5.4 now opens all corresponding foldouts if there are multiple, cleanup
// 5.5 make it possible to animate multiple foldouts at the same time
// 6.0 breaking change: foldouts have data-btn-class attribute, nicer animation
// 6.1 keyboard focus skips closed foldouts
// 6.2 add startCallback
// 6.3 add duringCallback
// 6.4 replace elFromEvent function with inline event.target.closest calls
// 7.0 use data-active instead if --active class
// 7.1 only add name, so it's not connected to specific classes ()
// 7.2 rename openFoldout to toggleFoldout, because it also closes foldouts, and can be used for both
// 8.0 breaking: move startup side effects out of the constructor into init(), add destroy(), and split internal logic into methods
// 8.1 callback now receives the visible fold-out element as first parameter and the affected fold-out elements as second parameter
// 8.2 add openByNr(), sync aria-expanded on all button state changes
// 8.3 add closeByNr()
class $8cb15295fbe17ca3$export$2e2bcd8739ae039 {
    #boundHandleClick;
    constructor({ name: name, transitionDuration: transitionDuration = 600, closeOthers: closeOthers = true, closeInOtherHolders: closeInOtherHolders = false, scrollAfterSwitch: scrollAfterSwitch = false, scrollAfterSwitchOffset: scrollAfterSwitchOffset = 0, startCallback: startCallback = '', duringCallback: duringCallback = '', callback: callback = '', hasVideos: hasVideos = false, hasVideoEmbeds: hasVideoEmbeds = false } = ''){
        // user variables ------------------------------------------------------------
        this.name = name;
        // can be changed based on a media query for instance and read
        this.transitionDuration = transitionDuration;
        this.closeOthers = closeOthers;
        this.closeInOtherHolders = closeInOtherHolders;
        this.scrollAfterSwitch = scrollAfterSwitch;
        this.scrollAfterSwitchOffset = scrollAfterSwitchOffset;
        this.startCallback = startCallback;
        this.duringCallback = duringCallback;
        this.callback = callback;
        this.hasVideos = hasVideos;
        this.hasVideoEmbeds = hasVideoEmbeds;
        this.#boundHandleClick = this.#handleClick.bind(this);
    }
    init = ()=>{
        document.body.addEventListener('click', this.#boundHandleClick);
    };
    destroy = ()=>{
        document.body.removeEventListener('click', this.#boundHandleClick);
    };
    toggleFoldout = (buttonEl)=>{
        // console.log('toggleFoldout', {buttonEl});
        if (buttonEl.dataset.animating == 'true') return;
        buttonEl.dataset.animating = true;
        if (typeof this.startCallback == 'function') this.startCallback();
        const nr = parseInt(buttonEl.getAttribute('data-nr'), 10);
        const buttonHolderEl = buttonEl.closest(`[data-fo-holder="${this.name}"]`);
        if (!buttonHolderEl) {
            buttonEl.dataset.animating = false;
            return;
        }
        let holderEls;
        // close others ---------------------------------------
        if (this.closeOthers) {
            if (this.closeInOtherHolders) {
                holderEls = document.querySelectorAll(`[data-fo-holder="${this.name}"]`);
                holderEls.forEach((holderEl)=>{
                    if (holderEl == buttonHolderEl) // only close others in same holderEl
                    this.#setMaxHeightOthers(holderEl, nr);
                    else // other holderEl, close all
                    this.#setMaxHeight(holderEl);
                });
            } else this.#setMaxHeightOthers(buttonHolderEl, nr);
            requestAnimationFrame(()=>{
                if (this.closeInOtherHolders && holderEls) holderEls.forEach((holderEl)=>{
                    if (holderEl == buttonHolderEl) // only close others in same holderEl
                    this.#removeMaxHeightOthers(holderEl, nr);
                    else // other holderEl, close all
                    this.#removeMaxHeight(holderEl);
                });
                else // only close others in same holderEl
                this.#removeMaxHeightOthers(buttonHolderEl, nr);
                if (this.scrollAfterSwitch) {
                    const prevOpenNr = parseInt(buttonHolderEl.getAttribute('data-open-nr'), 10);
                    if (prevOpenNr < nr && typeof animateScrollTop == 'function') {
                        const prevOpenFoldOutEl = buttonHolderEl.querySelector(`.fold-out[data-fo="${this.name}"][data-nr="${prevOpenNr}"]`);
                        if (prevOpenFoldOutEl) {
                            const offsetCurrent = buttonEl.offsetTop - prevOpenFoldOutEl.offsetHeight + this.scrollAfterSwitchOffset;
                            animateScrollTop(offsetCurrent);
                        }
                    }
                    buttonHolderEl.setAttribute('data-open-nr', nr);
                }
            });
            // after closing
            setTimeout(()=>{
                if (this.hasVideoEmbeds && typeof closeVideoEmbeds == 'function' && typeof holderEls !== 'undefined') closeVideoEmbeds(holderEls);
                if (this.hasVideos && typeof pauseVideos == 'function' && typeof holderEls !== 'undefined') pauseVideos(holderEls);
            }, this.transitionDuration);
        }
        // open or close this one ----------------------------
        buttonEl.dataset.active = buttonEl.dataset.active === '1' ? '0' : '1';
        buttonEl.setAttribute('aria-expanded', buttonEl.dataset.active === '1' ? 'true' : 'false');
        const foldOutEls = buttonHolderEl.querySelectorAll(`.fold-out[data-fo="${this.name}"][data-nr="${nr}"]`);
        foldOutEls.forEach((foldOutEl)=>{
            foldOutEl.style.maxHeight = foldOutEl.scrollHeight + 'px';
        });
        if (buttonEl.dataset.active === '1') setTimeout(()=>{
            foldOutEls.forEach((foldOutEl)=>{
                foldOutEl.style.maxHeight = '';
                foldOutEl.classList.add('fold-out--opened');
                // after adding --opened
                if (this.hasVideoEmbeds && typeof openVideoEmbeds == 'function') openVideoEmbeds(foldOutEl);
                if (this.hasVideos && typeof playVideos == 'function') playVideos(foldOutEl);
            });
            // because element positions changed and items became visible
            this.#runCallback(foldOutEls[0] || null, foldOutEls, buttonEl, buttonHolderEl);
            buttonEl.dataset.animating = false;
        }, this.transitionDuration);
        else {
            requestAnimationFrame(()=>{
                foldOutEls.forEach((foldOutEl)=>{
                    foldOutEl.style.maxHeight = '0px';
                    foldOutEl.classList.remove('fold-out--opened');
                });
                setTimeout(()=>{
                    this.#runCallback(null, foldOutEls, buttonEl, buttonHolderEl);
                }, this.transitionDuration);
            });
            // after closing
            setTimeout(()=>{
                foldOutEls.forEach((foldOutEl)=>{
                    if (this.hasVideoEmbeds && typeof closeVideoEmbeds == 'function') closeVideoEmbeds(foldOutEl);
                    if (this.hasVideos && typeof pauseVideos == 'function') pauseVideos(foldOutEl);
                    buttonEl.dataset.animating = false;
                });
            }, this.transitionDuration);
        }
        // may do callback and trigger resize during animation
        this.#duringAnimation();
    };
    openByNr = (nr, holderEl = document)=>{
        const btnEl = holderEl.querySelector(`[data-fo-btn="${this.name}"][data-nr="${nr}"]`);
        if (!btnEl || btnEl.dataset.active === '1') return;
        this.toggleFoldout(btnEl);
    };
    closeByNr = (nr, holderEl = document)=>{
        const btnEl = holderEl.querySelector(`[data-fo-btn="${this.name}"][data-nr="${nr}"]`);
        if (!btnEl || btnEl.dataset.active !== '1') return;
        this.toggleFoldout(btnEl);
    };
    closeFoldOuts = ()=>{
        const animatingButtonEl = document.querySelector(`[data-fo-btn="${this.name}"][data-animating="true"]`);
        if (animatingButtonEl) return;
        const holderEls = document.querySelectorAll(`[data-fo-holder="${this.name}"]`);
        if (holderEls && document.querySelector(`.fold-out--opened[data-fo="${this.name}"]`)) {
            const buttonEl = document.querySelector(`[data-fo-btn="${this.name}"][data-active="1"]`);
            if (!buttonEl) return;
            const foldOutEls = document.querySelectorAll(`.fold-out--opened[data-fo="${this.name}"]`);
            buttonEl.dataset.animating = true;
            // there are opened foldouts
            this.#setMaxHeight(document);
            // may do callback and trigger resize during animation
            this.#duringAnimation();
            setTimeout(()=>{
                this.#removeMaxHeight(document);
                setTimeout(()=>{
                    this.#runCallback(null, foldOutEls, buttonEl, holderEls);
                }, this.transitionDuration);
            }, 100);
            // after closing
            setTimeout(()=>{
                if (this.hasVideoEmbeds && typeof closeVideoEmbeds == 'function') closeVideoEmbeds(holderEls);
                if (this.hasVideos && typeof pauseVideos == 'function') pauseVideos(holderEls);
                buttonEl.dataset.animating = false;
            }, this.transitionDuration);
        }
    };
    #handleClick(event) {
        const btnEl = event.target.closest(`[data-fo-btn="${this.name}"]`);
        if (!btnEl) return;
        const btnHolder = btnEl.closest(`[data-fo-holder="${this.name}"]`);
        if (btnHolder) this.toggleFoldout(btnEl);
    }
    #setMaxHeightOthers(holderEl, nr) {
        const foldOutEls = holderEl.querySelectorAll(`.fold-out--opened[data-fo="${this.name}"]:not([data-nr="${nr}"])`);
        foldOutEls.forEach((foldOutEl)=>{
            foldOutEl.style.maxHeight = foldOutEl.scrollHeight + 'px';
        });
    }
    #setMaxHeight(holderEl) {
        const foldOutEls = holderEl.querySelectorAll(`.fold-out--opened[data-fo="${this.name}"]`);
        foldOutEls.forEach((openFoldoutEl)=>{
            openFoldoutEl.style.maxHeight = openFoldoutEl.scrollHeight + 'px';
        });
    }
    #removeMaxHeightOthers(holderEl, nr) {
        const foldOutEls = holderEl.querySelectorAll(`.fold-out--opened[data-fo="${this.name}"]:not([data-nr="${nr}"])`);
        foldOutEls.forEach((foldOutEl)=>{
            foldOutEl.style.maxHeight = '0px';
            foldOutEl.classList.remove('fold-out--opened');
        });
        const buttonEls = holderEl.querySelectorAll(`[data-fo-btn="${this.name}"]:not([data-nr="${nr}"])`);
        buttonEls.forEach((buttonEl)=>{
            buttonEl.dataset.active = '0';
            buttonEl.setAttribute('aria-expanded', 'false');
        });
    }
    #removeMaxHeight(holderEl) {
        const foldOutEls = holderEl.querySelectorAll(`.fold-out--opened[data-fo="${this.name}"]`);
        foldOutEls.forEach((foldOutEl)=>{
            foldOutEl.style.maxHeight = '0px';
            foldOutEl.classList.remove('fold-out--opened');
        });
        const buttonEls = holderEl.querySelectorAll(`[data-fo-btn="${this.name}"]`);
        buttonEls.forEach((buttonEl)=>{
            buttonEl.dataset.active = '0';
            buttonEl.setAttribute('aria-expanded', 'false');
        });
    }
    #duringAnimation() {
        const animatingButtonEl = document.querySelector(`[data-fo-btn="${this.name}"][data-animating="true"]`);
        if (animatingButtonEl) {
            if (typeof this.duringCallback == 'function') this.duringCallback();
            requestAnimationFrame(()=>this.#duringAnimation());
        }
    }
    #runCallback(activeFoldOutEl, foldOutEls, buttonEl, holderEl) {
        if (typeof this.callback == 'function') this.callback(activeFoldOutEl, foldOutEls, buttonEl, holderEl);
    }
}


// Animate It V5.3.1
// used for wiggling elements, mouse and scroll with interaction
// also copy _animate-it.scss
// init: animateIt = new AnimateIt(); animateIt.init();
// possible properties:
// frameFunction = '': external frame animation function using this frame handler
// SMOOTH SCROLL ---------------------------------------------------------------
// adds smoothscroll with sticky support, supports 1 instance
// smoothScroll usage: animateIt.smoothScroll({});
// required properties:
// none
// possible properties:
// speed = 0.1: larger is faster
// bounce = 0.01: larger is less overschoot
// iframeScrollDelay = 1000: delay before iframe can take over native scrolling
// useHorizontalWheel = false: does horizontal wheel input also scroll vertically?
// startScroll = -1: use this starting scroll position instead of current browser scroll
// scrollToAnchor = true: allow clicking hash links to scroll to matching elements
// related methods:
// animateIt.setScrollPosHard({ pos: 0 }); immediately here, even if smooth is on
// animateIt.setScrollPosSoft({ pos: 0 }); use smoothscroll here
// animateIt.disableSmoothScroll(); disables smoothscroll
// animateIt.enableSmoothScroll(); enables smoothscroll
// animateIt.removeSmoothScroll(); removes smoothscroll altogether
// animateIt.leaveIframe(); same as when mouse leaves iframe
// animateIt.resizeHandler(true); force recalculate sizes/positions
// WIGGLE ----------------------------------------------------------------------
// makes elements wiggle, can create multiple instances
// wiggle usage: animateIt.wiggle({ selector: '#selector' });
// required properties:
// selector: element selector
// possible properties:
// speed = 0.1: larger is faster
// bounce = 0.01: larger is less overschoot
// distance = 20: max position switch distance in px
// switchPerSec = 2: number of position switches per second
// slowScroll = false: does it scroll along slowly?
// mousePush = false: does it move with the mouse?
// mousePushRate = 1: how much does it move with the mouse, larger = more
// scrollPush = false: does it move with the scroll?
// scrollPushRate = 1: how much does it move with the scroll, larger = more
// wiggle = true: does it wiggle?
// related methods:
// animateIt.destroyWiggler(wiggler, removeElement = false); remove a wiggler instance
// FOLLOW MOUSE  ---------------------------------------------------------------
// makes an element follow the mouse, supports 1 instance
// followMouse usage: animateIt.followMouse({ selector: '#selector' });
// required properties:
// selector: element selector
// possible properties:
// speed = 1: larger is faster
// bounce = 0.1: larger is less overschoot
// rotate = false: does the element rotate?
// scrollSmear = false: is the mouse animated by scrolling?
// issues: ---------------------------------------------------------------------
// smoothscroll on iframe is not working on firefox
// changelog:
// 3.0 added slowscroll
// 3.0.1 cleaner scripts and fixed ResizeObserver
// 3.1 added setting smooth scroll position (because it interferes with scrollTop)
// 3.1.2 eslint
// 3.2 fix firefox iframe scroll bug
// 3.3 add disable smooth scroll function
// 3.3.1 fix intertia hickup on touch devices
// 3.3.2 make arrays available to external functions
// 3.3.3 fix ios scroll bug
// 3.3.4 removed scrollbar on smooth scroll
// 3.3.5 nicer wait on new frame
// 3.4 add keyboard control for smooth scroll
// 3.4.1 fix scroll on iframe
// 3.4.2 block resize observer option
// 3.4.3 fix for leaving iframe without mouseout (for instance on page switch)
// 3.4.4 add focus handler, for scrolling to focus
// 3.4.5 fix focus handler: only work with keyboard focus
// 3.4.6 fix for enabling scroll when body was fixed
// 3.4.7 make scrollDiff available outside
// 3.4.8 add mousy hover for select elements
// 3.4.9 don't set scroll when not moving to save performance
// 3.4.10 do keyboard focus action only once
// 3.4.11 make scroller available outside, fix hash links on current page
// 3.4.12 fix inertia on touch devices
// 3.4.13 make scrollDiff available without smoothscroll
// 3.4.14 fix for enabling wheel when blocking smoothscroll
// 3.4.15 don't start mouse in center (often in the way)
// 3.4.16 fix for undefined href
// 3.4.17 add preventSearch option
// 3.4.18 fix search instead of preventSearch
// 4.0 remove jquery dependency
// 4.0.1 fix for non smoothscroll
// 4.1 new drag css
// 4.1.1 offsetTop fix
// 4.2 fix events
// 4.2.1 fix for scrolling when in form element
// 4.2.2 fix smooth scroll to keyboard focus
// 4.2.3 turn of smoothscroll when using pen/stylus on non touchscreen
// 4.3 cleanup of getAttribute code, add removeSmoothScroll
// 4.3.1 cleanup of keycode
// 4.4 hide scrollbar on smoothscroll when document is not in focus
// 4.4.1 only enable smoothscroll after window blur if it was enabled before
// 4.5 return objects to calling functions, add non wiggle option, add destroy wiggler option
// 4.5.1 fix blocked scroll after click on iframe
// 4.6 add difference vars for wigglers
// 4.6.1 only scroll to keyboard focus if not in view
// 4.7 add scrollbar
// 4.7.1 fix scrollbar height
// 4.7.2 add el from event function
// 4.7.3 add aria label to scrollbar
// 4.7.4 add check for scrollbar
// 4.7.5 don't always add fader--still, subpixel for firefox partly
// 4.7.6 fix slowscroll wiggle flash in view on resize
// 4.7.7 don't use scss vars
// 4.7.8 fix smoothscroll start if no history js
// 4.7.9 fix preventDefault error
// 4.8 add scrollPush option
// 4.8.1 fix unblock smoothscroll
// 4.8.2 fix swiper hovers
// 4.8.3 fix anchor links
// 4.8.4 add click pulse
// 4.9 fix for non existing element, allow element instead of selector
// 4.9.1 replace elFromEvent function with inline event.target.closest calls
// 4.10 call resize after unblocking resize observer
// 4.11 add more support for keyboard scrolling
// 4.12 make resizeHandler publicly available, remove resize call on unblock
// 4.13 add useHorizontalWheel option for smoothscroll wheel input
// 4.14 add startScroll option for smoothScroll
// 4.15 fix for empty startScroll option
// 4.16 add resetFollowMouseClasses
// 5.0 Breaking: move setup into init/destroy and convert constructor closures to methods
// 5.1 hide custom scrollbar while on iframe to prevent double scrollbar
// 5.2 fake scroll inertia when leaving iframe
// 5.3 make wheel preventDefault/stopPropagation optional via blockWheel
// 5.3.1 add scrollToAnchor option to smoothScroll, allowing anchor-link scrolling to be disabled and toggled at runtime

class $2dc0ac34957019d1$export$2e2bcd8739ae039 {
    blockResizeObserver;
    arWigglers;
    arFollowers;
    scrollDiff;
    scroller;
    #frameFunction;
    #blockSmoothScroll;
    #mouseY;
    #mouseX;
    #mouseSmearY;
    #mouseSmearX;
    #mouseYDiff;
    #mouseXDiff;
    #mouseYPrevDiff;
    #mouseXPrevDiff;
    #mouseCounter;
    #lastScrolledTop;
    #lastScrolledLeft;
    #scrollTop;
    #scrollLeft;
    #scrollTopDiff;
    #scrollLeftDiff;
    #scrollTimeout;
    #windowWidth;
    #windowHeight;
    #prevObserverWidth;
    #prevObserverHeight;
    #maxBodyScrollTop;
    #prevTouchY;
    #onIframe;
    #scrollTopOnIframe;
    #iframeTimeout;
    #enteredFrame;
    #shiftDown;
    #focusSource;
    #touchendScrollDiff;
    #touchMoved;
    #blockedScrollFromWindowBlur;
    #scrollbarEl;
    #scrollbarHeight;
    #scrollDrag;
    #scrollDragPrevY;
    #prevBodyPosition;
    #prevBlockSmoothScroll;
    #isTouch;
    #blFirefox;
    #prevWidth;
    #resizeObserver;
    #animationFrameId;
    #initialized;
    #pauseWiggleFrame;
    #pauseScrollFrame;
    #pauseFollowFrame;
    #boundDoFrame;
    #boundObserverHandler;
    #boundTouchHandler;
    #boundMouseMoveHandler;
    #boundScrollTouchWheel;
    #boundScrollPointerDown;
    #boundResize;
    #boundScrollHandler;
    #boundKeyDownHandler;
    #boundKeyUpHandler;
    #boundKeyPressHandler;
    #boundMouseDownHandler;
    #boundMouseUpHandler;
    #boundFocusHandler;
    #boundDocumentClick;
    #boundBlurWindowHandler;
    #boundFocusWindowHandler;
    #boundLoadHandler;
    #boundHandleIframeEnter;
    #boundHandleIframeMouseOut;
    #boundScrollTouchStart;
    #boundScrollTouchMove;
    #boundScrollTouchEnd;
    #boundHandleMouseOver;
    #boundHandleMouseOut;
    #boundHandleMouseLeave;
    #boundHandleMouseEnterDocument;
    static #MAX_MOUSE_DIFF = 100;
    static #MAX_SCROLL_DIFF = 100;
    constructor({ frameFunction: frameFunction = '', pauseWiggle: pauseWiggle = false, pauseScroll: pauseScroll = false, pauseFollow: pauseFollow = false } = {}){
        this.blockResizeObserver = false;
        this.arWigglers = [];
        this.arFollowers = [];
        this.scrollDiff = 0;
        this.scroller = undefined;
        this.#frameFunction = frameFunction;
        this.#blockSmoothScroll = false;
        this.#mouseY = 0;
        this.#mouseX = 0;
        this.#mouseSmearY = 0;
        this.#mouseSmearX = 0;
        this.#mouseYDiff = 0;
        this.#mouseXDiff = 0;
        this.#mouseYPrevDiff = 0;
        this.#mouseXPrevDiff = 0;
        this.#mouseCounter = 0;
        this.#lastScrolledTop = 0;
        this.#lastScrolledLeft = 0;
        this.#scrollTop = 0;
        this.#scrollLeft = 0;
        this.#scrollTopDiff = 0;
        this.#scrollLeftDiff = 0;
        this.#scrollTimeout = undefined;
        this.#windowWidth = document.documentElement.clientWidth;
        this.#windowHeight = document.documentElement.clientHeight;
        this.#prevObserverWidth = 0;
        this.#prevObserverHeight = 0;
        this.#maxBodyScrollTop = 0;
        this.#prevTouchY = 0;
        this.#onIframe = false;
        this.#scrollTopOnIframe = 0;
        this.#iframeTimeout = undefined;
        this.#enteredFrame = false;
        this.#shiftDown = false;
        this.#focusSource = '';
        this.#touchendScrollDiff = 0;
        this.#touchMoved = false;
        this.#blockedScrollFromWindowBlur = false;
        this.#scrollbarEl = undefined;
        this.#scrollbarHeight = 0;
        this.#scrollDrag = false;
        this.#scrollDragPrevY = 0;
        this.#prevBodyPosition = '';
        this.#prevBlockSmoothScroll = false;
        this.#isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
        this.#blFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        this.#prevWidth = 0;
        this.#resizeObserver = undefined;
        this.#animationFrameId = undefined;
        this.#initialized = false;
        this.#pauseWiggleFrame = pauseWiggle;
        this.#pauseScrollFrame = pauseScroll;
        this.#pauseFollowFrame = pauseFollow;
        this.#boundDoFrame = this.#doFrame.bind(this);
        this.#boundObserverHandler = this.#observerHandler.bind(this);
        this.#boundTouchHandler = this.#touchHandler.bind(this);
        this.#boundMouseMoveHandler = this.#mousemoveHandler.bind(this);
        this.#boundScrollTouchWheel = this.#scrollTouchWheel.bind(this);
        this.#boundScrollPointerDown = this.#scrollPointerDown.bind(this);
        this.#boundResize = this.#handleWindowResize.bind(this);
        this.#boundScrollHandler = this.#scrollHandler.bind(this);
        this.#boundKeyDownHandler = this.#keyDownHandler.bind(this);
        this.#boundKeyUpHandler = this.#keyUpHandler.bind(this);
        this.#boundKeyPressHandler = this.#keyPressHandler.bind(this);
        this.#boundMouseDownHandler = this.#mousedownHandler.bind(this);
        this.#boundMouseUpHandler = this.#mouseupHandler.bind(this);
        this.#boundFocusHandler = this.#focusHandler.bind(this);
        this.#boundDocumentClick = this.#handleDocumentClick.bind(this);
        this.#boundBlurWindowHandler = this.#blurWindowHandler.bind(this);
        this.#boundFocusWindowHandler = this.#focusWindowHandler.bind(this);
        this.#boundLoadHandler = this.#loadHandler.bind(this);
        this.#boundHandleIframeEnter = this.#handleIframeEnter.bind(this);
        this.#boundHandleIframeMouseOut = this.#handleIframeMouseOut.bind(this);
        this.#boundScrollTouchStart = this.#scrollTouchStart.bind(this);
        this.#boundScrollTouchMove = this.#scrollTouchMove.bind(this);
        this.#boundScrollTouchEnd = this.#scrollTouchEnd.bind(this);
        this.#boundHandleMouseOver = this.#handleMouseOver.bind(this);
        this.#boundHandleMouseOut = this.#handleMouseOut.bind(this);
        this.#boundHandleMouseLeave = this.#handleMouseLeave.bind(this);
        this.#boundHandleMouseEnterDocument = this.#handleMouseEnterDocument.bind(this);
    }
    init = ()=>{
        if (this.#initialized) return;
        this.#initialized = true;
        this.#boundDoFrame();
        document.documentElement.addEventListener('touchmove', this.#boundTouchHandler);
        document.documentElement.addEventListener('touchstart', this.#boundTouchHandler);
        document.documentElement.addEventListener('mousemove', this.#boundMouseMoveHandler);
        document.documentElement.addEventListener('wheel', this.#boundScrollTouchWheel, {
            capture: true,
            passive: false
        });
        document.documentElement.addEventListener('pointerdown', this.#boundScrollPointerDown);
        window.addEventListener('resize', this.#boundResize);
        document.addEventListener('scroll', this.#boundScrollHandler);
        document.addEventListener('keydown', this.#boundKeyDownHandler);
        document.addEventListener('keyup', this.#boundKeyUpHandler);
        document.addEventListener('keypress', this.#boundKeyPressHandler);
        document.documentElement.addEventListener('mousedown', this.#boundMouseDownHandler);
        document.documentElement.addEventListener('mouseup', this.#boundMouseUpHandler);
        document.documentElement.addEventListener('focus', this.#boundFocusHandler, true);
        document.addEventListener('click', this.#boundDocumentClick);
        window.addEventListener('blur', this.#boundBlurWindowHandler);
        window.addEventListener('focus', this.#boundFocusWindowHandler);
        window.addEventListener('load', this.#boundLoadHandler);
        document.body.addEventListener('mouseover', this.#boundHandleMouseOver, true);
        document.body.addEventListener('mouseout', this.#boundHandleMouseOut, true);
        document.addEventListener('mouseleave', this.#boundHandleMouseLeave);
        document.addEventListener('mouseenter', this.#boundHandleMouseEnterDocument);
        const bodyElement = document.querySelector('body');
        if (bodyElement) {
            this.#resizeObserver = new ResizeObserver(this.#boundObserverHandler);
            this.#resizeObserver.observe(bodyElement);
        }
        this.resizeHandler();
        this.#scrollHandler();
    };
    destroy = ()=>{
        if (!this.#initialized) return;
        this.removeSmoothScroll();
        document.documentElement.removeEventListener('touchmove', this.#boundTouchHandler);
        document.documentElement.removeEventListener('touchstart', this.#boundTouchHandler);
        document.documentElement.removeEventListener('mousemove', this.#boundMouseMoveHandler);
        document.documentElement.removeEventListener('wheel', this.#boundScrollTouchWheel, {
            capture: true
        });
        document.documentElement.removeEventListener('pointerdown', this.#boundScrollPointerDown);
        window.removeEventListener('resize', this.#boundResize);
        document.removeEventListener('scroll', this.#boundScrollHandler);
        document.removeEventListener('keydown', this.#boundKeyDownHandler);
        document.removeEventListener('keyup', this.#boundKeyUpHandler);
        document.removeEventListener('keypress', this.#boundKeyPressHandler);
        document.documentElement.removeEventListener('mousedown', this.#boundMouseDownHandler);
        document.documentElement.removeEventListener('mouseup', this.#boundMouseUpHandler);
        document.documentElement.removeEventListener('focus', this.#boundFocusHandler, true);
        document.removeEventListener('click', this.#boundDocumentClick);
        window.removeEventListener('blur', this.#boundBlurWindowHandler);
        window.removeEventListener('focus', this.#boundFocusWindowHandler);
        window.removeEventListener('load', this.#boundLoadHandler);
        document.body.removeEventListener('mouseover', this.#boundHandleMouseOver, true);
        document.body.removeEventListener('mouseout', this.#boundHandleMouseOut, true);
        document.removeEventListener('mouseleave', this.#boundHandleMouseLeave);
        document.removeEventListener('mouseenter', this.#boundHandleMouseEnterDocument);
        if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = undefined;
        }
        if (typeof this.#animationFrameId !== 'undefined') {
            cancelAnimationFrame(this.#animationFrameId);
            this.#animationFrameId = undefined;
        }
        clearTimeout(this.#scrollTimeout);
        clearTimeout(this.#iframeTimeout);
        this.#scrollTimeout = undefined;
        this.#iframeTimeout = undefined;
        document.body.classList.remove('body--follow-mouse');
        this.#initialized = false;
    };
    smoothScroll = ({ speed: speed = 0.1, bounce: bounce = 0.01, iframeScrollDelay: iframeScrollDelay = 1000, blockWheel: blockWheel = false, useHorizontalWheel: useHorizontalWheel = false, startScroll: startScroll = -1, scrollToAnchor: scrollToAnchor = true } = {})=>{
        this.removeSmoothScroll();
        if (this.#isTouch) {
            document.documentElement.addEventListener('touchstart', this.#boundScrollTouchStart);
            document.documentElement.addEventListener('touchmove', this.#boundScrollTouchMove);
            document.documentElement.addEventListener('touchend', this.#boundScrollTouchEnd);
            document.body.style.touchAction = 'none';
        } else {
            document.body.classList.add('body--animate-it-smoothscroll');
            document.body.classList.add('body--animate-it-smoothscroll-initialized');
            this.#scrollbarEl = document.createElement('button');
            this.#scrollbarEl.classList.add('animate-it-scrollbar');
            this.#scrollbarEl.setAttribute('aria-label', 'Scrollbar');
            document.body.appendChild(this.#scrollbarEl);
            document.body.addEventListener('mouseenter', this.#boundHandleIframeEnter, true);
            document.body.addEventListener('mouseout', this.#boundHandleIframeMouseOut);
        }
        const smoothScroll = {
            tempY: this.#scrollTop,
            targetY: this.#scrollTop,
            elY: this.#scrollTop,
            speed: speed,
            bounce: bounce,
            iframeScrollDelay: iframeScrollDelay,
            blockWheel: blockWheel,
            useHorizontalWheel: useHorizontalWheel,
            scrollToAnchor: scrollToAnchor
        };
        this.scroller = smoothScroll;
        this.resizeHandler(true);
        setTimeout(()=>{
            if (startScroll == -1 || startScroll == '' || typeof startScroll == 'undefined' || startScroll === null) this.setScrollPosHard({
                pos: this.#scrollTop
            });
            else this.setScrollPosHard({
                pos: startScroll
            });
        }, 100);
        return smoothScroll;
    };
    leaveIframe = ()=>{
        this.#enteredFrame = false;
        clearTimeout(this.#iframeTimeout);
        if (this.#onIframe) {
            const scrollDiff = (this.#scrollTop - this.#scrollTopOnIframe) * 10;
            this.setScrollPosHard({
                pos: this.#scrollTop
            });
            // because inertia from regular scroll is lost, and deltaY returns 0
            // add a fake inertia when leaving the iframe
            if (scrollDiff !== 0) this.setScrollPosSoft({
                pos: this.#scrollTop + scrollDiff
            });
            this.#onIframe = false;
            document.body.classList.add('body--animate-it-smoothscroll');
        }
        if (typeof this.scroller !== 'object') return;
        if (this.#blockedScrollFromWindowBlur) {
            document.body.classList.add('body--animate-it-smoothscroll');
            this.enableSmoothScroll();
            this.#blockedScrollFromWindowBlur = false;
        }
    };
    disableSmoothScroll = ()=>{
        this.#blockSmoothScroll = true;
        if (this.#scrollbarEl) this.#scrollbarEl.disabled = true;
    };
    enableSmoothScroll = ()=>{
        this.#blockSmoothScroll = false;
        if (this.#scrollbarEl) this.#scrollbarEl.disabled = false;
    };
    removeSmoothScroll = ()=>{
        document.body.classList.remove('body--animate-it-smoothscroll');
        document.body.classList.remove('body--animate-it-smoothscroll-initialized');
        document.body.removeEventListener('mouseenter', this.#boundHandleIframeEnter, true);
        document.body.removeEventListener('mouseout', this.#boundHandleIframeMouseOut);
        document.documentElement.removeEventListener('touchstart', this.#boundScrollTouchStart);
        document.documentElement.removeEventListener('touchmove', this.#boundScrollTouchMove);
        document.documentElement.removeEventListener('touchend', this.#boundScrollTouchEnd);
        document.body.style.touchAction = '';
        if (this.#scrollbarEl) {
            this.#scrollbarEl.remove();
            this.#scrollbarEl = undefined;
        }
        this.#blockSmoothScroll = false;
        this.#blockedScrollFromWindowBlur = false;
        this.#onIframe = false;
        this.#enteredFrame = false;
        this.scroller = undefined;
    };
    setScrollPosHard = ({ pos: pos = 0 })=>{
        if (typeof this.scroller == 'object') {
            this.scroller.tempY = pos;
            this.scroller.targetY = pos;
            this.scroller.elY = pos;
        }
        window.scroll({
            top: pos
        });
        this.#setScrollerMax();
    };
    setScrollPosSoft = ({ pos: pos = 0 })=>{
        if (typeof this.scroller == 'object') this.scroller.targetY = pos;
        this.#setScrollerMax();
    };
    wiggle = ({ selector: selector, speed: speed = 0.1, bounce: bounce = 0.01, distance: distance = 20, switchPerSec: switchPerSec = 2, slowScroll: slowScroll = false, mousePush: mousePush = false, mousePushRate: mousePushRate = 1, scrollPush: scrollPush = false, scrollPushRate: scrollPushRate = 1, wiggle: wiggle = true } = {})=>{
        let element;
        if (selector instanceof Element) element = selector;
        else {
            element = document.querySelector(selector);
            if (!element) return;
        }
        element.classList.add('animate-it-wiggler');
        this.#scrollHandler();
        const parentEl = element.parentElement;
        if (slowScroll && parentEl && (parentEl.classList.contains('fader') || parentEl.classList.contains('fader2'))) parentEl.classList.add('fader--still');
        const wiggler = {
            element: element,
            startY: 0,
            tempY: slowScroll ? -this.#scrollTop : 0,
            targetY: 0,
            elY: slowScroll ? -this.#scrollTop : 0,
            prevElY: slowScroll ? -this.#scrollTop : 0,
            diffY: 0,
            startX: 0,
            tempX: this.#scrollLeft,
            targetX: 0,
            elX: this.#scrollLeft,
            prevElX: this.#scrollLeft,
            diffX: 0,
            speed: speed,
            bounce: bounce,
            distance: distance,
            switchEvery: 60 / switchPerSec,
            switchCounter: 0,
            slowScroll: slowScroll,
            mousePush: mousePush,
            mousePushRate: mousePushRate,
            scrollPush: scrollPush,
            scrollPushRate: scrollPushRate,
            wiggle: wiggle
        };
        this.arWigglers.push(wiggler);
        this.resizeHandler(true);
        return wiggler;
    };
    destroyWiggler = (wiggler, removeElement = false)=>{
        const index = this.arWigglers.indexOf(wiggler);
        if (index > -1) {
            this.arWigglers.splice(index, 1);
            if (removeElement) wiggler.element.remove();
        }
    };
    followMouse = ({ selector: selector, speed: speed = 1, bounce: bounce = 0.1, rotate: rotate = false, scrollSmear: scrollSmear = false } = {})=>{
        let element;
        if (selector instanceof Element) element = selector;
        else {
            element = document.querySelector(selector);
            if (!element) return;
        }
        const dot = document.createElement('div');
        dot.classList.add('animate-it-mouse__dot');
        element.appendChild(dot);
        for(let i = 0; i < 4; i++){
            const corner = document.createElement('div');
            corner.classList.add('animate-it-mouse__corner');
            corner.classList.add('animate-it-mouse__corner--' + i);
            element.appendChild(corner);
        }
        element.classList.add('animate-it-mouse');
        if (scrollSmear) element.classList.add('animate-it-mouse--smear');
        document.body.classList.add('body--follow-mouse');
        this.#mouseSmearY = this.#windowHeight / 2 + 100;
        this.#mouseSmearX = this.#windowWidth / 2;
        this.#mouseY = this.#mouseSmearY;
        this.#mouseX = this.#mouseSmearX;
        const startY = this.#mouseY + this.#scrollTop;
        const startX = this.#mouseX + this.#scrollLeft;
        const follower = {
            element: element,
            tempY: startY,
            targetY: startY,
            elY: startY,
            tempX: startX,
            targetX: startX,
            elX: startX,
            speed: speed,
            bounce: bounce,
            rotate: rotate,
            scrollSmear: scrollSmear
        };
        this.arFollowers.push(follower);
        return follower;
    };
    resetFollowMouseClasses = ()=>{
        for(let i = 0; i < this.arFollowers.length; i++){
            const element = this.arFollowers[i].element;
            element.classList.remove('mousy--prev');
            element.classList.remove('mousy--next');
            element.classList.remove('animate-it-mouse--hidden');
            element.classList.remove('animate-it-mouse--inverted');
            element.classList.remove('animate-it-mouse--drag');
            element.classList.remove('animate-it-mouse--drag-hor');
            element.classList.remove('animate-it-mouse--dragging');
            element.classList.remove('animate-it-mouse--dragging-hor');
        }
        this.leaveIframe();
    };
    resizeHandler = (force)=>{
        this.#windowWidth = document.documentElement.clientWidth;
        this.#windowHeight = document.documentElement.clientHeight;
        const windowInnerHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        if (getComputedStyle(document.body).position !== 'fixed') this.#maxBodyScrollTop = documentHeight - windowInnerHeight;
        if (this.#windowWidth == this.#prevWidth && force != true) return;
        this.#prevWidth = this.#windowWidth;
        for(let i = 0; i < this.arWigglers.length; i++)if (this.arWigglers[i].slowScroll) {
            const el = this.arWigglers[i].element;
            el.classList.remove('animate-it-wiggler--slowscroll');
            el.style.top = '';
            el.style.left = '';
            el.style.width = '';
            el.style.transform = '';
            const coords = (0, $e3efffc4d0edbc40$export$ccc55dee332fd8dd)(el);
            const rect = el.getBoundingClientRect();
            el.style.top = coords.top + 'px';
            el.style.left = coords.left + 'px';
            el.style.width = rect.width + 'px';
            el.classList.add('animate-it-wiggler--slowscroll');
        }
        this.#scrollHandler();
        this.#wiggleFrameHandler();
    };
    #doFrame() {
        const bodyElement = document.querySelector('body');
        if (bodyElement) {
            const bodyPosition = window.getComputedStyle(bodyElement).position;
            if (bodyPosition != this.#prevBodyPosition) this.#fixReset();
            this.#prevBodyPosition = bodyPosition;
        }
        if (!this.#pauseWiggleFrame) this.#wiggleFrameHandler();
        if (!this.#pauseScrollFrame) this.#scrollFrameHandler();
        if (!this.#pauseFollowFrame) this.#followFrameHandler();
        if (typeof this.#frameFunction == 'function') this.#frameFunction();
        this.#animationFrameId = requestAnimationFrame(this.#boundDoFrame);
    }
    // Public methods to pause/resume frame handlers
    pauseWiggle = ()=>{
        this.#pauseWiggleFrame = true;
    };
    resumeWiggle = ()=>{
        this.#pauseWiggleFrame = false;
    };
    pauseScroll = ()=>{
        this.#pauseScrollFrame = true;
    };
    resumeScroll = ()=>{
        this.#pauseScrollFrame = false;
    };
    pauseFollow = ()=>{
        this.#pauseFollowFrame = true;
    };
    resumeFollow = ()=>{
        this.#pauseFollowFrame = false;
    };
    // Set multiple handlers paused state at once. Pass `null` to skip.
    setFrameHandlersPaused = ({ wiggle: wiggle = null, scroll: scroll = null, follow: follow = null } = {})=>{
        if (wiggle !== null) this.#pauseWiggleFrame = !!wiggle;
        if (scroll !== null) this.#pauseScrollFrame = !!scroll;
        if (follow !== null) this.#pauseFollowFrame = !!follow;
    };
    #handleIframeEnter(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (!this.#enteredFrame && typeof this.scroller !== 'undefined' && target.matches('iframe')) {
            clearTimeout(this.#iframeTimeout);
            this.#enteredFrame = true;
            this.#iframeTimeout = setTimeout(()=>{
                this.#onIframe = true;
                document.body.classList.remove('body--animate-it-smoothscroll');
                if (this.#scrollbarEl) this.#scrollbarEl.classList.remove('animate-it-scrollbar--visible');
            }, this.scroller.iframeScrollDelay);
        }
    }
    #handleIframeMouseOut(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (target.matches('iframe')) this.leaveIframe();
    }
    #scrollFrameHandler() {
        if (typeof this.scroller == 'undefined' || this.#onIframe) return;
        if (this.#scrollbarEl) {
            this.#scrollbarHeight = this.#windowHeight / document.documentElement.scrollHeight * this.#windowHeight;
            const scrollbarTop = this.#scrollTop / this.#maxBodyScrollTop * (this.#windowHeight - this.#scrollbarHeight);
            this.#scrollbarEl.style.transform = 'translateY(' + scrollbarTop + 'px)';
            if (this.#maxBodyScrollTop == 0) this.#scrollbarEl.classList.remove('animate-it-scrollbar--visible');
            else {
                this.#scrollbarEl.classList.add('animate-it-scrollbar--visible');
                this.#scrollbarEl.style.height = this.#scrollbarHeight + 'px';
            }
        }
        if (this.#blockSmoothScroll) {
            this.#prevBlockSmoothScroll = this.#blockSmoothScroll;
            return;
        }
        if (this.#prevBlockSmoothScroll != this.#blockSmoothScroll && !this.#blockSmoothScroll) {
            this.resizeHandler();
            this.scroller.tempY = this.#scrollTop;
            this.scroller.targetY = this.#scrollTop;
            this.scroller.elY = this.#scrollTop;
        }
        this.#prevBlockSmoothScroll = this.#blockSmoothScroll;
        const distY = (this.scroller.targetY - this.scroller.elY) * this.scroller.speed;
        this.scroller.tempY += distY;
        if (this.scroller.tempY < 0) this.scroller.tempY = 0;
        if (this.scroller.tempY > this.#maxBodyScrollTop) this.scroller.tempY = this.#maxBodyScrollTop;
        if (Math.abs(distY) < 0.01) return;
        this.scroller.elY += this.scroller.bounce * (this.scroller.tempY + distY - this.scroller.elY);
        window.scroll({
            top: this.scroller.elY
        });
    }
    #wiggleFrameHandler() {
        if (this.#mouseYPrevDiff == this.#mouseYDiff && this.#mouseXPrevDiff == this.#mouseXDiff) this.#mouseCounter++;
        else this.#mouseCounter = 0;
        if (this.#mouseCounter > 10) {
            this.#mouseYDiff = 0;
            this.#mouseXDiff = 0;
        }
        this.#mouseYPrevDiff = this.#mouseYDiff;
        this.#mouseXPrevDiff = this.#mouseXDiff;
        for(let i = 0; i < this.arWigglers.length; i++){
            let item = this.arWigglers[i];
            if (item.wiggle) {
                item.switchCounter++;
                if (item.switchCounter > item.switchEvery) {
                    item.switchCounter = 0;
                    item.targetY = Math.random() * item.distance - item.distance / 2;
                    item.targetX = Math.random() * item.distance - item.distance / 2;
                }
            }
            let scopeY;
            let scopeX;
            if (item.slowScroll) {
                scopeY = item.targetY - this.#scrollTop;
                scopeX = item.targetX - this.#scrollLeft;
            } else {
                scopeY = item.targetY;
                scopeX = item.targetX;
            }
            if (item.mousePush) {
                let mousePushAmount = item.mousePushRate;
                mousePushAmount /= Math.sqrt(item.speed);
                scopeX += this.#mouseXDiff * mousePushAmount;
                scopeY += this.#mouseYDiff * mousePushAmount;
            }
            if (item.scrollPush) {
                let scrollPushAmount = item.scrollPushRate;
                scrollPushAmount /= Math.sqrt(item.speed);
                scopeX += this.#scrollLeftDiff * scrollPushAmount;
                scopeY += this.#scrollTopDiff * scrollPushAmount;
            }
            const distY = (scopeY - item.elY) * item.speed;
            item.tempY += distY;
            item.elY += item.bounce * (item.tempY + distY - item.elY);
            const distX = (scopeX - item.elX) * item.speed;
            item.tempX += distX;
            item.elX += item.bounce * (item.tempX + distX - item.elX);
            const transform3d = item.elX + 'px, ' + item.elY + 'px, 0';
            if (this.#blFirefox) item.element.style.transform = 'translate3d(' + transform3d + ') rotate(0.02deg)';
            else item.element.style.transform = 'translate3d(' + transform3d + ')';
            item.diffX = item.elX - item.prevElX;
            item.diffY = item.elY - item.prevElY;
            item.prevElX = item.elX;
            item.prevElY = item.elY;
            this.arWigglers[i] = item;
        }
    }
    #followFrameHandler() {
        for(let i = 0; i < this.arFollowers.length; i++){
            let item = this.arFollowers[i];
            const startY = item.elY;
            const startX = item.elX;
            let scopeMouseX;
            let scopeMouseY;
            if (item.scrollSmear && !this.#isTouch) {
                scopeMouseX = this.#mouseSmearX;
                scopeMouseY = this.#mouseSmearY;
            } else {
                scopeMouseX = this.#mouseX;
                scopeMouseY = this.#mouseY;
            }
            item.targetY = scopeMouseY;
            item.targetX = scopeMouseX;
            const distY = (item.targetY - item.elY) * item.speed;
            item.tempY += distY;
            item.elY += item.bounce * (item.tempY + distY - item.elY);
            const distX = (item.targetX - item.elX) * item.speed;
            item.tempX += distX;
            item.elX += item.bounce * (item.tempX + distX - item.elX);
            let transform3d;
            let distance;
            if (item.rotate) {
                let rotation = Math.atan2(item.elY - startY, item.elX - startX) * 180 / Math.PI;
                distance = Math.sqrt(Math.abs(item.elY - startY) + Math.abs(item.elX - startX));
                distance -= 2;
                if (distance < 0) {
                    distance = 0;
                    rotation = 0;
                }
                transform3d = item.elX + 'px, ' + item.elY + 'px, 0) rotate(' + rotation + 'deg';
                item.element.style.transform = 'translate3d(' + transform3d + ')';
            } else {
                distance = 0;
                transform3d = item.elX + 'px, ' + item.elY + 'px, 0';
                item.element.style.transform = 'translate3d(' + transform3d + ')';
            }
            const dot = item.element.querySelector('.animate-it-mouse__dot');
            if (dot) dot.style.transform = 'scale(' + (distance + 1) + ', 1)';
            this.arFollowers[i] = item;
        }
    }
    #mousedownHandler(event) {
        this.#focusSource = 'mouse';
        const target = event.target;
        if (!(target instanceof Element)) return;
        const el = target.closest('.animate-it-scrollbar');
        if (el && !this.#isTouch) {
            this.#scrollDrag = true;
            this.#scrollDragPrevY = event.clientY;
            el.classList.add('animate-it-scrollbar--drag');
        }
    }
    #mousemoveHandler(event) {
        if (!this.#isTouch) {
            this.#mouseSmearX = event.pageX;
            this.#mouseSmearY = event.pageY;
            this.#inputPositionChange(event.clientX, event.clientY);
            if (this.#scrollDrag && typeof this.scroller === 'object') {
                const diff = event.clientY - this.#scrollDragPrevY;
                const targetDiff = diff * (this.#maxBodyScrollTop / (this.#windowHeight - this.#scrollbarHeight));
                this.scroller.targetY += targetDiff;
                this.#setScrollerMax();
                this.#scrollDragPrevY = event.clientY;
            }
        }
    }
    #mouseupHandler() {
        this.#scrollDrag = false;
        if (this.#scrollbarEl) this.#scrollbarEl.classList.remove('animate-it-scrollbar--drag');
    }
    #touchHandler(event) {
        const evt = typeof event.originalEvent === 'undefined' ? event : event.originalEvent;
        const touch = evt.touches[0] || evt.changedTouches[0];
        if (!touch) return;
        this.#inputPositionChange(touch.pageX, touch.pageY);
    }
    #inputPositionChange(x, y) {
        const tempX = this.#mouseX;
        const tempY = this.#mouseY;
        this.#mouseX = x;
        this.#mouseY = y;
        this.#mouseXDiff = this.#mouseX - tempX;
        this.#mouseYDiff = this.#mouseY - tempY;
        this.#limitMouseDiff();
    }
    #limitMouseDiff() {
        let multiplier;
        if (this.#mouseXDiff > $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF) {
            multiplier = $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF / this.#mouseXDiff;
            this.#mouseXDiff = $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF;
            this.#mouseYDiff *= multiplier;
        }
        if (this.#mouseYDiff > $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF) {
            multiplier = $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF / this.#mouseYDiff;
            this.#mouseYDiff = $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF;
            this.#mouseXDiff *= multiplier;
        }
        if (this.#mouseXDiff < -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF) {
            multiplier = Math.abs($2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF / this.#mouseXDiff);
            this.#mouseXDiff = -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF;
            this.#mouseYDiff *= multiplier;
        }
        if (this.#mouseYDiff < -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF) {
            multiplier = Math.abs($2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF / this.#mouseYDiff);
            this.#mouseYDiff = -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_MOUSE_DIFF;
            this.#mouseXDiff *= multiplier;
        }
    }
    #scrollTouchStart(event) {
        const evt = typeof event.originalEvent === 'undefined' ? event : event.originalEvent;
        const touch = evt.touches[0] || evt.changedTouches[0];
        if (!touch) return;
        this.#prevTouchY = touch.pageY;
        this.#touchMoved = false;
    }
    #scrollTouchMove(event) {
        event.preventDefault();
        this.#touchMoved = true;
        const evt = typeof event.originalEvent === 'undefined' ? event : event.originalEvent;
        const touch = evt.touches[0] || evt.changedTouches[0];
        if (!touch) return;
        const touchY = touch.pageY;
        this.scrollDiff = this.#prevTouchY - touchY;
        this.#touchendScrollDiff = this.scrollDiff;
        this.#prevTouchY = touchY;
        if (typeof this.scroller === 'object') this.scroller.targetY += this.scrollDiff;
        this.#setScrollerMax();
    }
    #scrollTouchEnd() {
        if (!this.#touchMoved) return;
        this.scrollDiff = 10 * this.#touchendScrollDiff;
        if (typeof this.scroller === 'object') this.scroller.targetY += this.scrollDiff;
        this.#setScrollerMax();
    }
    #scrollTouchWheel(event) {
        const target = event.target;
        if (target instanceof Element && target.matches('iframe')) return;
        const horizontalScroll = typeof this.scroller === 'object' && this.scroller.useHorizontalWheel ? event.deltaX : 0;
        this.scrollDiff = event.deltaY + horizontalScroll;
        // console.log(this.scrollDiff);
        if (typeof this.scroller === 'object' && !this.#blockSmoothScroll) {
            // Only block native scroll / stop propagation when `blockWheel` is set
            // on the scroller (opt-in). Default behaviour is to allow other wheel
            // listeners and native scrolling.
            if (this.scroller.blockWheel) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.scroller.targetY += this.scrollDiff;
        }
        this.#setScrollerMax();
    }
    #scrollPointerDown(event) {
        if (typeof this.scroller !== 'object') return;
        if (event.pointerType == 'pen' && !this.#isTouch) this.removeSmoothScroll();
    }
    #setScrollerMax() {
        requestAnimationFrame(()=>{
            this.scrollDiff = 0;
        });
        if (typeof this.scroller !== 'object') return;
        if (this.scroller.targetY < 0) this.scroller.targetY = 0;
        if (this.scroller.targetY > this.#maxBodyScrollTop) this.scroller.targetY = this.#maxBodyScrollTop;
    }
    #handleWindowResize() {
        requestAnimationFrame(()=>{
            this.resizeHandler();
        });
    }
    #scrollHandler() {
        this.#scrollTopOnIframe = this.#scrollTop;
        this.#scrollTop = window.scrollY || document.documentElement.scrollTop;
        this.#scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        this.#scrollLeftDiff = this.#lastScrolledLeft - this.#scrollLeft;
        this.#scrollTopDiff = this.#lastScrolledTop - this.#scrollTop;
        if (this.#scrollLeftDiff > $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF) this.#scrollLeftDiff = $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF;
        if (this.#scrollLeftDiff < -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF) this.#scrollLeftDiff = -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF;
        if (this.#scrollTopDiff > $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF) this.#scrollTopDiff = $2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF;
        if (this.#scrollTopDiff < -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF) this.#scrollTopDiff = -$2dc0ac34957019d1$export$2e2bcd8739ae039.#MAX_SCROLL_DIFF;
        this.#lastScrolledLeft = this.#scrollLeft;
        this.#lastScrolledTop = this.#scrollTop;
        if (!this.#isTouch) {
            if (this.#lastScrolledLeft !== this.#scrollLeft) {
                this.#mouseSmearX -= this.#lastScrolledLeft;
                this.#lastScrolledLeft = this.#scrollLeft;
                this.#mouseSmearX += this.#lastScrolledLeft;
            }
            if (this.#lastScrolledTop !== this.#scrollTop) {
                this.#mouseSmearY -= this.#lastScrolledTop;
                this.#lastScrolledTop = this.#scrollTop;
                this.#mouseSmearY += this.#lastScrolledTop;
            }
        }
        clearTimeout(this.#scrollTimeout);
        this.#scrollTimeout = setTimeout(()=>{
            this.#scrollLeftDiff = 0;
            this.#scrollTopDiff = 0;
        }, 100);
    }
    #formElementFocused(event) {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return false;
        return target.tagName == 'INPUT' || target.tagName == 'TEXTAREA' || target.tagName == 'SELECT' || target.isContentEditable;
    }
    #keyPressHandler(event) {
        if (typeof this.scroller !== 'object' || this.#formElementFocused(event)) return;
        if (event.code === 'Space') {
            this.scrollDiff = this.#shiftDown ? -this.#windowHeight : this.#windowHeight;
            this.scroller.targetY += this.scrollDiff;
        }
        this.#setScrollerMax();
    }
    #keyDownHandler(event) {
        this.#focusSource = 'keyboard';
        if (typeof this.scroller !== 'object' || this.#formElementFocused(event)) return;
        if (event.key === 'ArrowUp') this.scrollDiff = -100;
        else if (event.key === 'ArrowDown') this.scrollDiff = 100;
        else if (event.key === 'PageUp') this.scrollDiff = -this.#windowHeight;
        else if (event.key === 'PageDown') this.scrollDiff = this.#windowHeight;
        else if (event.key === 'Home') {
            this.scrollDiff = 0;
            this.scroller.targetY = 0;
            this.#setScrollerMax();
            return;
        } else if (event.key === 'End') {
            this.scrollDiff = 0;
            this.scroller.targetY = this.#maxBodyScrollTop;
            this.#setScrollerMax();
            return;
        } else if (event.key === 'Shift') this.#shiftDown = true;
        this.scroller.targetY += this.scrollDiff;
        this.#setScrollerMax();
    }
    #keyUpHandler(event) {
        if (event.key === 'Shift') this.#shiftDown = false;
    }
    #focusHandler(event) {
        if (typeof this.scroller !== 'object' || this.#focusSource == 'mouse' || event.target != document.activeElement) return;
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        requestAnimationFrame(()=>{
            const rect = target.getBoundingClientRect();
            if (rect.top < 0 || rect.bottom > this.#windowHeight) this.#scrollToElement(target);
        });
    }
    #handleDocumentClick(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const linkEl = target.closest('a');
        if (linkEl) this.#linkHandler(event, linkEl);
    }
    #linkHandler(event, linkEl) {
        if (typeof this.scroller !== 'object' || this.scroller.scrollToAnchor === false) return;
        const href = linkEl.getAttribute('href');
        if (!href) return;
        let hrefResolved;
        try {
            hrefResolved = new URL(href, window.location.href).href;
        } catch (error) {
            return;
        }
        const hrefNoHash = hrefResolved.split('#')[0];
        const currentNoHash = window.location.href.split('#')[0];
        if ((hrefNoHash === currentNoHash || href.startsWith('#')) && href.indexOf('#') !== -1) {
            event.preventDefault();
            const hrefHash = href.split('#')[1];
            this.#scrollToElement(document.getElementById(hrefHash));
        }
    }
    #scrollToElement(el) {
        if (!el) return;
        const offsetTop = (0, $e3efffc4d0edbc40$export$ccc55dee332fd8dd)(el).top;
        const center = offsetTop - this.#windowHeight / 2;
        this.setScrollPosSoft({
            pos: center
        });
    }
    #blurWindowHandler() {
        if (typeof this.scroller !== 'object') return;
        if (this.#blockSmoothScroll == false) {
            this.#blockedScrollFromWindowBlur = true;
            this.disableSmoothScroll();
            document.body.classList.remove('body--animate-it-smoothscroll');
        }
    }
    #focusWindowHandler() {
        if (typeof this.scroller !== 'object') return;
        if (this.#blockedScrollFromWindowBlur) {
            document.body.classList.add('body--animate-it-smoothscroll');
            this.enableSmoothScroll();
            this.#blockedScrollFromWindowBlur = false;
        }
    }
    #fixReset() {
        this.#scrollTop = window.scrollY || document.documentElement.scrollTop;
        this.#scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        let i;
        for(i = 0; i < this.arWigglers.length; i++)if (this.arWigglers[i].slowScroll) {
            this.arWigglers[i].startY = 0;
            this.arWigglers[i].tempY = -this.#scrollTop;
            this.arWigglers[i].targetY = 0;
            this.arWigglers[i].elY = -this.#scrollTop;
            this.arWigglers[i].startX = 0;
            this.arWigglers[i].tempX = this.#scrollLeft;
            this.arWigglers[i].targetX = 0;
            this.arWigglers[i].elX = this.#scrollLeft;
        }
        for(i = 0; i < this.arFollowers.length; i++){
            let startY;
            if (this.arFollowers[i].scrollSmear && !this.#isTouch) startY = this.#mouseY + this.#scrollTop;
            else startY = this.#mouseY;
            const startX = this.#mouseX + this.#scrollLeft;
            this.arFollowers[i].tempY = startY;
            this.arFollowers[i].targetY = startY;
            this.arFollowers[i].elY = startY;
            this.arFollowers[i].tempX = startX;
            this.arFollowers[i].targetX = startX;
            this.arFollowers[i].elX = startX;
        }
    }
    #observerResize() {
        if ((this.#windowWidth != this.#prevObserverWidth || this.#windowHeight != this.#prevObserverHeight) && this.#prevObserverWidth != 0) {
            this.#prevObserverWidth = this.#windowWidth;
            this.#prevObserverHeight = this.#windowHeight;
            return;
        }
        this.#prevObserverWidth = this.#windowWidth;
        this.#prevObserverHeight = this.#windowHeight;
        this.resizeHandler(true);
    }
    #observerHandler() {
        if (!this.blockResizeObserver) requestAnimationFrame(()=>this.#observerResize());
    }
    #loadHandler() {
        this.resizeHandler(true);
    }
    #handleMouseOver(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const interactiveEls = 'button, a, input, label, textarea, select, *[role="button"], .swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
        const frameEls = 'iframe, input[type="file"]';
        if (target.closest(interactiveEls)) for(let i = 0; i < this.arFollowers.length; i++)this.arFollowers[i].element.classList.add('animate-it-mouse--hover');
        if (target.closest(frameEls)) for(let i = 0; i < this.arFollowers.length; i++)this.arFollowers[i].element.classList.add('animate-it-mouse--hidden');
    }
    #handleMouseOut(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const interactiveEls = 'button, a, input, label, textarea, select, *[role="button"], .swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
        const frameEls = 'iframe, input[type="file"]';
        if (target.closest(interactiveEls)) for(let i = 0; i < this.arFollowers.length; i++)this.arFollowers[i].element.classList.remove('animate-it-mouse--hover');
        if (target.closest(frameEls)) for(let i = 0; i < this.arFollowers.length; i++)this.arFollowers[i].element.classList.remove('animate-it-mouse--hidden');
    }
    #handleMouseLeave(event) {
        const from = event.relatedTarget || event.toElement;
        if (!from || from.nodeName == 'HTML') for(let i = 0; i < this.arFollowers.length; i++)this.arFollowers[i].element.classList.add('animate-it-mouse--hidden');
    }
    #handleMouseEnterDocument() {
        for(let i = 0; i < this.arFollowers.length; i++)this.arFollowers[i].element.classList.remove('animate-it-mouse--hidden');
    }
}


// Switcher V2.1
// used for resizing a parent when the content has switched to a new element
// also copy _switcher.scss
// init: switcher = new Switcher(); switcher.init();
// usage: 
// <button data-switcher-target="name" data-nr="0"></button>
// <div class="switcher" data-switcher="name" data-can-close="true">
//   <div class="switcher__item" data-switcher="name" data-nr="0">
//   <!-- content -->
//   </div><!-- switcher__item -->
// </div><!-- switcher -->
// add switcher__item--hidden to start an element hidden
// set data-can-close to false to prevent closing the switcher when clicking the same button again, set to true to allow closing it (so all items will be hidden)
// there can be multiple switcher elements with the same name on the page, to replace different content at the same time
// required properties:
// none
// possible properties:
// duration = 400: set to transition in ms, set to --switcher-duration
// startCallback = '': called when the switcher is started, returns a NodeList of the switcher elements that will be changed
// afterFadeOutCallback = '': called after fading out, returns the switcher element
// afterResizeCallback = '': called after resizing when all is done, returns the switcher element
// methods:
// switcher.init(): attach listeners/observer and set the initial height
// switcher.destroy(): remove listeners/observer
// switcher.switchTo(target, nr): programmatically trigger a switch
// changelog:
// 1.0 initial version
// 1.1 added startcallback
// 1.2 startCallback now returns the switcher elements. afterFadeOutCallback and afterResizeCallback now return the switcher element that was changed
// 1.3 replace elFromEvent function with inline event.target.closest calls
// 1.4 before switching, check if previous element's height changed
// 1.4.1 fix safari bug where it doesn't fade correctly
// 1.5 add data-can-close option to switcher element, so if the same button is clicked again, it will close the switcher instead of doing nothing
// 1.5.1 remove timeout when there is no open element, so it switches immediately
// 2.0 breaking: move startup side effects out of the constructor into init(), add destroy(), and split internal logic into private methods
// 2.1 add public switchTo(target, nr) method
class $109fd3484ed6546c$export$2e2bcd8739ae039 {
    #blockResizeObserver;
    #resizeObserver;
    #boundSetResize;
    #boundObserverHandler;
    #boundHandleClick;
    #boundHandleChange;
    constructor({ duration: duration = 400, startCallback: startCallback = '', afterFadeOutCallback: afterFadeOutCallback = '', afterResizeCallback: afterResizeCallback = '' } = ''){
        // console.log('Switcher');
        // user variables -----------------------------------------------
        this.duration = duration;
        this.startCallback = startCallback;
        this.afterFadeOutCallback = afterFadeOutCallback;
        this.afterResizeCallback = afterResizeCallback;
        // code variables -----------------------------------------------
        this.#blockResizeObserver = false;
        this.#resizeObserver = undefined;
        this.#boundSetResize = this.#setResize.bind(this);
        this.#boundObserverHandler = this.#observerHandler.bind(this);
        this.#boundHandleClick = this.#handleClick.bind(this);
        this.#boundHandleChange = this.#handleChange.bind(this);
    }
    init = ()=>{
        document.body.addEventListener('click', this.#boundHandleClick);
        document.body.addEventListener('change', this.#boundHandleChange);
        if (window.visualViewport) window.visualViewport.addEventListener('resize', this.#boundSetResize);
        this.#setResize();
        const el = document.querySelector('body');
        if (el) {
            this.#resizeObserver = new ResizeObserver(this.#boundObserverHandler);
            this.#resizeObserver.observe(el);
        }
    };
    switchTo = (target, nr)=>{
        this.#setSwitcher(target, nr);
    };
    destroy = ()=>{
        document.body.removeEventListener('click', this.#boundHandleClick);
        document.body.removeEventListener('change', this.#boundHandleChange);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', this.#boundSetResize);
        if (this.#resizeObserver) this.#resizeObserver.disconnect();
    };
    #setResize() {
        // console.log('setResize');
        const switcherEls = document.querySelectorAll('.switcher');
        switcherEls.forEach((switcherEl)=>{
            const action = switcherEl.getAttribute('data-switcher');
            const activeItemEl = switcherEl.querySelector(`.switcher__item[data-switcher="${action}"]:not(.switcher__item--hidden)`);
            if (activeItemEl) {
                const activeTextHeight = activeItemEl.offsetHeight;
                // console.log({activeTextHeight});
                switcherEl.style.setProperty('--switcher-scroll-height', activeTextHeight + 'px');
            } else switcherEl.style.setProperty('--switcher-scroll-height', "0px");
        });
    }
    #observerHandler() {
        // console.log('observerHandler');
        // after possible site specific resize calculations
        if (!this.#blockResizeObserver) setTimeout(this.#boundSetResize, 100);
    }
    #setSwitcher(target, nr) {
        const switcherEls = document.querySelectorAll(`.switcher[data-switcher="${target}"]`);
        if (typeof this.startCallback == 'function') this.startCallback(switcherEls);
        // console.log({target, nr, switcherEls});
        this.#blockResizeObserver = true;
        switcherEls.forEach((switcherEl)=>{
            const prevItemEl = switcherEl.querySelector(`.switcher__item[data-switcher="${target}"]:not(.switcher__item--hidden)`);
            const prevNr = prevItemEl ? prevItemEl.getAttribute('data-nr') : null;
            const fadeOutDuration = prevItemEl ? this.duration : 0;
            if (prevNr == nr && switcherEl.getAttribute('data-can-close') !== 'true') return;
            if (fadeOutDuration > 0) switcherEl.classList.add('switcher--faded-out');
            // so height is correct before switcher for if content changed
            this.#setResize();
            setTimeout(()=>{
                const itemEls = switcherEl.querySelectorAll(`.switcher__item[data-switcher="${target}"]`);
                itemEls.forEach((itemEl)=>{
                    itemEl.classList.add('switcher__item--hidden');
                });
                if (prevNr !== nr) {
                    const itemEl = switcherEl.querySelector(`.switcher__item[data-switcher="${target}"][data-nr="${nr}"]`);
                    // console.log({itemEl});
                    if (itemEl) itemEl.classList.remove('switcher__item--hidden');
                }
                switcherEl.classList.remove('switcher--faded-out');
                switcherEl.classList.add('switcher--resizing'); // resize holder to new size
                requestAnimationFrame(this.#boundSetResize); // wuut
                if (typeof this.afterFadeOutCallback == 'function') this.afterFadeOutCallback(switcherEl);
            }, fadeOutDuration);
            setTimeout(()=>{
                switcherEl.classList.remove('switcher--resizing');
                this.#blockResizeObserver = false;
                if (typeof this.afterResizeCallback == 'function') this.afterResizeCallback(switcherEl);
            }, fadeOutDuration + this.duration);
        });
    }
    #handleClick(event) {
        const el = event.target.closest('button[data-switcher-target], input[data-switcher-target]');
        if (!el) return;
        const target = el.getAttribute('data-switcher-target');
        const nr = el.getAttribute('data-nr');
        const hasClosableSwitcher = document.querySelector(`.switcher[data-switcher="${target}"][data-can-close="true"]`) !== null;
        const otherEls = document.querySelectorAll(`button[data-switcher-target="${target}"], input[data-switcher-target="${target}"]`);
        otherEls.forEach((otherEl)=>{
            if (otherEl == el) otherEl.dataset.active = el.dataset.active === '1' && hasClosableSwitcher ? '0' : '1';
            else otherEl.dataset.active = '0';
        });
        this.#setSwitcher(target, nr);
    }
    #handleChange(event) {
        const el = event.target.closest('select[data-switcher-target]');
        if (!el) return;
        const target = el.getAttribute('data-switcher-target');
        const nr = el.value;
        this.#setSwitcher(target, nr);
    }
}


// Split v1.14
// Breaks text holder elements into individual letter/word/line span parts.
// usage:
// uses these default selectors:
// characters = '.split-chars',
// words = '.split-words',
// lines = '.split-lines',
// splitter = new Split();
// add this sass to custom selectors: &:not(:has(.split)) { visibility: hidden; } 
// to prevent showing un-split content before js is loaded. For the default selectors, this is already in the css.
// possible properties:
// charTiming = { delay: 0, stagger: 50 }: delay config object for character splits
// wordTiming = { delay: 0, stagger: 100 }: delay config object for word splits 
// lineTiming = { delay: 0, stagger: 200 }: delay config object for line splits
// charHolderSelector = '.chars': selector for holders that should split into characters
// wordHolderSelector = '.words': selector for holders that should split into words
// lineHolderSelector = '.lines': selector for holders that should split into visual lines
// replacedChar = '±': placeholder used while splitting HTML tags safely
// textClass = 'fader fader--up': classes applied to text split parts
// imgClass = 'fader fader--loader': classes applied to image split parts
// isSafari = false: skip splitting holders with SVG filters on Safari and fade the whole holder instead
// methods:
// splitter.setSplitters(): need to be called after new content is added to the page
// splitter.destroy(): remove resize listener
// helper notes:
// add no-split-delay class to holder element to skip stagger delay
// is not using default selectors, add &:not(:has(.split)) { visibility: hidden; } to the holder element in css to prevent showing un-split content before js is loaded. For the default selectors, this is already in the css.
// changelog:
// 1.0: initial version
// 1.1: some cleanup 
// 1.2: fix for splitting an element twice
// 1.3: output data-fader-delay attribute even when delay is 0
// 1.4: remove fader--force, not needed from fader 9.0
// 1.5: make internal methods private, keep setSplitters as public API
// 1.6: tiny cleanup, remove getElementTop helper that is not used anymore
// 1.7: add destroy(), fix noDelayClass not assigned to this
// 1.8: wrap split chars per word so words don't get separated when they wrap
// 1.9: add Safari fallback for holders with svg filters, fade the whole holder instead of splitting
// 1.10: on split chars, a break now also creates a new word wrapper
// 1.11: add split-space--no-width when a space starts a wrapped line
// 1.12: use split-space elements between split words instead of css word spacing
// 1.13: trim leading and trailing whitespace so surrounding spaces are ignored during splitting
// 1.14: collapse repeated whitespace runs to a single space before splitting

class $e21bfd3f9dbb41e9$export$2e2bcd8739ae039 {
    #boundResize;
    constructor({ charHolderSelector: charHolderSelector = '.split-chars', wordHolderSelector: wordHolderSelector = '.split-words', lineHolderSelector: lineHolderSelector = '.split-lines', replacedChar: replacedChar = "\xb1", charTiming: charTiming = {
        delay: 0,
        stagger: 50
    }, wordTiming: wordTiming = {
        delay: 0,
        stagger: 100
    }, lineTiming: lineTiming = {
        delay: 0,
        stagger: 200
    }, textClass: textClass = 'fader fader--up', imgClass: imgClass = 'fader fader--loader', isSafari: isSafari = false } = {}){
        // config variables
        this.charHolderSelector = charHolderSelector;
        this.wordHolderSelector = wordHolderSelector;
        this.lineHolderSelector = lineHolderSelector;
        this.replacedChar = replacedChar;
        this.charTiming = charTiming;
        this.wordTiming = wordTiming;
        this.lineTiming = lineTiming;
        this.textClass = textClass;
        this.imgClass = imgClass;
        this.isSafari = isSafari;
        // code variables
        this.noDelayClass = 'no-split-delay';
        this.#boundResize = ()=>requestAnimationFrame(()=>this.#resize());
        window.visualViewport.addEventListener('resize', this.#boundResize);
    }
    destroy = ()=>{
        window.visualViewport.removeEventListener('resize', this.#boundResize);
    };
    setSplitters = ()=>{
        const charHolderEls = document.body.querySelectorAll(this.charHolderSelector);
        const wordHolderEls = document.body.querySelectorAll(this.wordHolderSelector);
        const lineHolderEls = document.body.querySelectorAll(this.lineHolderSelector);
        this.#splitChars(charHolderEls);
        this.#splitWords(wordHolderEls, this.wordTiming);
        this.#splitWords(lineHolderEls, this.lineTiming || this.wordTiming);
    };
    #resize() {
        const lineHolderEls = document.body.querySelectorAll(this.lineHolderSelector);
        const charHolderEls = document.body.querySelectorAll(this.charHolderSelector);
        const wordHolderEls = document.body.querySelectorAll(this.wordHolderSelector);
        const spaceHolderEls = new Set([
            ...charHolderEls,
            ...wordHolderEls,
            ...lineHolderEls
        ]);
        lineHolderEls.forEach((holderEl)=>{
            let line = 0;
            let prevTop = 0;
            const partsEls = holderEl.querySelectorAll('.split__text, .split__img');
            partsEls.forEach((partEl)=>{
                const top = (0, $e3efffc4d0edbc40$export$ccc55dee332fd8dd)(partEl).top;
                if (top > prevTop) line++;
                prevTop = top;
                partEl.dataset.faderDelay = this.#getDelay(holderEl, this.lineTiming, line);
            });
        });
        spaceHolderEls.forEach((holderEl)=>{
            let prevTop;
            const splitEls = holderEl.querySelectorAll('.split-word, .split-space');
            splitEls.forEach((splitEl)=>splitEl.classList.remove('split-space--no-width'));
            splitEls.forEach((splitEl)=>{
                const top = (0, $e3efffc4d0edbc40$export$ccc55dee332fd8dd)(splitEl).top;
                if (splitEl.classList.contains('split-space') && prevTop !== undefined && top > prevTop) splitEl.classList.add('split-space--no-width');
                prevTop = top;
            });
        });
    }
    #splitChars(holderEls) {
        holderEls.forEach((holderEl)=>{
            if (this.#shouldFadeHolder(holderEl)) {
                holderEl.classList.add('fader');
                holderEl.style.visibility = 'visible';
                return;
            }
            if (holderEl.querySelector('.split')) return;
            let staggerTotal = 0;
            let newHtml = '<div class="split-word">';
            const tokens = holderEl.innerHTML.split(/(<br\s*\/?>)/i);
            tokens.forEach((token)=>{
                const normalizedToken = this.#normalizeToken(token);
                if (!normalizedToken) return;
                if (normalizedToken.match(/<br\s*\/?>/i)) {
                    newHtml += `</div><span class="split-break"></span><div class="split-word">`;
                    return;
                }
                const tempEl = document.createElement('div');
                tempEl.innerHTML = normalizedToken;
                const letters = tempEl.textContent.split('');
                letters.forEach((letter)=>{
                    if (letter === ' ') newHtml += `</div><span class="split-space">&nbsp;</span><div class="split-word">`;
                    else {
                        const delay = this.#getDelay(holderEl, this.charTiming, staggerTotal);
                        // console.log({ letter, delay });
                        newHtml += `<span class="split">`;
                        newHtml += `<div class="split__text ${this.textClass}"${delay !== '' ? ` data-fader-delay="${delay}"` : ''}>${letter}</div>`;
                        newHtml += `</span> `;
                        staggerTotal++;
                    }
                });
            });
            newHtml += '</div>';
            holderEl.innerHTML = newHtml;
        });
    }
    #splitWords(holderEls, delayConfig) {
        holderEls.forEach((holderEl)=>{
            if (this.#shouldFadeHolder(holderEl)) {
                holderEl.classList.add('fader');
                holderEl.style.visibility = 'visible';
                return;
            }
            if (holderEl.querySelector('.split')) return;
            let staggerTotal = 0;
            const tokens = holderEl.innerHTML.split(/(<br\s*\/?>)/i);
            let newHtml = '';
            tokens.forEach((token)=>{
                const normalizedToken = this.#normalizeToken(token);
                if (!normalizedToken) return;
                if (normalizedToken.match(/<br\s*\/?>/i)) newHtml += `<span class="split-break"></span>`;
                else {
                    const parts = normalizedToken.split(' ').filter((part)=>part.length > 0);
                    parts.forEach((part, index)=>{
                        if (index > 0) newHtml += '<span class="split-space">&nbsp;</span>';
                        const delay = this.#getDelay(holderEl, delayConfig, staggerTotal);
                        // console.log({ word: part, delay });
                        newHtml += `<div class="split-word"><span class="split split--word">`;
                        if (part === this.replacedChar) {
                            const src = holderEl.dataset.src || '';
                            const width = holderEl.dataset.width || '1';
                            const alignment = holderEl.dataset.alignment || 'center';
                            newHtml += `  <img class="split__img split__img--${alignment} ${this.imgClass}" data-src="${src}" decoding="async" style="--width: ${width};"${delay !== '' ? ` data-fader-delay="${delay}"` : ''}>`;
                        } else newHtml += `  <div class="split__text ${this.textClass}"${delay !== '' ? ` data-fader-delay="${delay}"` : ''}>${part}</div>`;
                        newHtml += `</span></div>`;
                        staggerTotal++;
                    });
                }
            });
            holderEl.innerHTML = newHtml;
        });
        // call resize to set line numbers for the word splitters, so they can use that for delay if wanted
        this.#resize();
    }
    #normalizeToken(token) {
        return token.trim().replace(/\s+/g, ' ');
    }
    #getDelay(holderEl, delayConfig, index) {
        if (holderEl.classList.contains(this.noDelayClass) || !delayConfig) return '';
        return (delayConfig.delay || 0) + index * (delayConfig.stagger || 0);
    }
    #shouldFadeHolder(holderEl) {
        return this.isSafari && this.#hasSvgFilter(holderEl);
    }
    #hasSvgFilter(holderEl) {
        const inlineStyle = holderEl.getAttribute('style') || '';
        if (/filter:\s*url\(/i.test(inlineStyle) || /-webkit-filter:\s*url\(/i.test(inlineStyle)) return true;
        const computedStyle = window.getComputedStyle(holderEl);
        const filter = computedStyle.getPropertyValue('filter');
        const webkitFilter = computedStyle.getPropertyValue('-webkit-filter');
        return /url\(/i.test(filter) || /url\(/i.test(webkitFilter);
    }
}


// History V3.15
// used to load pages through ajax
// stores loaded pages in sessionStorage
// remembers what pages are present in which elements
// init: history = new History({ cookiesPrefix: 'myproject_' });
// then call: history.init();
// requires these globals to be set before each page switch (e.g. in #vars script):
// $pageType: string — current page type, set on body as data-pagetype
// $historySelector: string — selector of the element to swap content into (e.g. '.main')
// $wcPages: array (optional) — list of WooCommerce URL fragments that should use default navigation
// required properties:
// cookiesPrefix: prefix used for localStorage keys (e.g. 'myproject_')
// possible properties:
// useCache = false: cache full page HTML in sessionStorage for instant back/forward
// projectTitle: default document title used for history.pushState, defaults to current document.title
// viewTransitions = false: use the View Transitions API when swapping page content
// excludedHrefParts = []: additional href fragments that should always use default navigation
// popstateCaptureUrls = []: urls that should be intercepted on popstate (browser buttons) instead of ajax loading
// capturePopstate = url => {}: callback called with the new popstate url when it is intercepted. Only happens when using browser buttons.
// setScrollTop = () => {}: function called to set scroll position (e.g. animateIt.setScrollPosHard)
// samePage = () => {}: called when a link to the current page (same URL) is clicked
// animateBefore = setDoneAnimating => setDoneAnimating(): called to run an exit animation before swapping content, must call the passed callback when done
// beforeSwitch = () => {}: called just before the DOM is swapped
// newContent = () => {}: called after new content is placed in the DOM and scripts are executed
// afterSetScroll = () => {}: called after setting the scroll position, so scroll dependant position are correct
// loadEventDelay = 400: ms after content swap before a synthetic load event is dispatched (for fader etc.)
// resetLineDelay = 800: delay in ms before resetting the loader line back to default after load
// methods:
// history.init(): attach all click/submit/popstate/scroll listeners — call once on page load
// history.destroy(): remove all listeners
// history.navigateTo(url): programmatically navigate to a url
// history.setPageTypeNext(type): set the next page type ahead of a link click
// history.initLoadPage(): manually trigger loading of window.location.href
// history.checkWoocommerce(url): returns true if url should use default navigation
// history.addExcludedHrefParts(parts): append href fragments to default-navigation exclusion list
// history.setExcludedHrefParts(parts): replace href fragment exclusions
// changelog:
// 3.0 initial version
// 3.1 basic fixes
// 3.2 remove redundant history prefixes from class state/api, add loader line naming cleanup
// 3.3 make init the only public method, keep the rest private
// 3.4 restore setPageTypeNext and initLoadPage as public project hooks
// 3.5 expose historyCheckWoocommerce as public method (was unreachable as module-level function)
// 3.6 add destroy(), extract anonymous listeners into private methods so they can be removed
// 3.7 add navigateTo(url) for programmatic navigation
// 3.8 remove checkWoocommerce wrapper, changed order and timeouts
// 3.9 split callbacks to newContent (after DOM swap) and afterSetScroll (after setting scroll) for more granular control, like in Page.setPage and Page.setPageAfterSetScroll
// 3.10 add option to capture popstate on specific urls and do other things than loading a page
// 3.11 #setHistory in view transition, so changes animate
// 3.12 remove adding 'popover' to url, cleanup same page check, add checkSamePage method
// 3.13 make link exclusion fragments configurable via constructor + public methods
// 3.14 apply setSavedScroll during init so refresh restores saved scroll position
// 3.15 skip setting scroll to top if the content was already in the dom
const $7cc9ee14c2971c5c$var$isExternalLink = (url)=>{
    const tmp = document.createElement('a');
    tmp.href = url;
    return tmp.host !== window.location.host;
};
const $7cc9ee14c2971c5c$var$executeScript = (html, el)=>{
    if (!el) return;
    const scriptEl = document.createElement('script');
    scriptEl.innerHTML = html;
    el.innerHTML = '';
    el.appendChild(scriptEl);
};
class $7cc9ee14c2971c5c$export$2e2bcd8739ae039 {
    #boundSaveScroll;
    #boundBeforeUnload;
    #boundPopstate;
    #boundSubmit;
    #boundClick;
    constructor({ useCache: useCache = false, projectTitle: projectTitle, viewTransitions: viewTransitions = false, excludedHrefParts: excludedHrefParts = [], popstateCaptureUrls: popstateCaptureUrls = [], capturePopstate: capturePopstate = ()=>{}, cookiesPrefix: cookiesPrefix, setScrollTop: setScrollTop = ()=>{}, samePage: samePage = ()=>{}, animateBefore: animateBefore = (setDoneAnimating)=>setDoneAnimating(), beforeSwitch: beforeSwitch = ()=>{}, newContent: newContent = ()=>{}, afterSetScroll: afterSetScroll = ()=>{}, loadEventDelay: loadEventDelay = 400, resetLineDelay: resetLineDelay = 800 } = {}){
        if (typeof cookiesPrefix === 'undefined') throw new Error('History: cookiesPrefix is a required parameter.');
        // config variables
        this.useCache = useCache;
        this.projectTitle = projectTitle || document.title;
        this.viewTransitions = viewTransitions;
        this.excludedHrefParts = [];
        this.addExcludedHrefParts(excludedHrefParts);
        this.popstateCaptureUrls = Array.isArray(popstateCaptureUrls) ? popstateCaptureUrls : [];
        this.capturePopstate = typeof capturePopstate === 'function' ? capturePopstate : ()=>{};
        this.loadEventDelay = loadEventDelay;
        this.resetLineDelay = resetLineDelay;
        this.cookiesPrefix = cookiesPrefix;
        this.setScrollTop = setScrollTop;
        this.samePage = samePage;
        this.animateBefore = animateBefore;
        this.beforeSwitch = beforeSwitch;
        this.newContent = newContent;
        this.afterSetScroll = afterSetScroll;
        // code variables
        this.currentPages = [];
        this.isSwitching = false;
        this.switchAgain = false;
        this.canSaveScroll = true;
        this.pageElement = '';
        this.doneAnimating = false;
        this.doneScrolling = false;
        this.doneLoading = false;
        this.skipScrollReset = false;
        this.hasSetHtml = false;
        this.pageTypeNext = '';
        this.pageTypePrev = '';
        this.selectorPrev = '';
        this.formData = undefined;
        this.cache = JSON.parse(sessionStorage.getItem('historyCache'));
        if (this.cache === null) this.cache = [];
        this.url = window.location.href;
        this.hasLoaded = false;
        this.usedBrowser = false;
        this.currentCacheIndex = 0;
        this.loaderEl = document.querySelector('.history-loader');
        this.#boundSaveScroll = this.#saveScroll.bind(this);
        this.#boundBeforeUnload = this.#handleBeforeUnload.bind(this);
        this.#boundPopstate = this.#handlePopstate.bind(this);
        this.#boundSubmit = this.#handleSubmit.bind(this);
        this.#boundClick = this.#handleClick.bind(this);
    }
    init = ()=>{
        document.addEventListener('scroll', this.#boundSaveScroll);
        window.addEventListener('beforeunload', this.#boundBeforeUnload);
        this.#setHistory();
        if (history.scrollRestoration) history.scrollRestoration = 'manual';
        window.addEventListener('popstate', this.#boundPopstate, false);
        document.body.addEventListener('submit', this.#boundSubmit);
        document.body.addEventListener('click', this.#boundClick);
        requestAnimationFrame(this.setSavedScroll); // after resize
    };
    destroy = ()=>{
        document.removeEventListener('scroll', this.#boundSaveScroll);
        window.removeEventListener('beforeunload', this.#boundBeforeUnload);
        window.removeEventListener('popstate', this.#boundPopstate);
        document.body.removeEventListener('submit', this.#boundSubmit);
        document.body.removeEventListener('click', this.#boundClick);
    };
    #handleBeforeUnload() {
        sessionStorage.setItem('historyCache', JSON.stringify(this.cache));
    }
    #handlePopstate() {
        const popstateUrl = window.location.href;
        // console.log('popstate', {url: popstateUrl, state: history.state});
        if (this.#shouldCapturePopstate(popstateUrl)) {
            this.capturePopstate(popstateUrl);
            return;
        }
        if (!this.#checkDefault(popstateUrl)) {
            this.initLoadPage();
            this.usedBrowser = true;
        }
    }
    #shouldCapturePopstate(url) {
        if (!this.popstateCaptureUrls.length || !url) return false;
        const normalizedUrl = url.split('?')[0].split('#')[0];
        for(let i = 0; i < this.popstateCaptureUrls.length; i++){
            const captureUrl = this.popstateCaptureUrls[i];
            if (typeof captureUrl !== 'string') continue;
            const normalizedCaptureUrl = captureUrl.split('?')[0].split('#')[0];
            if (normalizedCaptureUrl === normalizedUrl) return true;
        }
        return false;
    }
    #handleSubmit(event) {
        const form = event.target.closest('form');
        if (!form) return;
        if (form.classList.contains('js-newsletter-form')) return;
        let action = form.getAttribute('action');
        if ($7cc9ee14c2971c5c$var$isExternalLink(action)) return;
        if (this.#checkDefault(action)) return;
        event.preventDefault();
        if (form.classList.contains('wpcf7-form') && this.hasLoaded === false) return;
        if (document.activeElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
        this.formData = new FormData(form);
        if (form.getAttribute('method') === 'get') {
            const queryString = new URLSearchParams(this.formData).toString();
            action += '?' + queryString;
            this.formData = undefined;
        } else if (action.indexOf('wpcf7') > -1) action = action.substring(0, action.indexOf('wpcf7')) + '?' + Date.now();
        else action += '?' + Date.now();
        requestAnimationFrame(()=>{
            window.history.pushState(null, this.projectTitle, action);
            this.initLoadPage();
        });
    }
    #handleClick(event) {
        const link = event.target.closest('a');
        if (!link) return;
        let href = link.getAttribute('href');
        if (!href) return;
        if (link.host === window.location.host && href.indexOf('mailto:') === -1 && href.indexOf('tel:') === -1 && !this.#isExcludedHref(href) && link.getAttribute('target') !== '_blank' && !event.ctrlKey && !event.metaKey || href.indexOf('?') === 0) {
            if (this.#checkDefault(href)) return;
            event.preventDefault();
            if (typeof link.className !== 'undefined') {
                if (link.className && link.className.indexOf('js-lang-') !== -1) {
                    localStorage.removeItem(this.cookiesPrefix + 'SetCookies');
                    location.href = href;
                    return;
                }
            }
            if (this.isSwitching) {
                window.history.pushState(null, this.projectTitle, href);
                this.initLoadPage();
                return;
            }
            if (this.#checkSamePage(href)) this.samePage(href);
            else {
                this.pageTypeNext = link.getAttribute('data-pagetype-next');
                this.setPageTypeNext(this.pageTypeNext);
                requestAnimationFrame(()=>{
                    window.history.pushState(null, this.projectTitle, href);
                    this.initLoadPage();
                });
            }
        }
    }
    #isExcludedHref(href) {
        if (!href || !this.excludedHrefParts.length) return false;
        for(let i = 0; i < this.excludedHrefParts.length; i++){
            if (href.indexOf(this.excludedHrefParts[i]) > -1) return true;
        }
        return false;
    }
    #checkSamePage(url) {
        const cleanHref = url.split('?')[0].split('#')[0];
        const cleanUrl = window.location.href.split('?')[0].split('#')[0];
        const hrefQuery = url.split('?')[1];
        const urlQuery = window.location.href.split('?')[1];
        if ((cleanHref === cleanUrl || cleanHref === '') && hrefQuery === urlQuery) return true;
        else return false;
    }
    setPageTypeNext = (type)=>{
        if (!type) type = '';
        this.pageTypeNext = type;
        document.body.setAttribute('data-pagetype-next', type);
    };
    addExcludedHrefParts = (parts)=>{
        if (!Array.isArray(parts)) return;
        for(let i = 0; i < parts.length; i++){
            const part = parts[i];
            if (typeof part !== 'string') continue;
            const trimmedPart = part.trim();
            if (!trimmedPart) continue;
            if (this.excludedHrefParts.indexOf(trimmedPart) === -1) this.excludedHrefParts.push(trimmedPart);
        }
    };
    setExcludedHrefParts = (parts)=>{
        this.excludedHrefParts = [];
        this.addExcludedHrefParts(parts);
    };
    checkWoocommerce = (url)=>{
        const currentUrl = url.split('?')[0];
        if (typeof $wcPages !== 'undefined') for(let i = 0; i < $wcPages.length; i++){
            if (currentUrl.indexOf($wcPages[i]) > -1) return true;
        }
        if (currentUrl.includes('/product/')) return true;
        return false;
    };
    navigateTo = (url)=>{
        if (this.#checkDefault(url)) {
            window.location.href = url;
            return;
        }
        if (this.#checkSamePage(url)) {
            this.samePage(url);
            return;
        }
        window.history.pushState(null, this.projectTitle, url);
        this.initLoadPage();
    };
    initLoadPage = ()=>{
        // console.log('initLoadPage', {url: window.location.href});
        this.usedBrowser = false;
        if (this.isSwitching) {
            this.switchAgain = true;
            return;
        }
        this.url = window.location.href;
        this.isSwitching = true;
        this.canSaveScroll = false;
        this.skipScrollReset = false;
        for(let i = 0; i < this.currentPages.length; i++)if (this.url === this.currentPages[i].url) {
            // console.log('page in dom, skipping load', this.url);
            this.skipScrollReset = true;
            this.beforeSwitch();
            this.#checkSwitch();
            $7cc9ee14c2971c5c$var$executeScript(this.currentPages[i].script, document.querySelector('#vars'));
            const swapDomFast = ()=>{
                this.#setHistory(); // sets pagetype, updates cache, sets current page
                this.#endLoading();
            };
            if ('startViewTransition' in document && this.viewTransitions) document.startViewTransition(swapDomFast);
            else swapDomFast();
            return;
        }
        if (this.loaderEl) this.loaderEl.dataset.status = 'start';
        document.documentElement.classList.add('html--loader');
        this.doneAnimating = false;
        this.doneScrolling = true;
        this.doneLoading = false;
        this.hasSetHtml = false;
        this.hasLoaded = true;
        this.animateBefore(()=>this.#setDoneAnimating());
        this.#loadPage(this.url);
    };
    #setHistory() {
        // console.log('setHistory', {$pageType});
        document.body.setAttribute('data-pagetype', $pageType);
        document.body.setAttribute('data-pagetype-next', '');
        this.pageTypeNext = '';
        if (!this.#isCached(window.location.href)) {
            const page = {
                url: window.location.href,
                scroll: 0
            };
            if (this.useCache) page.html = document.documentElement.innerHTML;
            this.cache.push(page);
            sessionStorage.setItem('historyCache', JSON.stringify(this.cache));
        }
        this.#setCurrent();
        for(let i = 0; i < this.cache.length; i++)if (window.location.href === this.cache[i].url) this.currentCacheIndex = i;
    }
    #checkDefault(url) {
        if (!url) return true;
        let cleanUrl = url.split('?')[0].split('#')[0];
        if (cleanUrl === '') cleanUrl = window.location.href;
        if (this.checkWoocommerce(cleanUrl) || this.checkWoocommerce(window.location.href) || typeof hasProducts !== 'undefined' && hasProducts || cleanUrl.indexOf('add-to-cart') > -1 || document.querySelector(`a[href="${url}"][hreflang]`)) return true;
        return false;
    }
    #loadPage(url) {
        if (typeof this.formData === 'object') {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.onload = ()=>this.#setDoneLoading(xhr, url);
            xhr.send(this.formData);
        } else if (this.useCache && this.#isCached(url)) {
            for(let i = 0; i < this.cache.length; i++)if (url === this.cache[i].url) {
                this.pageElement = document.createElement('div');
                this.pageElement.innerHTML = this.cache[i].html;
                this.#setDoneLoading({
                    status: 'cache'
                }, url);
            }
        } else {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.onload = ()=>this.#setDoneLoading(xhr, url);
            xhr.send();
        }
    }
    #setDoneLoading(xhr, url) {
        if (this.loaderEl) this.loaderEl.dataset.status = 'loading-done';
        if (xhr.status !== 'cache') {
            this.pageElement = document.createElement('div');
            this.pageElement.innerHTML = xhr.response;
        }
        if (xhr.responseURL) {
            const cleanRequestedUrl = url.split('?')[0].split('#')[0];
            const cleanResponseUrl = xhr.responseURL.split('?')[0].split('#')[0];
            if (cleanResponseUrl !== cleanRequestedUrl) // console.warn('Response URL differs from requested URL:', {requestedUrl: url, responseUrl: xhr.responseURL});
            window.history.pushState(null, this.projectTitle, xhr.responseURL);
        }
        this.doneLoading = true;
        this.formData = undefined;
        if (this.doneScrolling && this.doneAnimating) this.#setHtml();
    }
    #setDoneScrolling() {
        if (this.loaderEl) this.loaderEl.dataset.status = 'scrolling-done';
        this.doneScrolling = true;
        if (this.doneLoading && this.doneAnimating) this.#setHtml();
    }
    #setDoneAnimating() {
        if (this.loaderEl) this.loaderEl.dataset.status = 'animation-done';
        this.doneAnimating = true;
        if (this.doneLoading && this.doneScrolling) this.#setHtml();
    }
    #setHtml() {
        // console.log('setHtml', 'old pageType:', $pageType);
        if (this.hasSetHtml) return;
        this.hasSetHtml = true;
        this.beforeSwitch();
        this.pageTypePrev = $pageType;
        this.selectorPrev = $historySelector;
        if (this.#checkSwitch()) return;
        let el = document.createElement('textarea');
        const titleEl = this.pageElement.querySelector('title');
        if (el && titleEl) el.innerHTML = titleEl.innerHTML;
        document.title = el.value;
        const varsScript = this.pageElement.querySelector('#vars script');
        if (varsScript) $7cc9ee14c2971c5c$var$executeScript(varsScript.innerHTML, document.querySelector('#vars'));
        // console.log('new pageType:', $pageType);
        const swapDom = ()=>{
            // console.log('swapping DOM');
            el = document.querySelector($historySelector);
            if (el) {
                const sourceEl = this.pageElement.querySelector($historySelector);
                if (sourceEl) el.innerHTML = sourceEl.innerHTML;
                const scriptEls = el.querySelectorAll('script');
                scriptEls.forEach((scriptEl)=>{
                    $7cc9ee14c2971c5c$var$executeScript(scriptEl.innerHTML, scriptEl);
                });
            }
            // must be here, because startViewTransition is async function
            if ($historySelector === '.items') $historySelector = '.main';
            this.#setHistory(); // sets pagetype, updates cache, sets current page
            this.#endLoading();
        };
        if ('startViewTransition' in document && this.viewTransitions) document.startViewTransition(swapDom);
        else swapDom();
    }
    #endLoading() {
        // console.log('history end loading');
        this.pageElement = undefined;
        this.newContent(); // external callback. often setPage
        if (this.loaderEl) this.loaderEl.dataset.status = 'new-content';
        const isSameMainSelector = $historySelector === '.main' && this.selectorPrev === '.main';
        if (isSameMainSelector) {
            if (this.usedBrowser) this.setSavedScroll();
            else if (!this.skipScrollReset) this.setScrollTop(0);
        } else {
            const el = document.querySelector($historySelector);
            if (el) el.scrollTo(0, 0);
        }
        this.canSaveScroll = true;
        if (!this.skipScrollReset) this.#saveScroll();
        this.skipScrollReset = false;
        this.afterSetScroll(); // external callback, often setPageAfterSetScroll, must be called after setting scroll
        setTimeout(()=>{
            if (this.loaderEl) this.loaderEl.dataset.status = 'end';
            document.documentElement.classList.remove('html--loader');
            dispatchEvent(new Event('load'));
        }, this.loadEventDelay);
        setTimeout(()=>{
            if (this.loaderEl) this.loaderEl.dataset.status = '';
        }, this.resetLineDelay);
    }
    #checkSwitch() {
        this.isSwitching = false;
        if (this.switchAgain) {
            this.switchAgain = false;
            this.initLoadPage();
            return true;
        }
        return false;
    }
    #setCurrent() {
        const varsScript = document.querySelector('#vars script');
        const currentPage = {
            url: this.url,
            script: varsScript ? varsScript.innerHTML : '',
            selector: $historySelector
        };
        let hasCurrent = false;
        for(let i = 0; i < this.currentPages.length; i++)if ($historySelector === this.currentPages[i].selector) {
            this.currentPages[i] = currentPage;
            hasCurrent = true;
        }
        if (!hasCurrent) this.currentPages.push(currentPage);
    }
    #isCached(url) {
        let inCache = false;
        for(let i = 0; i < this.cache.length; i++)if (url === this.cache[i].url) inCache = true;
        return inCache;
    }
    #saveScroll() {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        if (!this.isSwitching && this.canSaveScroll && this.cache[this.currentCacheIndex]) this.cache[this.currentCacheIndex].scroll = scrollY;
    }
    setSavedScroll = ()=>{
        let loadedCacheIndex;
        for(let i = 0; i < this.cache.length; i++)if (window.location.href === this.cache[i].url) loadedCacheIndex = i;
        // console.log('setSavedScroll', {loadedCacheIndex, cache: this.cache}); 
        if (typeof loadedCacheIndex === 'undefined') return;
        const savedScroll = this.cache[loadedCacheIndex].scroll;
        // console.log('setting saved scroll', savedScroll);
        this.setScrollTop(savedScroll);
    };
}


// VtOutOfView V1.2
// disables view-transition-name on elements outside the viewport
// init:
// vtOutOfView = new VtOutOfView();
// vtOutOfView.init();
// usage:
// set data-vt-name="your-name" and style="view-transition-name: your-name;" in templates
// view-transition-name is needed in the template, because only setting it later breaks the vt
// call vtOutOfView.init() once so it listens to scroll/resize and checks automatically
// optionally call vtOutOfView.refreshElements() when content changes
// required properties:
// none
// possible properties:
// selector = '[data-vt-name]': selector used to gather tracked VT elements
// listenToScroll = true: run checks on window scroll
// listenToResize = true: run checks on window resize
// listenToMutations = true: run checks when DOM mutations happen
// methods:
// vtOutOfView.init(): gather initial elements and attach listeners
// vtOutOfView.destroy(): remove listeners
// vtOutOfView.scheduleCheck({refreshElements}): debounce checks into one animation frame
// vtOutOfView.refreshElements(): query and update tracked elements using this.selector
// vtOutOfView.setElements(elements): update tracked elements
// vtOutOfView.check(): toggle view-transition-name based on viewport
// vtOutOfView.checkSync({refreshElements}): run check immediately, bypassing rAF (use before pageswap/pagehide)
// changelog:
// 1.0 initial version
// 1.1 add debounced check scheduler and filtered mutation observer
// 1.2 add checkSync for synchronous pre-snapshot checks
class $5ed1486d1d2cc343$export$2e2bcd8739ae039 {
    constructor({ selector: selector = '[data-vt-name]', listenToScroll: listenToScroll = true, listenToResize: listenToResize = true, listenToMutations: listenToMutations = true } = {}){
        this.selector = selector;
        this.listenToScroll = listenToScroll;
        this.listenToResize = listenToResize;
        this.listenToMutations = listenToMutations;
        this.elements = [];
        this.initialized = false;
        this.checkQueued = false;
        this.shouldRefreshElements = false;
        this.frameId = 0;
        this.mutationObserver = undefined;
        this.boundScheduleCheck = this.scheduleCheck.bind(this);
        this.boundHandleMutations = this.handleMutations.bind(this);
    }
    init = ()=>{
        if (this.initialized) return;
        if (this.listenToScroll) window.addEventListener('scroll', this.boundScheduleCheck, {
            passive: true
        });
        if (this.listenToResize) window.addEventListener('resize', this.boundScheduleCheck, {
            passive: true
        });
        if (this.listenToMutations) {
            this.mutationObserver = new MutationObserver(this.boundHandleMutations);
            this.mutationObserver.observe(document.body, {
                attributes: true,
                attributeFilter: [
                    'class',
                    'style',
                    'hidden',
                    'aria-hidden',
                    'data-vt-name'
                ],
                childList: true,
                subtree: true
            });
        }
        this.initialized = true;
        this.scheduleCheck({
            refreshElements: true
        });
    };
    destroy = ()=>{
        if (!this.initialized) return;
        if (this.listenToScroll) window.removeEventListener('scroll', this.boundScheduleCheck);
        if (this.listenToResize) window.removeEventListener('resize', this.boundScheduleCheck);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.frameId) {
            cancelAnimationFrame(this.frameId);
            this.frameId = 0;
        }
        this.checkQueued = false;
        this.shouldRefreshElements = false;
        this.initialized = false;
    };
    scheduleCheck = ({ refreshElements: refreshElements = false } = {})=>{
        if (refreshElements) this.shouldRefreshElements = true;
        if (this.checkQueued) return;
        this.checkQueued = true;
        this.frameId = requestAnimationFrame(()=>{
            this.checkQueued = false;
            this.frameId = 0;
            if (this.shouldRefreshElements) {
                this.elements = Array.from(document.querySelectorAll(this.selector));
                this.shouldRefreshElements = false;
            }
            this.check();
        });
    };
    handleMutations = (mutations)=>{
        let refreshElements = false;
        for (const mutation of mutations){
            if (mutation.type === 'childList') {
                refreshElements = true;
                break;
            }
            if (mutation.type === 'attributes') {
                const attrName = mutation.attributeName;
                if (attrName === 'data-vt-name') refreshElements = true;
                if (refreshElements) break;
            }
        }
        this.scheduleCheck({
            refreshElements: refreshElements
        });
    };
    refreshElements = ()=>{
        this.scheduleCheck({
            refreshElements: true
        });
    };
    checkSync = ({ refreshElements: refreshElements = false } = {})=>{
        if (refreshElements) {
            this.elements = Array.from(document.querySelectorAll(this.selector));
            this.shouldRefreshElements = false;
        }
        this.check();
    };
    setElements = (elements = [])=>{
        this.elements = Array.from(elements);
        this.scheduleCheck();
    };
    check = ()=>{
        this.elements.forEach((vtEl)=>{
            const vtName = vtEl.dataset.vtName;
            if (!vtName) return;
            const rect = vtEl.getBoundingClientRect();
            const isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight || rect.left > window.innerWidth || rect.right < 0;
            if (isOutOfView) {
                if (vtEl.style.getPropertyValue('view-transition-name')) vtEl.style.removeProperty('view-transition-name');
            } else if (!vtEl.style.getPropertyValue('view-transition-name')) vtEl.style.setProperty('view-transition-name', vtName);
        });
    };
}


// HorScroll V1.3
// Delegates horizontal scroll handling using a single body listener in capture phase.
// Tracks pairs of {scroll: 'scroll-class', holder: 'holder-class'} and updates holder
// dataset attributes [data-left] and [data-right] based on scroll position of scroll element
// optional dataset attributes on holder:
// [data-center]: if present, content will be centered
// [data-mask]: if present, a mask-image fade instead of 2 gradients. 
// Mask advantage: works on any background, disadvantage: doesn't transition, scrollbar is included in mask
// init:
// horScroller = new HorScroll({ classes: [{scroll: 'filter__content', holder: 'filter'}] });
// horScroller.init();
// horScroller.refreshElements() when content changes. Not needed for scroll listener, but for adding dataset-scroll="true"
// required properties:
// none
// methods:
// horScroller.init(): initialize scroll handling and query initial elements
// horScroller.destroy(): remove listeners and clear dataset attributes
// horScroller.refreshElements(): query and update tracked elements using configured classes
// horScroller.checkMaxScroll(el, holderClass): update scroll position attributes for a single element (public helper)
// changelog:
// 1.0 initial version
// 1.1 perfect padding, center option, margin bottom
// 1.2 add mask-image option
// 1.3 add centerOnActiveElement option and logic to refreshElements
class $ebc1dd69562e7bb7$export$2e2bcd8739ae039 {
    constructor({ holderClass: holderClass = 'hor-scroll', contentClass: contentClass = 'hor-scroll__content', centerOnActiveElement: centerOnActiveElement = true } = {}){
        this.holderClass = holderClass;
        this.contentClass = contentClass;
        this.centerOnActiveElement = centerOnActiveElement;
        this.initialized = false;
        this.boundHandleScroll = this.#handleScroll.bind(this);
        this.boundHandleResize = this.#handleResize.bind(this);
    }
    init = ()=>{
        if (this.initialized) return;
        // console.log('HorScroll init');
        // capture phase so we get scroll events from descendants without adding per-element listeners
        document.body.addEventListener('scroll', this.boundHandleScroll, {
            capture: true,
            passive: true
        });
        window.addEventListener('resize', this.boundHandleResize, {
            passive: true
        });
        this.initialized = true;
    };
    destroy = ()=>{
        if (!this.initialized) return;
        document.body.removeEventListener('scroll', this.boundHandleScroll, {
            capture: true
        });
        window.removeEventListener('resize', this.boundHandleResize);
        // clear left/right dataset flags from holders
        const holders = document.querySelectorAll('.' + this.holderClass);
        holders.forEach((holder)=>{
            try {
                delete holder.dataset.left;
                delete holder.dataset.right;
                delete holder.dataset.scroll;
            } catch (e) {}
        });
        this.initialized = false;
    };
    #handleScroll(event) {
        const target = event.target;
        if (!(target instanceof Element)) return;
        // check if target is a hor-scroll content element (or inside one)
        const sel = '.' + this.contentClass;
        const contentEl = target.matches(sel) ? target : target.closest(sel);
        if (contentEl) this.checkMaxScroll(contentEl, this.holderClass);
    }
    #handleResize() {
        // recalc sizes for all tracked elements
        this.refreshElements();
    }
    // query DOM for configured classes and run a size/position update on them
    refreshElements = (newContent = false)=>{
        if (!this.initialized) return;
        // gather all holders and their content elements
        const holderEls = document.querySelectorAll('.' + this.holderClass);
        holderEls.forEach((holderEl)=>{
            holderEl.dataset.scroll = 'true';
            const contentEl = holderEl.querySelector('.' + this.contentClass);
            if (contentEl) {
                this.checkMaxScroll(contentEl, this.holderClass);
                // If requested, center the active element, so it's visible after content switch
                if (this.centerOnActiveElement && newContent) {
                    const activeEl = holderEl.querySelector('[data-hor-scroll-active="true"]');
                    if (activeEl && contentEl.contains(activeEl)) {
                        const scrollWidth = contentEl.scrollWidth;
                        const width = contentEl.clientWidth;
                        const maxScrollX = Math.max(0, scrollWidth - width);
                        const activeLeft = activeEl.offsetLeft;
                        const activeCenter = activeLeft + activeEl.offsetWidth / 2;
                        let target = Math.round(activeCenter - width / 2);
                        target = Math.max(0, Math.min(target, maxScrollX));
                        contentEl.scrollLeft = target;
                        this.checkMaxScroll(contentEl, this.holderClass);
                    }
                }
            }
        });
    };
    checkMaxScroll = (el, holder)=>{
        const holderEl = el.closest('.' + holder);
        if (!holderEl) return;
        const { scrollWidth: scrollWidth } = el;
        const width = el.clientWidth;
        const maxScrollX = parseInt(scrollWidth - width, 10);
        const scrollX = el.scrollLeft;
        holderEl.dataset.left = scrollX < 1 ? 'true' : 'false';
        holderEl.dataset.right = scrollX > maxScrollX - 1 ? 'true' : 'false';
    };
}



// do this whenever you load a page
// so also when loading a new history.js page
// often occurs in <main> or changing navigations
// imports --------------------------------------------------------------------
// FixLocalTesting v1.3
// Rewrites localhost URLs to the current LAN hostname during local network testing.
// changelog:
// 1.0 initial version, handles anchors, forms, img lazy attributes, global JS vars
// 1.1 expand IP check to all RFC 1918 ranges (10.*, 172.16-31.*, 192.168.*), add source element handling
// 1.2 add data-src-mobile and data-srcset-mobile handling for img and video elements
// 1.3 add $homeUrl rewrite 
const $a35e88d1ef46936c$export$d7ad141dbf28d3d = ()=>{
    const hostname = window.location.hostname;
    // matches all RFC 1918 private IP ranges: 10.*, 172.16-31.*, 192.168.*
    if (!/^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(hostname)) return;
    // replace in links
    const anchors = document.querySelectorAll('a');
    anchors.forEach((element)=>{
        const href = element.getAttribute('href');
        if (!href) return;
        element.setAttribute('href', href.replace('localhost', hostname));
    });
    // replace in forms
    const forms = document.querySelectorAll('form');
    forms.forEach((element)=>{
        const action = element.getAttribute('action');
        if (!action) return;
        element.setAttribute('action', action.replace('localhost', hostname));
    });
    // replace in image lazy attributes
    const imageEls = document.querySelectorAll('img');
    imageEls.forEach((imageEl)=>{
        const src = imageEl.getAttribute('data-src');
        if (src) imageEl.setAttribute('data-src', src.split('localhost').join(hostname));
        const srcMobile = imageEl.getAttribute('data-src-mobile');
        if (srcMobile) imageEl.setAttribute('data-src-mobile', srcMobile.split('localhost').join(hostname));
        const srcset = imageEl.getAttribute('data-srcset');
        if (srcset) imageEl.setAttribute('data-srcset', srcset.split('localhost').join(hostname));
        const srcsetMobile = imageEl.getAttribute('data-srcset-mobile');
        if (srcsetMobile) imageEl.setAttribute('data-srcset-mobile', srcsetMobile.split('localhost').join(hostname));
    });
    // replace in video lazy attributes
    const videoEls = document.querySelectorAll('video');
    videoEls.forEach((videoEl)=>{
        const src = videoEl.getAttribute('data-src');
        if (src) videoEl.setAttribute('data-src', src.split('localhost').join(hostname));
        const srcMobile = videoEl.getAttribute('data-src-mobile');
        if (srcMobile) videoEl.setAttribute('data-src-mobile', srcMobile.split('localhost').join(hostname));
    });
    // replace in source elements (picture, video)
    const sourceEls = document.querySelectorAll('source');
    sourceEls.forEach((sourceEl)=>{
        const src = sourceEl.getAttribute('src');
        if (src) sourceEl.setAttribute('src', src.split('localhost').join(hostname));
        const srcset = sourceEl.getAttribute('srcset');
        if (srcset) sourceEl.setAttribute('srcset', srcset.split('localhost').join(hostname));
    });
    if (typeof $baseUrl !== 'undefined') $baseUrl = $baseUrl.replace('localhost', hostname);
    if (typeof $url !== 'undefined') $url = $url.replace('localhost', hostname);
    if (typeof $homeUrl !== 'undefined') $homeUrl = $homeUrl.replace('localhost', hostname);
    if (typeof $assets !== 'undefined') $assets = $assets.replace('localhost', hostname);
};


// SetActiveMenuItems v1.8
// Sets aria-current on navigation links based on current URL.
// usage:
// setActiveMenuItems(['nav__item'], {
//   matchQueryString: false,
//   postTypeSlugs: ['news', 'insights'],
//   baseUrl: 'https://example.com/',
// });
// changelog:
// 1.0: initial version
// 1.1: navItemClasses parameter required, querystring toggle added
// 1.2: switched active state to aria-current="page"
// 1.3: replaced boolean second parameter with options object
// 1.4: only query anchors that match configured nav classes
// 1.5: rename to SetActiveMenuItems
// 1.6: added optional postTypeSlugs option to avoid global dependency
// 1.7: added optional baseUrl option to avoid global dependency
// 1.8: added matchPartialPath option for active ancestor nav items
const $6364af678aaff281$var$getUrlObject = (url)=>{
    try {
        return new URL(url, window.location.href);
    } catch  {
        return null;
    }
};
const $6364af678aaff281$export$aa50272292466539 = (navItemClasses, options = {})=>{
    if (!Array.isArray(navItemClasses) || navItemClasses.length === 0) throw new TypeError('setActiveMenuItems requires a non-empty navItemClasses array');
    const { matchQueryString: matchQueryString = false, matchPartialPath: matchPartialPath = false, postTypeSlugs: postTypeSlugs = [], baseUrl: baseUrl = `${window.location.origin}/` } = options;
    const currentUrl = new URL(window.location.href);
    const cleanUrl = currentUrl.href.split('?')[0].split('#')[0];
    const selector = navItemClasses.map((navItemClass)=>`a.${navItemClass}`).join(', ');
    const navItemsEls = document.querySelectorAll(selector);
    navItemsEls.forEach((navItemEl)=>{
        navItemEl.removeAttribute('aria-current');
        const href = navItemEl.getAttribute('href');
        if (!href) return;
        const hrefUrl = $6364af678aaff281$var$getUrlObject(href);
        const hrefCleanUrl = hrefUrl ? hrefUrl.href.split('?')[0].split('#')[0] : href;
        const queryMatches = !matchQueryString || hrefUrl && hrefUrl.search === currentUrl.search;
        // console.log('Comparing:', { href, hrefCleanUrl, cleanUrl, queryMatches });
        if (hrefCleanUrl === cleanUrl && queryMatches) navItemEl.setAttribute('aria-current', 'page');
        else if (matchPartialPath && hrefCleanUrl !== baseUrl && cleanUrl.startsWith(hrefCleanUrl) && queryMatches) navItemEl.setAttribute('aria-current', 'page');
        else if (Array.isArray(postTypeSlugs) && postTypeSlugs.length > 0) {
            for(let j = 0; j < postTypeSlugs.length; j++)if (cleanUrl.indexOf('/' + postTypeSlugs[j] + '/') > 0 && href == baseUrl + postTypeSlugs[j] + '/' && queryMatches) navItemEl.setAttribute('aria-current', 'page');
        }
    });
};





var $eab0398616e9ffb4$exports = {};

$parcel$export($eab0398616e9ffb4$exports, "initMediaItems", () => $eab0398616e9ffb4$export$4ea236338c7d64ed);
$parcel$export($eab0398616e9ffb4$exports, "togglePlayPause", () => $eab0398616e9ffb4$export$4b6478966c109e99);
$parcel$export($eab0398616e9ffb4$exports, "setMediaItems", () => $eab0398616e9ffb4$export$74fd572b7937cf92);
$parcel$export($eab0398616e9ffb4$exports, "pauseMediaItems", () => $eab0398616e9ffb4$export$593d508bb877f2f);
// media items 1.7
// dependencies: can-autoplay.js
// depends on setPage() to call setMediaItems()
// depends on each $slick element to call setSlickVideo($slick)
// changelog
// 1.1 no $
// 1.2 supports audio now
// 1.3 supports fullscreen now
// 1.3.1 don't open embeds with preview when doing setPage, fix media class
// 1.3.2 new blockScrollchecker
// 1.3.3 fix for mistakenly hiding preview on touch
// 1.3.4 fix autoplay random pause
// 1.4 add set progress from progress bar
// 1.4.1 load main video with preview on play click
// 1.4.2 correct block scroll check and clean up
// 1.4.3 cleaner focusin/out
// 1.5 add fullscreen source support + remember time when switching sources
// 1.6 modular js
// 1.7 remove elFromEvent dependency
// imports --------------------------------------------------------------------

// do these things only once
// even if you are using a history.js navigation
// imports --------------------------------------------------------------------



var $b5ee8e0943d4762a$exports = {};

$parcel$export($b5ee8e0943d4762a$exports, "scrollAnimator", () => $b5ee8e0943d4762a$export$60388f6293022a1f);
$parcel$export($b5ee8e0943d4762a$exports, "scrollTop", () => $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9);
$parcel$export($b5ee8e0943d4762a$exports, "scrollLeft", () => $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80);
$parcel$export($b5ee8e0943d4762a$exports, "windowBottom", () => $b5ee8e0943d4762a$export$3cebd429ba9c7e2f);
$parcel$export($b5ee8e0943d4762a$exports, "windowRight", () => $b5ee8e0943d4762a$export$fa1dcc62260e390a);
$parcel$export($b5ee8e0943d4762a$exports, "atBodyBottom", () => $b5ee8e0943d4762a$export$186a1a0a62ca04b8);
$parcel$export($b5ee8e0943d4762a$exports, "atBodyRight", () => $b5ee8e0943d4762a$export$5f2810376f156045);
$parcel$export($b5ee8e0943d4762a$exports, "isScrolling", () => $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2);
$parcel$export($b5ee8e0943d4762a$exports, "initScroll", () => $b5ee8e0943d4762a$export$44e7c48d94f0a708);
$parcel$export($b5ee8e0943d4762a$exports, "setScroll", () => $b5ee8e0943d4762a$export$6bbf62f168c1dddc);
$parcel$export($b5ee8e0943d4762a$exports, "checkBlockScroll", () => $b5ee8e0943d4762a$export$172c67b7e113cff8);
$parcel$export($b5ee8e0943d4762a$exports, "setScrollTop", () => $b5ee8e0943d4762a$export$38a81aac5c9c320d);
$parcel$export($b5ee8e0943d4762a$exports, "scrollToEl", () => $b5ee8e0943d4762a$export$9e22b9da3b459613);
// scroll functions and listeners ---------------------------------------------
// imports --------------------------------------------------------------------

// ScrollAnimator V1.2
// reusable animated scroll engine with built-in wheel/touch override listeners
// init:
// scrollAnimator = new ScrollAnimator();
// scrollAnimator.init();
// usage:
// call animateScrollTop/animateScrollLeft for animated scroll movement
// required properties:
// none
// possible properties:
// durationFactor = 35: larger means slower animation
// minDuration = 400: minimum animation duration in ms
// allowOverride = true: allow user input (wheel/touch) to interrupt animation
// overrideThreshold = 120: wheel delta threshold before override kicks in
// touchOverrideIncrement = 12: accumulated touch delta step for override
// onStart = '': callback fired when animation starts
// onStop = '': callback fired when animation stops
// beforeAnimate = '': callback before animation frame loop starts
// afterAnimate = '': callback after animation frame loop completes
// methods:
// scrollAnimator.init()
// scrollAnimator.destroy()
// scrollAnimator.setDurationFactor(35)
// scrollAnimator.isAnimating()
// scrollAnimator.cancel()
// scrollAnimator.setHooks({beforeAnimate, afterAnimate})
// scrollAnimator.animateScrollTop(scroll, {element, useMax, onDone})
// scrollAnimator.animateScrollLeft(scroll, {element, useMax, onDone})
// changelog:
// 1.0 initial version, extracted from scroll helpers and renamed for clarity
// 1.1 make methods private for clearer distinction
// 1.2 add cancel() to stop animation programmatically
class $c4ea45c3694a757d$export$2e2bcd8739ae039 {
    #isScrolling;
    #overrideTotal;
    #didOverride;
    #initialized;
    #boundHandleWheel;
    #boundHandleTouchMove;
    constructor({ durationFactor: durationFactor = 35, minDuration: minDuration = 400, allowOverride: allowOverride = true, overrideThreshold: overrideThreshold = 120, touchOverrideIncrement: touchOverrideIncrement = 12, onStart: onStart = '', onStop: onStop = '', beforeAnimate: beforeAnimate = '', afterAnimate: afterAnimate = '' } = {}){
        this.durationFactor = durationFactor;
        this.minDuration = minDuration;
        this.allowOverride = allowOverride;
        this.overrideThreshold = overrideThreshold;
        this.touchOverrideIncrement = touchOverrideIncrement;
        this.onStart = onStart;
        this.onStop = onStop;
        this.beforeAnimate = beforeAnimate;
        this.afterAnimate = afterAnimate;
        this.#isScrolling = false;
        this.#overrideTotal = 0;
        this.#didOverride = false;
        this.#initialized = false;
        this.#boundHandleWheel = this.#handleWheel.bind(this);
        this.#boundHandleTouchMove = this.#handleTouchMove.bind(this);
    }
    init = ()=>{
        if (this.#initialized || !document.body) return;
        document.body.addEventListener('wheel', this.#boundHandleWheel);
        document.body.addEventListener('touchmove', this.#boundHandleTouchMove, {
            passive: false
        });
        this.#initialized = true;
    };
    destroy = ()=>{
        if (!this.#initialized || !document.body) return;
        document.body.removeEventListener('wheel', this.#boundHandleWheel);
        document.body.removeEventListener('touchmove', this.#boundHandleTouchMove);
        this.#initialized = false;
    };
    setDurationFactor = (durationFactor)=>{
        this.durationFactor = durationFactor;
    };
    setHooks = ({ beforeAnimate: beforeAnimate, afterAnimate: afterAnimate } = {})=>{
        if (typeof beforeAnimate !== 'undefined') this.beforeAnimate = beforeAnimate;
        if (typeof afterAnimate !== 'undefined') this.afterAnimate = afterAnimate;
    };
    isAnimating = ()=>{
        return this.#isScrolling;
    };
    cancel = ()=>{
        if (this.#isScrolling) this.#didOverride = true;
    };
    animateScrollTop = (scroll, { element: element = document.body, useMax: useMax = true, onDone: onDone = '' } = {})=>{
        this.#animate({
            scroll: scroll,
            direction: 'top',
            element: element,
            useMax: useMax,
            onDone: onDone
        });
    };
    animateScrollLeft = (scroll, { element: element = document.body, useMax: useMax = true, onDone: onDone = '' } = {})=>{
        this.#animate({
            scroll: scroll,
            direction: 'left',
            element: element,
            useMax: useMax,
            onDone: onDone
        });
    };
    #animate({ scroll: scroll, direction: direction = 'top', element: element = document.body, useMax: useMax = true, onDone: onDone = '', beforeAnimate: beforeAnimate = '', afterAnimate: afterAnimate = '' } = {}) {
        const originalElement = element;
        const shouldTrackScrollState = originalElement?.tagName === 'BODY';
        const beforeCallback = typeof beforeAnimate === 'function' ? beforeAnimate : this.beforeAnimate;
        if (shouldTrackScrollState && typeof beforeCallback === 'function') beforeCallback({
            direction: direction,
            element: originalElement,
            originalElement: originalElement,
            scroll: scroll
        });
        let size;
        let scrollSize;
        if (element.tagName === 'BODY') {
            size = direction === 'top' ? window.innerHeight : window.innerWidth;
            scrollSize = direction === 'top' ? document.documentElement.scrollHeight : document.documentElement.scrollWidth;
            element = document.documentElement;
        } else {
            size = direction === 'top' ? element.offsetHeight : element.offsetWidth;
            scrollSize = direction === 'top' ? element.scrollHeight : element.scrollWidth;
        }
        if (useMax) {
            const maxScroll = scrollSize - size;
            if (scroll > maxScroll) scroll = maxScroll;
            if (scroll < 0) scroll = 0;
        }
        const delay = this.#isScrolling ? 50 : 0;
        if (this.#isScrolling) this.#didOverride = true;
        setTimeout(()=>this.#scrollToPosition({
                to: scroll,
                direction: direction,
                element: element,
                onDone: onDone,
                afterAnimate: afterAnimate,
                originalElement: originalElement,
                shouldTrackScrollState: shouldTrackScrollState
            }), delay);
    }
    #scrollToPosition({ to: to, direction: direction = 'top', element: element, onDone: onDone = '', afterAnimate: afterAnimate = '', originalElement: originalElement = element, shouldTrackScrollState: shouldTrackScrollState = false } = {}) {
        this.#overrideTotal = 0;
        this.#didOverride = false;
        let start;
        if (element == document.documentElement) start = direction === 'top' ? window.scrollY || element.scrollTop : window.scrollX || element.scrollLeft;
        else start = direction === 'top' ? element.scrollTop : element.scrollLeft;
        const change = to - start;
        if (change < 1 && change > -1) {
            const afterCallback = typeof afterAnimate === 'function' ? afterAnimate : this.afterAnimate;
            if (shouldTrackScrollState && typeof afterCallback === 'function') afterCallback({
                direction: direction,
                element: element,
                originalElement: originalElement,
                to: to,
                overridden: false
            });
            if (typeof onDone === 'function') onDone(element);
            return;
        }
        if (shouldTrackScrollState) {
            this.#isScrolling = true;
            if (typeof this.onStart === 'function') this.onStart(shouldTrackScrollState);
        }
        let duration = Math.sqrt(Math.abs(change)) * this.durationFactor;
        if (duration < this.minDuration) duration = this.minDuration;
        const increment = 15;
        let currentTime = 0;
        const easeInOutQuart = (t)=>t < 0.5 ? 8 * t ** 4 : 1 - 8 * (--t * t ** 3);
        const done = ({ overridden: overridden = false } = {})=>{
            if (shouldTrackScrollState) {
                this.#isScrolling = false;
                if (typeof this.onStop === 'function') this.onStop(shouldTrackScrollState);
            }
            const afterCallback = typeof afterAnimate === 'function' ? afterAnimate : this.afterAnimate;
            if (shouldTrackScrollState && typeof afterCallback === 'function') afterCallback({
                direction: direction,
                element: element,
                originalElement: originalElement,
                to: to,
                overridden: overridden
            });
            if (typeof onDone === 'function') onDone(element);
        };
        const animate = ()=>{
            currentTime += increment;
            const val = easeInOutQuart(currentTime / duration);
            const currentScroll = start + change * val;
            if (direction === 'top') element.scrollTo({
                top: currentScroll
            });
            else element.scrollTo({
                left: currentScroll
            });
            if (currentTime < duration) {
                if (shouldTrackScrollState && this.#didOverride && this.allowOverride) {
                    const wasOverridden = true;
                    this.#didOverride = false;
                    done({
                        overridden: wasOverridden
                    });
                } else setTimeout(animate, increment);
            } else {
                if (direction === 'top') element.scrollTo({
                    top: to
                });
                else element.scrollTo({
                    left: to
                });
                done();
            }
        };
        animate();
    }
    #handleWheel(event) {
        if (!this.#isScrolling) return;
        if (this.allowOverride) {
            const absDeltaY = Math.abs(event.deltaY || 0);
            const absDeltaX = Math.abs(event.deltaX || 0);
            this.#overrideTotal += absDeltaY > absDeltaX ? absDeltaY : absDeltaX;
            if (this.#overrideTotal > this.overrideThreshold) this.#didOverride = true;
        } else {
            event.preventDefault();
            event.stopPropagation();
        }
    }
    #handleTouchMove(event) {
        if (!this.#isScrolling) return;
        if (this.allowOverride) {
            this.#overrideTotal += this.touchOverrideIncrement;
            if (this.#overrideTotal > this.overrideThreshold) this.#didOverride = true;
        } else {
            event.preventDefault();
            event.stopPropagation();
        }
    }
}






// set user variables ---------------------------------------------------------
// which elements, when active, should block scroll
const $b5ee8e0943d4762a$var$blockScrollSelector = '.popover--active, .body--nav, .media--fullscreen';
let $b5ee8e0943d4762a$export$60388f6293022a1f;
let $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 = 0;
let $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 = 0;
let $b5ee8e0943d4762a$export$3cebd429ba9c7e2f = window.innerHeight;
let $b5ee8e0943d4762a$export$fa1dcc62260e390a = window.innerWidth;
let $b5ee8e0943d4762a$export$186a1a0a62ca04b8 = false;
let $b5ee8e0943d4762a$export$5f2810376f156045 = false;
let $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2 = false;
const $b5ee8e0943d4762a$export$44e7c48d94f0a708 = ()=>{
    // scroll listener
    window.addEventListener('scroll', ()=>{
        // add code only called from real scroll here
        $b5ee8e0943d4762a$export$6bbf62f168c1dddc();
    }, {
        passive: true
    });
    $b5ee8e0943d4762a$export$60388f6293022a1f = new (0, $c4ea45c3694a757d$export$2e2bcd8739ae039)({
        durationFactor: 35,
        minDuration: $183c77cc0773b3dc$export$35a4a76088200152,
        allowOverride: true,
        overrideThreshold: 120,
        onStart: (isDocumentScroll = false)=>{
            if (!isDocumentScroll) return;
            $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2 = true;
            $b5ee8e0943d4762a$export$172c67b7e113cff8();
        },
        onStop: (isDocumentScroll = false)=>{
            if (!isDocumentScroll) return;
            $b5ee8e0943d4762a$export$3db4e7cb4a7afaa2 = false;
            $b5ee8e0943d4762a$export$172c67b7e113cff8();
        }
    });
    $b5ee8e0943d4762a$export$60388f6293022a1f.init();
};
const $b5ee8e0943d4762a$export$6bbf62f168c1dddc = ()=>{
    // do scrolling actions
    // console.log('setScroll');
    if ('fixer' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.fixer?.bodyFixed !== 'undefined') {
        if ($56a526a578fe3239$exports.fixer.bodyFixed !== true) $b5ee8e0943d4762a$var$updateFromScroll();
    } else $b5ee8e0943d4762a$var$updateFromScroll();
};
const $b5ee8e0943d4762a$var$updateFromScroll = ()=>{
    $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 = window.scrollY || document.documentElement.scrollTop;
    $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 = window.scrollX || document.documentElement.scrollLeft;
    $b5ee8e0943d4762a$export$3cebd429ba9c7e2f = $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 + window.innerHeight;
    $b5ee8e0943d4762a$export$fa1dcc62260e390a = $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 + window.innerWidth;
    // use >= becaues of ios scrolling past the max, -1 for smooth scroll
    $b5ee8e0943d4762a$export$186a1a0a62ca04b8 = $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9 >= $41264c54ad2c6427$exports.maxBodyScrollTop - 1;
    $b5ee8e0943d4762a$export$5f2810376f156045 = $b5ee8e0943d4762a$export$6eddf9bc7f2b7d80 >= $41264c54ad2c6427$exports.maxBodyScrollLeft - 1;
    // console.log('updateFromScroll', {scrollTop, scrollLeft, windowBottom, windowRight, atBodyBottom, atBodyRight});
    $b7c88863cbfbcd57$export$ece7705a25021b6d.forEach((gradientEl)=>{
        const rect = gradientEl.getBoundingClientRect();
        if (rect.bottom <= $41264c54ad2c6427$exports.viewportHeight) gradientEl.classList.add('gradient--visible');
    });
    $b7c88863cbfbcd57$export$867dcd50196c50f3.forEach((chartsEl)=>{
        const rect = chartsEl.getBoundingClientRect();
        if (rect.bottom <= $41264c54ad2c6427$exports.viewportHeight * 1 + 100) chartsEl.classList.add('charts--visible');
    });
};
const $b5ee8e0943d4762a$export$172c67b7e113cff8 = ()=>{
    // console.log('checkBlockScroll', {isScrolling});
    const hasFixer = 'fixer' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.fixer?.bodyFixed !== 'undefined';
    const hasAnimator = 'animator' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.animator?.disableSmoothScroll !== 'undefined';
    if (document.querySelector($b5ee8e0943d4762a$var$blockScrollSelector)) {
        // an element is active, which should block scroll
        if (hasFixer) $56a526a578fe3239$exports.fixer.fixBody();
        if (hasAnimator) $56a526a578fe3239$exports.animator.disableSmoothScroll();
    } else if ($b5ee8e0943d4762a$export$3db4e7cb4a7afaa2) // scroll is animating, so disable scroll
    {
        if (hasAnimator) $56a526a578fe3239$exports.animator.disableSmoothScroll();
    } else {
        // normal state, enable scroll
        if (hasFixer) $56a526a578fe3239$exports.fixer.unfixBody();
        if (hasAnimator) $56a526a578fe3239$exports.animator.enableSmoothScroll();
        if ('saveOffsets' in $41264c54ad2c6427$exports) $41264c54ad2c6427$exports.saveOffsets();
    }
};
const $b5ee8e0943d4762a$export$38a81aac5c9c320d = (scroll)=>{
    if ('animator' in $56a526a578fe3239$exports && $56a526a578fe3239$exports.animator?.scroller !== undefined) $56a526a578fe3239$exports.animator.setScrollPosHard({
        pos: scroll
    });
    else window.scrollTo({
        top: scroll
    });
};
const $b5ee8e0943d4762a$export$9e22b9da3b459613 = (element, returnFunction = '', offset = $41264c54ad2c6427$exports.headerHeight, direction = 'both')=>{
    const top = (0, $e3efffc4d0edbc40$export$ccc55dee332fd8dd)(element).top - offset;
    if (direction === 'up' && top >= $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9) return;
    if (direction === 'down' && top <= $b5ee8e0943d4762a$export$3e0c8fa3b5e4b3b9) return;
    $b5ee8e0943d4762a$export$60388f6293022a1f.animateScrollTop(top, {
        element: document.body,
        useMax: true,
        onDone: ()=>{
            if (typeof returnFunction === 'function') returnFunction();
        }
    });
};


let $592a2eb60fbd4a62$export$d6c7e16048971142 = false;
// local variables ------------------------------------------------------------
const $592a2eb60fbd4a62$var$pulseSelector = '.button, .swiper-button-next, .swiper-button-prev'; // elements that get a pulse on click
let $592a2eb60fbd4a62$var$didPageInteraction = false; // to track first interaction for playing videos on low battery devices
const $592a2eb60fbd4a62$export$f699d83c57fc51d7 = ()=>{
    // console.log('listeners');
    // touch --------------------------------
    const hoverSelector = 'button, a, input, .header__nav-item';
    document.body.addEventListener('touchstart', (event)=>{
        // console.log('touchstart', event.target.classList[0]);
        // add touch hover classes
        let el = event.target.closest(hoverSelector);
        if (el) {
            const hoverEl = el;
            hoverEl.classList.add('hover');
            // if using css animation for hover effect, remove class after animation duration
            let duration = $183c77cc0773b3dc$export$bc5e1f7fdf0656e1;
            if (hoverEl.classList.contains('button')) duration = $183c77cc0773b3dc$export$35a4a76088200152; // same as css animation duration
            setTimeout(()=>{
                hoverEl.classList.remove('hover');
            }, duration);
        }
    });
    document.body.addEventListener('touchend', (event)=>{
    // console.log('touchend', event.target.classList[0]);
    // when not using css animation
    // let el = event.target.closest(hoverSelector);
    // if (el) el.classList.remove('hover');
    });
    // touch and mouse --------------------------------
    document.body.addEventListener('click', (event)=>{
        // console.log('click', event.target.classList[0]);
        // remove focus after click
        let el = event.target.closest('button, a, input[type="radio"], input[type="checkbox"], *[role="button"], input[type=range]');
        if (el && event.clientX !== 0 && event.clientY !== 0) el.blur();
        if ('aim' in $56a526a578fe3239$exports && $56a526a578fe3239$exports.aim) {
            $56a526a578fe3239$exports.aim.classList.add('animate-it-mouse--click');
            setTimeout(()=>{
                $56a526a578fe3239$exports.aim.classList.remove('animate-it-mouse--click');
            }, $183c77cc0773b3dc$export$35a4a76088200152); // same as .pulse duration
        }
        // pulse effect on buttons --------------------------------
        el = event.target.closest($592a2eb60fbd4a62$var$pulseSelector);
        if (el) {
            const linkEl = el;
            linkEl.classList.add('pulse');
            setTimeout(()=>{
                linkEl.classList.remove('pulse');
            }, $183c77cc0773b3dc$export$35a4a76088200152); // same as .pulse duration
        }
        // play video on low battery devices  --------------------------------------------
        if (!$592a2eb60fbd4a62$var$didPageInteraction) {
            // actual autoplay videos, not ones that have autoplay from Fader.js
            const videoEls = document.querySelectorAll('video[autoplay]:not([data-autoplay="false"]):not([data-src=""])');
            videoEls.forEach((videoEl)=>videoEl.play());
            $592a2eb60fbd4a62$var$didPageInteraction = true;
        }
        // interaction  --------------------------------------------
        el = event.target.closest('button, p a'); // interaction acf selectors
        if (el) {
            // to section
            const sectionName = el.dataset.section;
            if (typeof sectionName !== 'undefined') {
                event.preventDefault();
                const sectionEl = document.querySelector('[data-name="' + sectionName + '"]');
                if (sectionEl) $b5ee8e0943d4762a$exports.scrollToEl(sectionEl);
            }
        }
        // hamburger
        el = event.target.closest('.hamburger');
        if (el) {
            document.body.classList.toggle('body--nav');
            if ('animator' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.animator.blockResizeObserver = true;
            if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
        }
        // remove hover from any item on touch devices
        const headerNavItemEls = document.querySelectorAll('.header__nav-item');
        headerNavItemEls.forEach((headerNavItemEl)=>headerNavItemEl.classList.remove('header__nav-item--active'));
        el = event.target.closest('.header__nav-item');
        if (el && ($183c77cc0773b3dc$export$507ba88fae84526c || $183c77cc0773b3dc$export$64334b5f702ba3ba.matches)) {
            el.classList.add('header__nav-item--active');
            $56a526a578fe3239$exports.fader.setFaders();
        }
        // override previous
        el = event.target.closest('.flap__back');
        if (el) {
            const headerNavItemEl = el.closest('.header__nav-item--active');
            if (headerNavItemEl) headerNavItemEl.classList.remove('header__nav-item--active');
        }
        el = event.target.closest('.back-link');
        if (el) {
            // check if there's a previous page in history and if it's from the same domain
            if (document.referrer && new URL(document.referrer).origin === window.location.origin) window.history.back();
            else // go to homepage if no referrer or referrer is from different domain
            window.location.href = $url; // is homepage set in base.twig
        }
        // filtering
        el = event.target.closest('button.button--filter');
        if (el) {
            const filter = el.getAttribute('data-filter');
            const buttons = document.querySelectorAll('.button--filter');
            buttons.forEach((button)=>button.classList.remove('button--active'));
            el.classList.add('button--active');
            const filterableEl = document.querySelector('.filterable');
            if (!filterableEl) return;
            filterableEl.classList.add('filterable--faded-out');
            // console.log(' scroll to filter');
            const scrollerEl = document.querySelector('#scroller');
            if (scrollerEl) $b5ee8e0943d4762a$exports.scrollToEl(scrollerEl, '', $41264c54ad2c6427$export$24f4c7f1d039d0b6, 'up');
            setTimeout(()=>{
                // before adding hidden, because it's removed by fader
                $56a526a578fe3239$exports.fader.fadeInHolderAgain(filterableEl);
                const allItemEls = filterableEl.querySelectorAll('.filterable__item');
                allItemEls.forEach((itemEl)=>itemEl.classList.remove('fader--br', 'fader--bl'));
                if (filter === 'all') allItemEls.forEach((itemEl)=>itemEl.classList.remove('hidden'));
                else {
                    allItemEls.forEach((itemEl)=>itemEl.classList.add('hidden'));
                    const filteredItemEls = filterableEl.querySelectorAll('.filterable__item[data-tags*="' + filter + '"]');
                    filteredItemEls.forEach((itemEl)=>itemEl.classList.remove('hidden'));
                }
                filterableEl.classList.remove('filterable--faded-out');
            }, $183c77cc0773b3dc$export$35a4a76088200152);
        }
    });
    // keyboard --------------------------------
    document.body.addEventListener('keydown', (event)=>{
        // console.log('keydown', event.key);
        $592a2eb60fbd4a62$export$d6c7e16048971142 = true;
    });
    // mouse and keyboard --------------------------------
    // mouseout, focusout listeners 
    const outHandler = (event)=>{
        // use if (event.type === 'mouseout') to avoid keyboard blur
        if ($183c77cc0773b3dc$export$507ba88fae84526c) return;
        if (event.type === 'focusout' && !$592a2eb60fbd4a62$export$d6c7e16048971142) return;
    // console.log('outHandler', event.target.classList[0], event.type);
    // let el = event.target.closest(swiperHoverSelector);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--hover');
    // }
    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--drag-hor');
    // }
    // let el = event.target.closest('.header__nav-item');
    // if(!el) {
    //   const activeHeaderNavItemEls = document.querySelectorAll('.header__nav-item--active');
    //   activeHeaderNavItemEls.forEach(activeHeaderNavItemEl => activeHeaderNavItemEl.classList.remove('header__nav-item--active'));
    // } 
    };
    // document.body.addEventListener('mouseleave', outHandler, true); // bubbles to body, triggers on touch
    document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
    document.body.addEventListener('focusout', outHandler); // doesn't bubble or trigger on touch, triggers on keyboard blur and click on other button
    // mouseover, focusin listeners 
    const swiperHoverSelector = '.swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
    const inHandler = (event)=>{
        // use if (event.type === 'mouseover') to avoid keyboard focus
        if ($183c77cc0773b3dc$export$507ba88fae84526c) return;
        if (event.type === 'focusin' && !$592a2eb60fbd4a62$export$d6c7e16048971142) return;
        // console.log('inHandler', event.target.classList[0], event.type);
        // let el = event.target.closest(swiperHoverSelector);
        // if (el && Once.aim) {
        //   Once.aim.classList.add('animate-it-mouse--hover');
        // }
        // el = event.target.closest('.swiper-wrapper');
        // if (el && Once.aim) {
        //   Once.aim.classList.add('animate-it-mouse--drag-hor');
        // }
        let el = event.target.closest('.header__nav-item');
        if (el) $56a526a578fe3239$exports.fader.setFaders();
        if (event.type == 'focusin' && $592a2eb60fbd4a62$export$d6c7e16048971142) {
            // keyboard focus fixed footer, scroll there
            if (event.target.closest('.footer')) $b5ee8e0943d4762a$exports.animateScrollTop(1000000);
            // remove hover from any item if keyboard focus
            const headerNavItemEls = document.querySelectorAll('.header__nav-item');
            headerNavItemEls.forEach((headerNavItemEl)=>headerNavItemEl.classList.remove('header__nav-item--active'));
            el = event.target.closest('.header__nav-item');
            if (el) el.classList.add('header__nav-item--active');
        }
        $592a2eb60fbd4a62$export$d6c7e16048971142 = false;
    };
    // document.body.addEventListener('mouseenter', inHandler, true); // bubbles to body, triggers on touch
    document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
    document.body.addEventListener('focusin', inHandler); // doesn't bubble or trigger on touch, triggers on keyboard focus and mousedown on button
    // mousedown listener --------------------------------
    document.body.addEventListener('mousedown', (event)=>{
    // console.log('mousedown', event.target.classList[0]);
    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--dragging-hor');
    // }
    }, true);
    // mousemove listener --------------------------------
    document.body.addEventListener('mousemove', (event)=>{
        // console.log('mousemove', event.target.classList[0]);
        const x = event.clientX;
        const y = event.clientY;
    }, true);
    // mouseup listener --------------------------------
    document.body.addEventListener('mouseup', (event)=>{
    // console.log('mouseup', event.target.classList[0]);
    // if (Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--dragging-hor');
    // }
    }, true);
}; // functions -------------------------------------------------------------------




/* global Blob */ // This file is generated. Do not edit this file directly.
// Command: 'npm run generate' should be used to update the content.
/**
 * @type {Blob}
 */ var $f66167a3c26eb16f$var$AUDIO = new Blob([
    new Uint8Array([
        255,
        227,
        24,
        196,
        0,
        0,
        0,
        3,
        72,
        1,
        64,
        0,
        0,
        4,
        132,
        16,
        31,
        227,
        192,
        225,
        76,
        255,
        67,
        12,
        255,
        221,
        27,
        255,
        228,
        97,
        73,
        63,
        255,
        195,
        131,
        69,
        192,
        232,
        223,
        255,
        255,
        207,
        102,
        239,
        255,
        255,
        255,
        101,
        158,
        206,
        70,
        20,
        59,
        255,
        254,
        95,
        70,
        149,
        66,
        4,
        16,
        128,
        0,
        2,
        2,
        32,
        240,
        138,
        255,
        36,
        106,
        183,
        255,
        227,
        24,
        196,
        59,
        11,
        34,
        62,
        80,
        49,
        135,
        40,
        0,
        253,
        29,
        191,
        209,
        200,
        141,
        71,
        7,
        255,
        252,
        152,
        74,
        15,
        130,
        33,
        185,
        6,
        63,
        255,
        252,
        195,
        70,
        203,
        86,
        53,
        15,
        255,
        255,
        247,
        103,
        76,
        121,
        64,
        32,
        47,
        255,
        34,
        227,
        194,
        209,
        138,
        76,
        65,
        77,
        69,
        51,
        46,
        57,
        55,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        255,
        227,
        24,
        196,
        73,
        13,
        153,
        210,
        100,
        81,
        135,
        56,
        0,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170,
        170
    ])
], {
    type: 'audio/mpeg'
});
/**
 * @type {Blob}
 */ var $f66167a3c26eb16f$var$VIDEO = new Blob([
    new Uint8Array([
        0,
        0,
        0,
        28,
        102,
        116,
        121,
        112,
        105,
        115,
        111,
        109,
        0,
        0,
        2,
        0,
        105,
        115,
        111,
        109,
        105,
        115,
        111,
        50,
        109,
        112,
        52,
        49,
        0,
        0,
        0,
        8,
        102,
        114,
        101,
        101,
        0,
        0,
        2,
        239,
        109,
        100,
        97,
        116,
        33,
        16,
        5,
        32,
        164,
        27,
        255,
        192,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        55,
        167,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        112,
        33,
        16,
        5,
        32,
        164,
        27,
        255,
        192,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        55,
        167,
        128,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        112,
        0,
        0,
        2,
        194,
        109,
        111,
        111,
        118,
        0,
        0,
        0,
        108,
        109,
        118,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        232,
        0,
        0,
        0,
        47,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        1,
        236,
        116,
        114,
        97,
        107,
        0,
        0,
        0,
        92,
        116,
        107,
        104,
        100,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        47,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        101,
        100,
        116,
        115,
        0,
        0,
        0,
        28,
        101,
        108,
        115,
        116,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        47,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        100,
        109,
        100,
        105,
        97,
        0,
        0,
        0,
        32,
        109,
        100,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        8,
        0,
        85,
        196,
        0,
        0,
        0,
        0,
        0,
        45,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        115,
        111,
        117,
        110,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0,
        0,
        0,
        1,
        15,
        109,
        105,
        110,
        102,
        0,
        0,
        0,
        16,
        115,
        109,
        104,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        36,
        100,
        105,
        110,
        102,
        0,
        0,
        0,
        28,
        100,
        114,
        101,
        102,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        12,
        117,
        114,
        108,
        32,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        211,
        115,
        116,
        98,
        108,
        0,
        0,
        0,
        103,
        115,
        116,
        115,
        100,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        87,
        109,
        112,
        52,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        16,
        0,
        0,
        0,
        0,
        172,
        68,
        0,
        0,
        0,
        0,
        0,
        51,
        101,
        115,
        100,
        115,
        0,
        0,
        0,
        0,
        3,
        128,
        128,
        128,
        34,
        0,
        2,
        0,
        4,
        128,
        128,
        128,
        20,
        64,
        21,
        0,
        0,
        0,
        0,
        1,
        244,
        0,
        0,
        1,
        243,
        249,
        5,
        128,
        128,
        128,
        2,
        18,
        16,
        6,
        128,
        128,
        128,
        1,
        2,
        0,
        0,
        0,
        24,
        115,
        116,
        116,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        28,
        115,
        116,
        115,
        99,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        28,
        115,
        116,
        115,
        122,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        1,
        115,
        0,
        0,
        1,
        116,
        0,
        0,
        0,
        20,
        115,
        116,
        99,
        111,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        44,
        0,
        0,
        0,
        98,
        117,
        100,
        116,
        97,
        0,
        0,
        0,
        90,
        109,
        101,
        116,
        97,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        33,
        104,
        100,
        108,
        114,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        109,
        100,
        105,
        114,
        97,
        112,
        112,
        108,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        45,
        105,
        108,
        115,
        116,
        0,
        0,
        0,
        37,
        169,
        116,
        111,
        111,
        0,
        0,
        0,
        29,
        100,
        97,
        116,
        97,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        76,
        97,
        118,
        102,
        53,
        54,
        46,
        52,
        48,
        46,
        49,
        48,
        49
    ])
], {
    type: 'video/mp4'
});
/* global URL */ function $f66167a3c26eb16f$var$setupDefaultValues(options) {
    return Object.assign({
        muted: false,
        timeout: 250,
        inline: false
    }, options);
}
function $f66167a3c26eb16f$var$startPlayback(_ref, elementCallback) {
    var muted = _ref.muted, timeout = _ref.timeout, inline = _ref.inline;
    var _elementCallback = elementCallback(), element = _elementCallback.element, source = _elementCallback.source;
    var playResult = void 0;
    var timeoutId = void 0;
    var sendOutput = void 0;
    element.muted = muted;
    if (muted === true) element.setAttribute('muted', 'muted');
    // indicates that the video is to be played "inline",
    // that is within the element's playback area.
    if (inline === true) element.setAttribute('playsinline', 'playsinline');
    element.src = source;
    return new Promise(function(resolve) {
        playResult = element.play();
        timeoutId = setTimeout(function() {
            sendOutput(false, new Error('Timeout ' + timeout + ' ms has been reached'));
        }, timeout);
        sendOutput = function sendOutput(result) {
            var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            // Clean up to avoid MediaElementLeak
            element.remove();
            element.srcObject = null;
            clearTimeout(timeoutId);
            resolve({
                result: result,
                error: error
            });
        };
        if (playResult !== undefined) playResult.then(function() {
            return sendOutput(true);
        }).catch(function(playError) {
            return sendOutput(false, playError);
        });
        else sendOutput(true);
    });
}
//
// API
//
function $f66167a3c26eb16f$var$video(options) {
    options = $f66167a3c26eb16f$var$setupDefaultValues(options);
    return $f66167a3c26eb16f$var$startPlayback(options, function() {
        return {
            element: document.createElement('video'),
            source: URL.createObjectURL($f66167a3c26eb16f$var$VIDEO)
        };
    });
}
function $f66167a3c26eb16f$var$audio(options) {
    options = $f66167a3c26eb16f$var$setupDefaultValues(options);
    return $f66167a3c26eb16f$var$startPlayback(options, function() {
        return {
            element: document.createElement('audio'),
            source: URL.createObjectURL($f66167a3c26eb16f$var$AUDIO)
        };
    });
}
var $f66167a3c26eb16f$var$index = {
    audio: $f66167a3c26eb16f$var$audio,
    video: $f66167a3c26eb16f$var$video
};
var $f66167a3c26eb16f$export$2e2bcd8739ae039 = $f66167a3c26eb16f$var$index;


// set user variables ----------------------------------------------------------
let $eab0398616e9ffb4$var$didPageInteraction = false;
const $eab0398616e9ffb4$var$showBlockedAutoplayHolderSelector = '.home'; // these will show OS play button
// set default variables -------------------------------------------------------
const $eab0398616e9ffb4$var$mediaSelector = '.media__video:not(.media__video--preview), .media__audio';
let $eab0398616e9ffb4$var$mediaTouchTimeout;
let $eab0398616e9ffb4$var$mediaDragging = false;
let $eab0398616e9ffb4$var$mediaDragEl;
const $eab0398616e9ffb4$export$4ea236338c7d64ed = ()=>{
    // click listener ------------------------------
    document.body.addEventListener('click', (event)=>{
        // autoplay video asap on mobile battery saver
        // touchstart doesn't count as interaction for unmuting
        // once
        if (!$eab0398616e9ffb4$var$didPageInteraction) {
            // actual autoplay videos, not ones that have autoplay from Fader.js
            const mediaVideoEls = document.querySelectorAll('video[autoplay]:not([data-autoplay="false"]):not([data-src=""])');
            mediaVideoEls.forEach((mediaVideoEl)=>{
                // mediaVideoEl.play(); // done from listeners already
                const mediaHolder = mediaVideoEl.closest('.media__holder');
                if (mediaHolder) mediaHolder.classList.remove('media__holder--hidden');
            });
            $eab0398616e9ffb4$var$didPageInteraction = true;
        }
        // tapped entire video
        let el = event.target.closest('.media');
        if (el && $183c77cc0773b3dc$export$507ba88fae84526c) {
            // show controls on touch
            const mediaEl = el;
            mediaEl.classList.add('media--touched');
            clearTimeout($eab0398616e9ffb4$var$mediaTouchTimeout);
            $eab0398616e9ffb4$var$mediaTouchTimeout = setTimeout(()=>{
                mediaEl.classList.remove('media--touched');
            }, $183c77cc0773b3dc$export$34977f05af4bf228);
        }
        // click play/pause
        el = event.target.closest('.media__btn--play-pause, .media__play');
        if (el) $eab0398616e9ffb4$export$4b6478966c109e99(el.closest('.media'));
        // click mute/unmute
        el = event.target.closest('.media__btn--audio');
        if (el) {
            const mediaEl = el.closest('.media');
            const mediaMediaEl = mediaEl.querySelector($eab0398616e9ffb4$var$mediaSelector);
            if (mediaEl.classList.contains('media--muted')) {
                if (mediaMediaEl) mediaMediaEl.muted = false;
                mediaEl.classList.remove('media--muted');
            } else {
                // mute
                if (mediaMediaEl) mediaMediaEl.muted = true;
                mediaEl.classList.add('media--muted');
            }
        }
        // click grow/shrink
        el = event.target.closest('.media__btn--fullscreen');
        if (el) {
            const mediaEl = el.closest('.media');
            if (!mediaEl) return;
            if (mediaEl.classList.contains('media--fullscreen')) $eab0398616e9ffb4$var$closeFullscreenMedia(mediaEl);
            else {
                mediaEl.classList.add('media--fullscreen');
                $eab0398616e9ffb4$var$setVideoFaderFS(mediaEl);
                if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
            }
        }
    });
    // mousedown listener ------------------------------
    document.addEventListener('mousedown', (event)=>{
        let el = event.target.closest('.media__progress');
        if (el) {
            $eab0398616e9ffb4$var$setMediaProgress(event, el, 'mouse');
            $eab0398616e9ffb4$var$mediaDragEl = el;
            $eab0398616e9ffb4$var$mediaDragging = true;
        }
    });
    // touchstart listener ------------------------------
    document.body.addEventListener('touchstart', (event)=>{
        let el = event.target.closest('.media__progress');
        if (el) {
            $eab0398616e9ffb4$var$setMediaProgress(event, el, 'touch');
            $eab0398616e9ffb4$var$mediaDragEl = el;
            $eab0398616e9ffb4$var$mediaDragging = true;
        }
    });
    // mousemove listener ------------------------------
    document.addEventListener('mousemove', (event)=>{
        if ($eab0398616e9ffb4$var$mediaDragging) $eab0398616e9ffb4$var$setMediaProgress(event, $eab0398616e9ffb4$var$mediaDragEl, 'mouse');
    });
    // touchmove listener ------------------------------
    document.body.addEventListener('touchmove', (event)=>{
        if ($eab0398616e9ffb4$var$mediaDragging) $eab0398616e9ffb4$var$setMediaProgress(event, $eab0398616e9ffb4$var$mediaDragEl, 'touch');
    });
    // mouseup listener ------------------------------
    document.addEventListener('mouseup', (event)=>{
        $eab0398616e9ffb4$var$mediaDragging = false;
    });
    // touchend listener ------------------------------
    document.body.addEventListener('touchend', (event)=>{
        $eab0398616e9ffb4$var$mediaDragging = false;
    });
    // keyboard focus on media buttons ----------------
    document.body.addEventListener('focusin', (event)=>{
        let el = event.target.closest('.media__btn');
        if (el) {
            const mediaEl = el.closest('.media');
            if (mediaEl) mediaEl.classList.add('media--focus');
        }
    });
    // keyboard blur on media buttons ----------------
    document.body.addEventListener('focusout', (event)=>{
        let el = event.target.closest('.media__btn');
        if (el) {
            const mediaEl = el.closest('.media');
            if (mediaEl) mediaEl.classList.remove('media--focus');
        }
    });
    document.addEventListener('keyup', (event)=>{
        const fsMediaEl = document.querySelector('.media--fullscreen');
        if (!fsMediaEl) return;
        if (event.code === 'Escape') $eab0398616e9ffb4$var$closeFullscreenMedia(fsMediaEl);
        else if (event.code === 'Space') $eab0398616e9ffb4$export$4b6478966c109e99(fsMediaEl);
    });
    document.addEventListener('keydown', (event)=>{
        // block keyboard scrolling on fullscreen media
        if (document.querySelector('.media--fullscreen')) {
            if ([
                'Space',
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.code) > -1) event.preventDefault();
        }
    }, false);
};
const $eab0398616e9ffb4$export$74fd572b7937cf92 = ()=>{
    // console.log('setMediaItems');
    (0, $f66167a3c26eb16f$export$2e2bcd8739ae039).video({
        timeout: 1000,
        muted: true,
        inline: true
    }).then(({ result: result, error: error })=>{
        // console.log({result, didPageInteraction});
        // even on battery saver, after a page interaction you can always autoplay video
        if (!result && !$eab0398616e9ffb4$var$didPageInteraction && $183c77cc0773b3dc$export$507ba88fae84526c) {
            // can't autoplay video's, so hide them
            // actual autoplay video's, not ones that have autoplay from Fader.js
            const mediaVideoEls = document.querySelectorAll('video[autoplay]:not([data-autoplay="false"])');
            mediaVideoEls.forEach((mediaVideoEl)=>{
                // If the media__video element can't autoplay and is not in the noHideAutoplayHolder, hide it
                const showBlockedAutoplayHolder = mediaVideoEl.closest($eab0398616e9ffb4$var$showBlockedAutoplayHolderSelector);
                if (!showBlockedAutoplayHolder) {
                    const mediaHolder = mediaVideoEl.closest('.media__holder');
                    if (mediaHolder) mediaHolder.classList.add('media__holder--hidden');
                }
            });
        }
    });
    let mediaMediaEls = document.querySelectorAll('.media__video:not([autoplay]):not(.media__video--preview), .media__audio');
    // console.log({mediaMediaEls});
    // remove observer from elements first
    $eab0398616e9ffb4$var$mediaSrcObserver.disconnect();
    mediaMediaEls.forEach((mediaMediaEl)=>{
        $eab0398616e9ffb4$var$mediaSrcObserver.observe(mediaMediaEl, {
            attributes: true
        });
        // remove Listeners for possible re-init
        mediaMediaEl.removeEventListener('ended', (event)=>{});
        mediaMediaEl.removeEventListener('webkitendfullscreen', (event)=>{});
        mediaMediaEl.removeEventListener('play', (event)=>{});
        mediaMediaEl.removeEventListener('pause', (event)=>{});
        mediaMediaEl.removeEventListener('timeupdate', (event)=>{});
        mediaMediaEl.addEventListener('ended', (event)=>{
            // console.log('ended', {autoplay: event.currentTarget.autoplay});
            // doesn't fire on iOS (sometimes)
            $eab0398616e9ffb4$var$endedMedia(event.currentTarget.closest('.media'));
        });
        mediaMediaEl.addEventListener('webkitendfullscreen', (event)=>{
            // console.log('fullscreen');
            // This pauses the media, so do correct actions
            const mediaEl = event.currentTarget.closest('.media');
            $eab0398616e9ffb4$var$pauseMedia(mediaEl);
        });
        mediaMediaEl.addEventListener('play', (event)=>{
            // console.log('play');
            const mediaEl = event.currentTarget.closest('.media');
            if (mediaEl) {
                mediaEl.classList.add('media--playing');
                const mediaVideoEl = mediaEl.querySelector('.media__video');
                // console.log(mediaVideoEl.dataset.mayplay);
                if (mediaVideoEl && mediaVideoEl.dataset.mayplay === 'true') mediaEl.classList.add('media--started'); // hides preview
            }
        });
        mediaMediaEl.addEventListener('pause', (event)=>{
            // console.log('pause');
            const mediaEl = event.currentTarget.closest('.media');
            if (mediaEl) mediaEl.classList.remove('media--playing');
        });
    });
    // fix for random autoplay pausing
    mediaMediaEls = document.querySelectorAll('.media__video[autoplay]');
    mediaMediaEls.forEach((mediaMediaEl)=>{
        mediaMediaEl.addEventListener('pause', (event)=>{
            // console.log('pause autoplay');
            event.currentTarget.play();
        });
    });
    mediaMediaEls = document.querySelectorAll('.media__video:not(.media__video--preview), .media__audio');
    mediaMediaEls.forEach((mediaMediaEl)=>{
        mediaMediaEl.addEventListener('timeupdate', (event)=>{
            $eab0398616e9ffb4$var$showMediaTime(event.currentTarget);
        });
    });
    // in timeout not to interfere with the load event
    setTimeout(()=>{
        // open/play video's in the current selector
        if (typeof $historySelector === 'undefined') return;
        const historySelectorEl = document.querySelector($historySelector);
        if (historySelectorEl) {
            if (typeof openVideoEmbeds === 'function') openVideoEmbeds(historySelectorEl, false);
            $eab0398616e9ffb4$var$playAutoplayVideos(historySelectorEl);
        }
        // both skip foldouts
        let otherSelector;
        if ($historySelector == '.popover') otherSelector = '.main';
        else otherSelector = '.popover';
        // stop video's in the other selector
        const otherEl = document.querySelector(otherSelector);
        if (otherEl) {
            if (typeof closeVideoEmbeds === 'function') closeVideoEmbeds(otherEl);
            $eab0398616e9ffb4$export$593d508bb877f2f(otherEl);
        }
    }, $183c77cc0773b3dc$export$35a4a76088200152);
};
// must be called when setting slick -------------------------------------------
// const setSlickVideo = $slickSlider => {
//   // pause other medias
//   $slickSlider.on('afterChange', (event, slick, currentSlide) => {
//     // console.log('afterChange');
//     const otherSlides = '.slick-slide:not([data-slick-index="' + currentSlide + '"])';
//     const $otherSlides = $(event.currentTarget).find(otherSlides);
//     $otherSlides.each((index, element) => {
//       const $media = $(element).find(mediaSelector);
//       // console.log({ $media });
//       $media.trigger('pause');
//       $(element).find('.media').removeClass('media--playing');
//     });
//   });
//   // if autoplay, continue current media
//   $slickSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
//     const slide = '.slick-slide[data-slick-index="' + nextSlide + '"]';
//     const $currentSlide = $(event.currentTarget).find(slide);
//     const $media = $currentSlide.find(mediaSelector);
//     // console.log('beforeChange', { slide, $currentSlide, $media }, $media.prop('autoplay'));
//     if ($media.length && $media.prop('autoplay') === true) $media.trigger('play');
//     // media--playing doesn't get added for autoplay medias
//   });
// };
// functions -------------------------------------------------------------------
const $eab0398616e9ffb4$var$setMediaProgress = (event, progressEl, inputType)=>{
    const mediaEl = progressEl.closest('.media');
    if (!mediaEl) return;
    const mediaMediaEl = mediaEl.querySelector($eab0398616e9ffb4$var$mediaSelector);
    if (!mediaMediaEl) return;
    mediaEl.classList.add('media--started'); // hides preview
    let x;
    if (inputType == 'touch') x = event.touches[0].clientX - progressEl.getBoundingClientRect().left;
    else x = event.clientX - progressEl.getBoundingClientRect().left;
    const percentage = x / progressEl.offsetWidth * 100;
    mediaMediaEl.currentTime = mediaMediaEl.duration / 100 * percentage;
    $eab0398616e9ffb4$var$showMediaTime(mediaMediaEl, mediaMediaEl.currentTime);
    mediaEl.classList.add('media--touched');
    clearTimeout($eab0398616e9ffb4$var$mediaTouchTimeout);
    $eab0398616e9ffb4$var$mediaTouchTimeout = setTimeout(()=>{
        mediaEl.classList.remove('media--touched');
    }, $183c77cc0773b3dc$export$34977f05af4bf228);
};
const $eab0398616e9ffb4$var$closeFullscreenMedia = (mediaEl)=>{
    // hide holder, for safari fix
    // const zoomEl = mediaEl.closest('.zoom--active');
    // if (zoomEl) zoomEl.classList.remove('zoom--active');
    mediaEl.classList.remove('media--fullscreen');
    $eab0398616e9ffb4$var$setVideoFaderFS(mediaEl);
    if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
// show holder, for safari fix
// if (zoomEl) zoomEl.classList.add('zoom--active');
};
// load fullscreen video if available
const $eab0398616e9ffb4$var$setVideoFaderFS = (mediaEl)=>{
    if (!mediaEl) return;
    const mediaMediaEl = mediaEl.querySelector($eab0398616e9ffb4$var$mediaSelector);
    if (!mediaMediaEl) return;
    // this is the element that initialises the loading of a fullscreen source
    const mediaLoaderEl = mediaMediaEl.closest('.fader--loader, .fader--loading, .fader--loaded');
    if (mediaLoaderEl) {
        if (mediaEl.classList.contains('media--fullscreen')) mediaLoaderEl.classList.add('fader--fullscreen'); // removes transition so it remains fullscreen
        else mediaLoaderEl.classList.remove('fader--fullscreen');
        // begins possible load of fullscreen source
        if ('fader' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.fader.setFaders();
    }
};
const $eab0398616e9ffb4$export$4b6478966c109e99 = (mediaEl)=>{
    if (!mediaEl) return;
    if (mediaEl.classList.contains('media--playing')) $eab0398616e9ffb4$var$pauseMedia(mediaEl);
    else {
        $eab0398616e9ffb4$export$593d508bb877f2f(document.body);
        // audioBtnEls.forEach(audioBtnEl => audioBtnEl.classList.add('audio-btn--visible'));
        // end wilde weide
        // not playing, so play
        const mediaMediaEl = mediaEl.querySelector($eab0398616e9ffb4$var$mediaSelector);
        // console.log({mediaEl, mediaMediaEl});
        if (mediaMediaEl) {
            mediaMediaEl.dataset.mayplay = 'true'; // set mayplay so preview can fade
            if (!mediaMediaEl.src) {
                let classname = mediaMediaEl.getAttribute('class');
                classname += ' ' + mediaMediaEl.dataset.fader;
                mediaMediaEl.setAttribute('class', classname);
                if ('fader' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.fader.setFaders();
            }
            mediaMediaEl.play();
        }
    }
};
const $eab0398616e9ffb4$var$showMediaTime = (mediaMediaEl, seconds = mediaMediaEl.currentTime)=>{
    // console.log('showMediaTime', {mediaMediaEl, seconds});
    if (!mediaMediaEl) return;
    // save current time for when switching sources
    if (seconds != 0) mediaMediaEl.dataset.seconds = seconds;
    let timeString;
    if (seconds < 3600) timeString = new Date(mediaMediaEl.currentTime * 1000).toISOString().slice(14, 19);
    else timeString = new Date(mediaMediaEl.currentTime * 1000).toISOString().slice(12, 19);
    const timeEl = mediaMediaEl.closest('.media').querySelector('.media__time');
    if (timeEl) timeEl.innerHTML = timeString;
    let percentage = seconds / mediaMediaEl.duration * 100;
    if (isNaN(percentage)) percentage = 0;
    const progressEl = mediaMediaEl.closest('.media').querySelector('.media__progress-bar');
    if (progressEl) progressEl.style.left = percentage + '%';
    if (mediaMediaEl.currentTime == mediaMediaEl.duration && seconds != 0) // media ended, but 'ended' doensn't fire on ios, so use this
    $eab0398616e9ffb4$var$endedMedia(mediaMediaEl.closest('.media'));
};
const $eab0398616e9ffb4$var$endedMedia = (mediaEl)=>{
    $eab0398616e9ffb4$var$pauseMedia(mediaEl);
    mediaEl.classList.remove('media--started');
    const mediaMediaEl = mediaEl.querySelector($eab0398616e9ffb4$var$mediaSelector);
    if (mediaMediaEl) mediaMediaEl.currentTime = 0;
};
const $eab0398616e9ffb4$var$pauseMedia = (mediaEl)=>{
    // console.log('pauseMedia', {mediaEl});
    const mediaMediaEl = mediaEl.querySelector($eab0398616e9ffb4$var$mediaSelector);
    if (mediaMediaEl) mediaMediaEl.pause();
// audioBtnEls.forEach(audioBtnEl => audioBtnEl.classList.remove('audio-btn--visible'));
};
const $eab0398616e9ffb4$var$playAutoplayVideos = (holderEl)=>{
    // console.log('playAutoplayVideos', holderEl);
    const mediaMediaEls = holderEl.querySelectorAll($eab0398616e9ffb4$var$mediaSelector);
    mediaMediaEls.forEach((mediaMediaEl)=>{
        // skips closed foldouts
        const foldout = mediaMediaEl.closest('.fold-out');
        // console.log({mediaMediaEl, foldout});
        if (mediaMediaEl.autoplay && (!foldout || foldout.classList.contains('fold-out--opened'))) mediaMediaEl.play();
    });
};
const $eab0398616e9ffb4$export$593d508bb877f2f = (holderEl)=>{
    const mediaMediaEls = holderEl.querySelectorAll($eab0398616e9ffb4$var$mediaSelector);
    mediaMediaEls.forEach((mediaMediaEl)=>{
        const mediaEl = mediaMediaEl.closest('.media');
        if (mediaEl) $eab0398616e9ffb4$var$pauseMedia(mediaEl);
    });
};
const $eab0398616e9ffb4$var$mediaSrcObserver = new MutationObserver((mutations)=>{
    mutations.forEach((mutation)=>{
        if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
            // console.log('src changed to: ' + mutation.target.src);
            const mediaEl = mutation.target.closest('.media');
            if (mediaEl) mediaEl.classList.remove('media--playing');
            // set video with new source to the same time
            const mediaMediaEl = mutation.target;
            const { seconds: seconds } = mediaMediaEl.dataset;
            if (seconds) {
                mediaMediaEl.currentTime = seconds;
                $eab0398616e9ffb4$var$showMediaTime(mediaMediaEl, seconds);
            }
        }
    });
});


/**
 * Swiper 12.0.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: September 18, 2025
 */ /**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $0868fe5596dee114$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $0868fe5596dee114$var$extend(target = {}, src = {}) {
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($0868fe5596dee114$var$isObject(src[key]) && $0868fe5596dee114$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $0868fe5596dee114$var$extend(target[key], src[key]);
    });
}
const $0868fe5596dee114$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $0868fe5596dee114$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $0868fe5596dee114$var$extend(doc, $0868fe5596dee114$var$ssrDocument);
    return doc;
}
const $0868fe5596dee114$var$ssrWindow = {
    document: $0868fe5596dee114$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $0868fe5596dee114$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $0868fe5596dee114$var$extend(win, $0868fe5596dee114$var$ssrWindow);
    return win;
}



function $f97f33853a605dba$export$35e795649ee09318(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $f97f33853a605dba$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $f97f33853a605dba$export$7ccc53e8f1e7dfc5(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $f97f33853a605dba$export$2d1720544b23b823() {
    return Date.now();
}
function $f97f33853a605dba$var$getComputedStyle(el) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $f97f33853a605dba$export$342063e11d6c3cad(el, axis = 'x') {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $f97f33853a605dba$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $f97f33853a605dba$export$ae1af26003f05816(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $f97f33853a605dba$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $f97f33853a605dba$export$d141bba7fdc215a3(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$f97f33853a605dba$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($f97f33853a605dba$export$ae1af26003f05816(to[nextKey]) && $f97f33853a605dba$export$ae1af26003f05816(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f97f33853a605dba$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$f97f33853a605dba$export$ae1af26003f05816(to[nextKey]) && $f97f33853a605dba$export$ae1af26003f05816(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f97f33853a605dba$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $f97f33853a605dba$export$407448d2b89b1813(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $f97f33853a605dba$export$3b14a55fb2447963({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $f97f33853a605dba$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $f97f33853a605dba$export$f1e1789686576879(element, selector = '') {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $f97f33853a605dba$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $f97f33853a605dba$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $f97f33853a605dba$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $f97f33853a605dba$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $f97f33853a605dba$export$db3b6bfb95261072(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $f97f33853a605dba$export$35e795649ee09318(classes));
    return el;
}
function $f97f33853a605dba$export$4368d992c4eafac0(el) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $f97f33853a605dba$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $f97f33853a605dba$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $f97f33853a605dba$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $f97f33853a605dba$export$23f2a1d2818174ef(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $f97f33853a605dba$export$8b22cf2602fb60ce(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $f97f33853a605dba$export$882b5998b3b9117c(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $f97f33853a605dba$export$dda1d9f60106f0e9(el, size, includeMargins) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $f97f33853a605dba$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $f97f33853a605dba$export$ffb5f4729a158638(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $f97f33853a605dba$export$2408f22a0fab9ae5(el, html = '') {
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $1262f2e38e280703$var$support;
function $1262f2e38e280703$var$calcSupport() {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $1262f2e38e280703$var$getSupport() {
    if (!$1262f2e38e280703$var$support) $1262f2e38e280703$var$support = $1262f2e38e280703$var$calcSupport();
    return $1262f2e38e280703$var$support;
}
let $1262f2e38e280703$var$deviceCached;
function $1262f2e38e280703$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = $1262f2e38e280703$var$getSupport();
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $1262f2e38e280703$var$getDevice(overrides = {}) {
    if (!$1262f2e38e280703$var$deviceCached) $1262f2e38e280703$var$deviceCached = $1262f2e38e280703$var$calcDevice(overrides);
    return $1262f2e38e280703$var$deviceCached;
}
let $1262f2e38e280703$var$browser;
function $1262f2e38e280703$var$calcBrowser() {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const device = $1262f2e38e280703$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $1262f2e38e280703$var$getBrowser() {
    if (!$1262f2e38e280703$var$browser) $1262f2e38e280703$var$browser = $1262f2e38e280703$var$calcBrowser();
    return $1262f2e38e280703$var$browser;
}
function $1262f2e38e280703$var$Resize({ swiper: swiper, on: on, emit: emit }) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $1262f2e38e280703$var$Observer({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $1262f2e38e280703$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $1262f2e38e280703$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $1262f2e38e280703$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $f97f33853a605dba$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $f97f33853a605dba$export$dda1d9f60106f0e9)(slide, 'width', true) : (0, $f97f33853a605dba$export$dda1d9f60106f0e9)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (offsetBefore || 0) + (offsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $f97f33853a605dba$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $1262f2e38e280703$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $1262f2e38e280703$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $1262f2e38e280703$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $1262f2e38e280703$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $1262f2e38e280703$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $1262f2e38e280703$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $1262f2e38e280703$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $1262f2e38e280703$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $1262f2e38e280703$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $f97f33853a605dba$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $f97f33853a605dba$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $1262f2e38e280703$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $1262f2e38e280703$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $1262f2e38e280703$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $1262f2e38e280703$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $1262f2e38e280703$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $1262f2e38e280703$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $1262f2e38e280703$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $1262f2e38e280703$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $1262f2e38e280703$var$unlazy(swiper, i);
    }
};
function $1262f2e38e280703$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $1262f2e38e280703$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $1262f2e38e280703$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $1262f2e38e280703$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $1262f2e38e280703$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $1262f2e38e280703$var$update = {
    updateSize: $1262f2e38e280703$var$updateSize,
    updateSlides: $1262f2e38e280703$var$updateSlides,
    updateAutoHeight: $1262f2e38e280703$var$updateAutoHeight,
    updateSlidesOffset: $1262f2e38e280703$var$updateSlidesOffset,
    updateSlidesProgress: $1262f2e38e280703$var$updateSlidesProgress,
    updateProgress: $1262f2e38e280703$var$updateProgress,
    updateSlidesClasses: $1262f2e38e280703$var$updateSlidesClasses,
    updateActiveIndex: $1262f2e38e280703$var$updateActiveIndex,
    updateClickedSlide: $1262f2e38e280703$var$updateClickedSlide
};
function $1262f2e38e280703$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $f97f33853a605dba$export$342063e11d6c3cad)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $1262f2e38e280703$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $1262f2e38e280703$var$minTranslate() {
    return -this.snapGrid[0];
}
function $1262f2e38e280703$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $1262f2e38e280703$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $f97f33853a605dba$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $1262f2e38e280703$var$translate = {
    getTranslate: $1262f2e38e280703$var$getSwiperTranslate,
    setTranslate: $1262f2e38e280703$var$setTranslate,
    minTranslate: $1262f2e38e280703$var$minTranslate,
    maxTranslate: $1262f2e38e280703$var$maxTranslate,
    translateTo: $1262f2e38e280703$var$translateTo
};
function $1262f2e38e280703$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $1262f2e38e280703$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $1262f2e38e280703$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $1262f2e38e280703$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $1262f2e38e280703$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $1262f2e38e280703$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $1262f2e38e280703$var$transition = {
    setTransition: $1262f2e38e280703$var$setTransition,
    transitionStart: $1262f2e38e280703$var$transitionStart,
    transitionEnd: $1262f2e38e280703$var$transitionEnd
};
function $1262f2e38e280703$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $f97f33853a605dba$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $1262f2e38e280703$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $1262f2e38e280703$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $1262f2e38e280703$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $1262f2e38e280703$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $1262f2e38e280703$var$slide = {
    slideTo: $1262f2e38e280703$var$slideTo,
    slideToLoop: $1262f2e38e280703$var$slideToLoop,
    slideNext: $1262f2e38e280703$var$slideNext,
    slidePrev: $1262f2e38e280703$var$slidePrev,
    slideReset: $1262f2e38e280703$var$slideReset,
    slideToClosest: $1262f2e38e280703$var$slideToClosest,
    slideToClickedSlide: $1262f2e38e280703$var$slideToClickedSlide
};
function $1262f2e38e280703$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $f97f33853a605dba$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $1262f2e38e280703$var$loopFix({ slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $f97f33853a605dba$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $1262f2e38e280703$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $1262f2e38e280703$var$loop = {
    loopCreate: $1262f2e38e280703$var$loopCreate,
    loopFix: $1262f2e38e280703$var$loopFix,
    loopDestroy: $1262f2e38e280703$var$loopDestroy
};
function $1262f2e38e280703$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $1262f2e38e280703$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $1262f2e38e280703$var$grabCursor = {
    setGrabCursor: $1262f2e38e280703$var$setGrabCursor,
    unsetGrabCursor: $1262f2e38e280703$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $1262f2e38e280703$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $0868fe5596dee114$export$39b482c5e57630a8)() || el === (0, $0868fe5596dee114$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $1262f2e38e280703$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $1262f2e38e280703$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $1262f2e38e280703$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $f97f33853a605dba$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $1262f2e38e280703$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$1262f2e38e280703$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $1262f2e38e280703$var$onTouchMove(event) {
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $1262f2e38e280703$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $1262f2e38e280703$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $1262f2e38e280703$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $1262f2e38e280703$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $1262f2e38e280703$var$onLoad(e) {
    const swiper = this;
    $1262f2e38e280703$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $1262f2e38e280703$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $1262f2e38e280703$var$events = (swiper, method)=>{
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $1262f2e38e280703$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $1262f2e38e280703$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $1262f2e38e280703$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $1262f2e38e280703$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $1262f2e38e280703$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $1262f2e38e280703$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $1262f2e38e280703$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $1262f2e38e280703$var$onScroll.bind(swiper);
    swiper.onClick = $1262f2e38e280703$var$onClick.bind(swiper);
    swiper.onLoad = $1262f2e38e280703$var$onLoad.bind(swiper);
    $1262f2e38e280703$var$events(swiper, 'on');
}
function $1262f2e38e280703$var$detachEvents() {
    const swiper = this;
    $1262f2e38e280703$var$events(swiper, 'off');
}
var $1262f2e38e280703$var$events$1 = {
    attachEvents: $1262f2e38e280703$var$attachEvents,
    detachEvents: $1262f2e38e280703$var$detachEvents
};
const $1262f2e38e280703$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $1262f2e38e280703$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $1262f2e38e280703$var$isGridEnabled(swiper, params);
    const isMultiRow = $1262f2e38e280703$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $f97f33853a605dba$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $1262f2e38e280703$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $1262f2e38e280703$var$breakpoints = {
    setBreakpoint: $1262f2e38e280703$var$setBreakpoint,
    getBreakpoint: $1262f2e38e280703$var$getBreakpoint
};
function $1262f2e38e280703$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $1262f2e38e280703$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $1262f2e38e280703$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $1262f2e38e280703$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $1262f2e38e280703$var$classes = {
    addClasses: $1262f2e38e280703$var$addClasses,
    removeClasses: $1262f2e38e280703$var$removeClasses
};
function $1262f2e38e280703$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $1262f2e38e280703$var$checkOverflow$1 = {
    checkOverflow: $1262f2e38e280703$var$checkOverflow
};
var $1262f2e38e280703$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $1262f2e38e280703$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $f97f33853a605dba$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $f97f33853a605dba$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $f97f33853a605dba$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $1262f2e38e280703$var$prototypes = {
    eventsEmitter: $1262f2e38e280703$var$eventsEmitter,
    update: $1262f2e38e280703$var$update,
    translate: $1262f2e38e280703$var$translate,
    transition: $1262f2e38e280703$var$transition,
    slide: $1262f2e38e280703$var$slide,
    loop: $1262f2e38e280703$var$loop,
    grabCursor: $1262f2e38e280703$var$grabCursor,
    events: $1262f2e38e280703$var$events$1,
    breakpoints: $1262f2e38e280703$var$breakpoints,
    checkOverflow: $1262f2e38e280703$var$checkOverflow$1,
    classes: $1262f2e38e280703$var$classes
};
const $1262f2e38e280703$var$extendedDefaults = {};
class $1262f2e38e280703$export$25ce5a424b770e84 {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $1262f2e38e280703$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $1262f2e38e280703$var$getSupport();
        swiper.device = $1262f2e38e280703$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $1262f2e38e280703$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $1262f2e38e280703$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, $1262f2e38e280703$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, swiperParams, $1262f2e38e280703$var$extendedDefaults, params);
        swiper.originalParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $f97f33853a605dba$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $f97f33853a605dba$export$23f2a1d2818174ef)(slides[0]);
        return (0, $f97f33853a605dba$export$23f2a1d2818174ef)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $f97f33853a605dba$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $1262f2e38e280703$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $f97f33853a605dba$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $f97f33853a605dba$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $f97f33853a605dba$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $f97f33853a605dba$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $1262f2e38e280703$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $1262f2e38e280703$var$processLazyPreloader(swiper, e.target);
            });
        });
        $1262f2e38e280703$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $1262f2e38e280703$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $f97f33853a605dba$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $f97f33853a605dba$export$d141bba7fdc215a3)($1262f2e38e280703$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $1262f2e38e280703$var$extendedDefaults;
    }
    static get defaults() {
        return $1262f2e38e280703$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__) $1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $1262f2e38e280703$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$1262f2e38e280703$export$25ce5a424b770e84.installModule(m));
            return $1262f2e38e280703$export$25ce5a424b770e84;
        }
        $1262f2e38e280703$export$25ce5a424b770e84.installModule(module);
        return $1262f2e38e280703$export$25ce5a424b770e84;
    }
}
Object.keys($1262f2e38e280703$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($1262f2e38e280703$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $1262f2e38e280703$export$25ce5a424b770e84.prototype[protoMethod] = $1262f2e38e280703$var$prototypes[prototypeGroup][protoMethod];
    });
});
$1262f2e38e280703$export$25ce5a424b770e84.use([
    $1262f2e38e280703$var$Resize,
    $1262f2e38e280703$var$Observer
]);






function $91b4fe59f517404d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $f97f33853a605dba$export$407448d2b89b1813)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $2a1c43be64e359f8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $f97f33853a605dba$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $f97f33853a605dba$export$4368d992c4eafac0)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $1e6c01efa040ca9a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $f97f33853a605dba$export$2d1720544b23b823)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $f97f33853a605dba$export$2d1720544b23b823)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $f97f33853a605dba$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $f97f33853a605dba$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $306a0aea613e7477$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



const $dc75855670d5bebb$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function $dc75855670d5bebb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $306a0aea613e7477$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempEl, $dc75855670d5bebb$var$arrowSvg);
                    el.appendChild(tempEl.querySelector('svg'));
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $129272ba76d8b432$export$db3b6bfb95261072(classes = '') {
    return `.${classes.trim().replace(/([\.:!+\/()[\]])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $a65bf22b710e8cc3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $f97f33853a605dba$export$23f2a1d2818174ef)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $f97f33853a605dba$export$dda1d9f60106f0e9)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $f97f33853a605dba$export$23f2a1d2818174ef)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $129272ba76d8b432$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $306a0aea613e7477$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $f97f33853a605dba$export$8b22cf2602fb60ce)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $acf6379ef00d1b73$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $f97f33853a605dba$export$4368d992c4eafac0)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $306a0aea613e7477$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $f97f33853a605dba$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $9eab48129a718d0a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $f97f33853a605dba$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $f97f33853a605dba$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $5ce60fb5cd45355e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $f97f33853a605dba$export$342063e11d6c3cad)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $f97f33853a605dba$export$342063e11d6c3cad)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $f97f33853a605dba$export$4368d992c4eafac0)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $f97f33853a605dba$export$4368d992c4eafac0)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f97f33853a605dba$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $4ee670f8e74e92c5$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $f97f33853a605dba$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $f97f33853a605dba$export$882b5998b3b9117c)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $9df471290665e5ad$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $f97f33853a605dba$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $f97f33853a605dba$export$23f2a1d2818174ef)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $129272ba76d8b432$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $f97f33853a605dba$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $f97f33853a605dba$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $bdde5ed48a8716dc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $900bed1a87b88621$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
    const window = (0, $0868fe5596dee114$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $f97f33853a605dba$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $ccf162aef171d9ed$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params }) {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $8051f561d9b02add$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $f97f33853a605dba$export$ae1af26003f05816)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $f97f33853a605dba$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $0868fe5596dee114$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $83be9fecc6264cb2$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $f97f33853a605dba$export$2d1720544b23b823)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $f97f33853a605dba$export$2d1720544b23b823)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $f97f33853a605dba$export$2d1720544b23b823)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $f97f33853a605dba$export$882b5998b3b9117c)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $f97f33853a605dba$export$882b5998b3b9117c)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $f97f33853a605dba$export$882b5998b3b9117c)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $ddd0c2ed1384f58e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $f08f7df954f7b274$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $f08f7df954f7b274$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $f97f33853a605dba$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $f08f7df954f7b274$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $f08f7df954f7b274$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $f08f7df954f7b274$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $f08f7df954f7b274$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: $f08f7df954f7b274$var$appendSlide.bind(swiper),
        prependSlide: $f08f7df954f7b274$var$prependSlide.bind(swiper),
        addSlide: $f08f7df954f7b274$var$addSlide.bind(swiper),
        removeSlide: $f08f7df954f7b274$var$removeSlide.bind(swiper),
        removeAllSlides: $f08f7df954f7b274$var$removeAllSlides.bind(swiper)
    });
}


function $e0e15645344c9e40$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $b53f154314d4e7c8$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $999496ad6a55bf28$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $f97f33853a605dba$export$882b5998b3b9117c)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $1aaae3023eb523a1$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $ae560e392d45c8b7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $0a10add51d1983e4$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $f97f33853a605dba$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $03034e94e938a55a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $f2ff8c65b6ddc62a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $2d1d46abc1b4e0b9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $f97f33853a605dba$export$ffb5f4729a158638)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $ddebdb27567903ce$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $0a10add51d1983e4$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $b53f154314d4e7c8$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f97f33853a605dba$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $999496ad6a55bf28$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $e0e15645344c9e40$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






(0, $1262f2e38e280703$export$25ce5a424b770e84).use([
    (0, $dc75855670d5bebb$export$2e2bcd8739ae039),
    (0, $ccf162aef171d9ed$export$2e2bcd8739ae039)
]);
const $b7c88863cbfbcd57$export$ece7705a25021b6d = document.body.querySelectorAll('.gradient');
const $b7c88863cbfbcd57$export$867dcd50196c50f3 = document.body.querySelectorAll('.charts');
const $b7c88863cbfbcd57$var$navItemClasses = [
    'nav-list__link'
]; // add &[aria-current="page"] to styles for active state
const $b7c88863cbfbcd57$var$handleCountryCode = async (goToLang)=>{
    // console.log('handleCountryCode', {goToLang});
    const endpoint = 'wp-json/bbcapital/v1/country-code';
    const url = `${$baseUrl}${endpoint}`;
    try {
        const response = await fetch(url, {
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const countryCode = (data?.country_code || '').toLowerCase();
        const englishHomeUrl = $languages?.en?.url || $baseUrl + 'en/';
        // console.log('handleCountryCode', {countryCode, englishHomeUrl, goToLang});
        if (!countryCode) return;
        if (countryCode !== 'nl' && countryCode !== 'be' && englishHomeUrl && goToLang === 'en') window.location.replace(englishHomeUrl);
        else if ((countryCode === 'nl' || countryCode === 'be') && goToLang === 'nl') window.location.replace($baseUrl);
        return countryCode;
    } catch (error) {
        console.error('Failed to load country code', error);
        return '';
    }
};
const $b7c88863cbfbcd57$export$5e830c5f3cd8a610 = ({ prepareFaderForViewTransition: prepareFaderForViewTransition = window.blPageTransition } = {})=>{
    // sets all the pages
    // console.log('setPage');
    // setters -----------------------------------------------
    (0, $a35e88d1ef46936c$export$d7ad141dbf28d3d)(); // before historySetPage, because it might change URLs
    (0, $6364af678aaff281$export$aa50272292466539)($b7c88863cbfbcd57$var$navItemClasses, {
        postTypeSlugs: $arPostTypes,
        baseUrl: $url
    }); // after fixLocalTesting, because it might change URLs
    // if ('setExample' in Example) Example.setExample();
    if ($56a526a578fe3239$exports.splitter && typeof $56a526a578fe3239$exports.splitter.setSplitters === 'function') $56a526a578fe3239$exports.splitter.setSplitters();
    if ($56a526a578fe3239$exports.vtOutOfView && typeof $56a526a578fe3239$exports.vtOutOfView.refreshElements === 'function') $56a526a578fe3239$exports.vtOutOfView.refreshElements(); // saves elements array to var
    if ($56a526a578fe3239$exports.horScroller && typeof $56a526a578fe3239$exports.horScroller.refreshElements === 'function') $56a526a578fe3239$exports.horScroller.refreshElements(true);
    if ('setMediaItems' in $eab0398616e9ffb4$exports) $eab0398616e9ffb4$exports.setMediaItems();
    // homepage language check and redirect if needed -----------------------------------------------
    const browserLanguage = navigator.language || navigator.languages?.[0] || '';
    // console.log({browserLanguage, href: window.location.href, baseUrl: $baseUrl, redirected: sessionStorage.getItem('bbLanguageSet')});
    if (window.location.href === $baseUrl) {
        const browserIsEnglishLike = /^en(?:$|-)/i.test(browserLanguage);
        if (browserIsEnglishLike && sessionStorage.getItem('bbLanguageSet') !== '1') $b7c88863cbfbcd57$var$handleCountryCode('en');
    } else if (window.location.href === $baseUrl + 'en/') {
        const browserIsDutchLike = /^nl(?:$|-)/i.test(browserLanguage);
        // const browserIsDutchLike = true;
        if (browserIsDutchLike && sessionStorage.getItem('bbLanguageSet') !== '1') $b7c88863cbfbcd57$var$handleCountryCode('nl');
    }
    // when the user has been redirected, we don't want to redirect them again on subsequent visits
    // also, you don't want to redirect when they go from a homepage to the homepage in another language
    sessionStorage.setItem('bbLanguageSet', '1');
    // initialize Swiper ----------------------------------------------
    const swiperEls = document.querySelectorAll('.slider__swiper');
    swiperEls.forEach((swiperEl)=>{
        const isCenter = swiperEl.classList.contains('slider__swiper--center');
        const prevBtnEl = swiperEl.parentElement.querySelector('.swiper-button-prev');
        const nextBtnEl = swiperEl.parentElement.querySelector('.swiper-button-next');
        const mySwiper = new (0, $1262f2e38e280703$export$25ce5a424b770e84)(swiperEl, {
            // Swiper options here
            // modules: [Navigation, Pagination],
            direction: 'horizontal',
            speed: $183c77cc0773b3dc$export$507ba88fae84526c ? 400 : 800,
            loop: isCenter,
            centeredSlides: isCenter,
            autoplay: {
                enabled: isCenter,
                delay: 2000,
                disableOnInteraction: true
            },
            navigation: {
                nextEl: nextBtnEl,
                prevEl: prevBtnEl
            },
            variableWidth: true,
            slidesPerView: 'auto',
            touchStartPreventDefault: $183c77cc0773b3dc$export$507ba88fae84526c ? true : false
        });
    });
    // browser color
    const background = getComputedStyle(document.body).getPropertyValue('background-color');
    document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
    // most of the time it's better to do an element check instead of a pageType check
    // switch ($pageType) {
    // }
    if (!$56a526a578fe3239$exports.useHistoryNavigation) $b7c88863cbfbcd57$export$dfdac01fb43f2195();
};
const $b7c88863cbfbcd57$export$dfdac01fb43f2195 = ({ prepareFaderForViewTransition: prepareFaderForViewTransition = window.blPageTransition, delay: delay = true } = {})=>{
    // console.log('setPageAfterSetScroll', {prepareFaderForViewTransition});
    if ('fader' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.fader.init === 'function') $56a526a578fe3239$exports.fader.init(); // has a safeguard against multiple inits
    // has vt and new page
    if (prepareFaderForViewTransition && 'fader' in $56a526a578fe3239$exports) $56a526a578fe3239$exports.fader.doSkipOnLoadInView(false); // false to not call setFaders, done below
    if (prepareFaderForViewTransition || !delay) $56a526a578fe3239$exports.observerUnblocker(); // calls setResize() and setFaders();
    else // no vt and transitionDelay exists
    setTimeout($56a526a578fe3239$exports.observerUnblocker, $56a526a578fe3239$exports.transitionDelay - 200); // looks nice to start fader before the end of the main fade-in 
};




// set user variables ---------------------------------------------------------
const $56a526a578fe3239$var$vtDuration = $183c77cc0773b3dc$export$34977f05af4bf228 * .5; // also change in view-transitions css
let $56a526a578fe3239$export$48c3efaeac751014;
let $56a526a578fe3239$export$760c9eb46059594c;
let $56a526a578fe3239$export$55a5c8f21be693ee;
let $56a526a578fe3239$export$a424a0aa8f687495;
let $56a526a578fe3239$export$c60327b420936b9e;
let $56a526a578fe3239$export$43aab11487ea38c9;
let $56a526a578fe3239$export$8987e38cfd004b13;
let $56a526a578fe3239$export$8cfde575cbd41e40;
let $56a526a578fe3239$export$55abd4691b317664;
let $56a526a578fe3239$export$8f2aa2ab7b76b0d5;
let $56a526a578fe3239$export$510413726083552f;
let $56a526a578fe3239$export$bba485742287c13f = sessionStorage.getItem('pageType');
document.body.setAttribute('data-pagetype-prev', $56a526a578fe3239$export$bba485742287c13f);
sessionStorage.setItem('pageType', $pageType);
const $56a526a578fe3239$var$browserColorEl = document.querySelector('.browser-color');
const $56a526a578fe3239$export$9d68b6ad9acc2308 = !(typeof $usePageTransitions !== 'undefined' && $usePageTransitions);
const $56a526a578fe3239$export$caa6e1ba6b757214 = ()=>{
    // console.log('once', window.blPageTransition ? 'view-transition' : 'no view-transition');
    // safari delay should be after VT duration, because css transitions are buggy during VT
    $56a526a578fe3239$export$8cfde575cbd41e40 = new (0, $e21bfd3f9dbb41e9$export$2e2bcd8739ae039)({
        wordHolderSelector: '.words, .heading--h1, .heading--h2, .heading--h3',
        wordTiming: {
            delay: $183c77cc0773b3dc$export$73e6618aa19ac9d5 ? 400 : 0,
            stagger: 100
        },
        textClass: 'fader fader--up fader--repeat',
        imgClass: 'fader fader--loader fader--repeat'
    });
    if ($183c77cc0773b3dc$export$60de2f8f1539cec2) // add || Vars.blFirefox if you have vt elements with fader--force
    $56a526a578fe3239$export$48c3efaeac751014 = $183c77cc0773b3dc$export$73e6618aa19ac9d5 ? $56a526a578fe3239$var$vtDuration : $56a526a578fe3239$var$vtDuration - 0; // 200 before last transition end is kinda nice. Fixes safari css transition issue
    else $56a526a578fe3239$export$48c3efaeac751014 = $183c77cc0773b3dc$export$35a4a76088200152; // main fade-out duration if using history
    // add Fader
    $56a526a578fe3239$export$760c9eb46059594c = new (0, $0b34a3644a6f4c48$export$2e2bcd8739ae039)({
        // mobileMq: '(orientation: portrait)',
        // fadeDur: 1000,
        stagger: 100,
        // preFadeResizeDur: 200,
        // afterLoadFunction: Resize.saveOffsets, 
        inViewFadeDelay: $56a526a578fe3239$export$48c3efaeac751014,
        addStaggerToFaderDelay: false,
        fadeScrollersSelector: '.flap'
    });
    $56a526a578fe3239$export$8987e38cfd004b13 = new (0, $109fd3484ed6546c$export$2e2bcd8739ae039)({
        // duration: 400, // set to --switcher-duration
        startCallback: $56a526a578fe3239$export$2f5ac5bcfd51f435,
        afterFadeOutCallback: (switcherEl)=>{
            if ($56a526a578fe3239$export$760c9eb46059594c && typeof $56a526a578fe3239$export$760c9eb46059594c.fadeInHolderAgain === 'function') $56a526a578fe3239$export$760c9eb46059594c.fadeInHolderAgain(switcherEl); // not needed for fader loading images, that is done in observerUnblocker
        },
        afterResizeCallback: $56a526a578fe3239$export$5a0a8e9ff7c0e4a7
    });
    $56a526a578fe3239$export$8987e38cfd004b13.init();
    // disable view-transition-name for elements outside viewport
    $56a526a578fe3239$export$8f2aa2ab7b76b0d5 = new (0, $5ed1486d1d2cc343$export$2e2bcd8739ae039)({
        selector: '[data-vt-name]'
    });
    // add FoldOut
    $56a526a578fe3239$export$55a5c8f21be693ee = new (0, $8cb15295fbe17ca3$export$2e2bcd8739ae039)({
        name: 'default',
        startCallback: $56a526a578fe3239$export$2f5ac5bcfd51f435,
        duringCallback: $b5ee8e0943d4762a$export$6bbf62f168c1dddc,
        callback: $56a526a578fe3239$export$5a0a8e9ff7c0e4a7,
        // closeOthers: false,
        // transitionDuration: 600; // also change _fold-out.scss
        closeInOtherHolders: true
    });
    $56a526a578fe3239$export$55a5c8f21be693ee.init();
    // add HorScroll
    $56a526a578fe3239$export$510413726083552f = new (0, $ebc1dd69562e7bb7$export$2e2bcd8739ae039)({
    });
    if ($183c77cc0773b3dc$export$507ba88fae84526c) $56a526a578fe3239$export$510413726083552f.init();
    // horScroller.init(); // only if buttons to scroll, because not all devices have horizontal scroll
    // add AnimateIt
    $56a526a578fe3239$export$a424a0aa8f687495 = new (0, $2dc0ac34957019d1$export$2e2bcd8739ae039)({
    });
    $56a526a578fe3239$export$a424a0aa8f687495.init();
    // slow scroll and mouse follower
    // if (typeof animator !== 'undefined') {
    //   // not on firefox if iframes are present
    //   // if (!Vars.blTouch && !Vars.blFirefox) {
    //   if (!Vars.blTouch) {
    //     const initSmoothScroll = () => {
    //       animator.smoothScroll({
    //         speed: 0.2,
    //         bounce: 1,
    //       });
    //     };
    //     if (history && typeof history.historyCheckWoocommerce === 'function') {
    //       if (!historyCheckWoocommerce(window.location.href)) initSmoothScroll();
    //     } else {
    //       initSmoothScroll();
    //     }
    //   }
    // }
    $56a526a578fe3239$export$c60327b420936b9e = typeof $56a526a578fe3239$export$a424a0aa8f687495 === 'undefined' || typeof $56a526a578fe3239$export$a424a0aa8f687495.scroller !== 'object';
    if ($56a526a578fe3239$export$9d68b6ad9acc2308) {
        $56a526a578fe3239$export$55abd4691b317664 = new (0, $7cc9ee14c2971c5c$export$2e2bcd8739ae039)({
            useCache: false,
            projectTitle: $baseTitle,
            viewTransitions: $183c77cc0773b3dc$export$60de2f8f1539cec2,
            cookiesPrefix: typeof Cookies !== 'undefined' && 'cookiesPrefix' in Cookies ? Cookies.cookiesPrefix : 'lf-p2',
            setScrollTop: $b5ee8e0943d4762a$export$38a81aac5c9c320d,
            samePage: $56a526a578fe3239$var$historySamePage,
            animateBefore: $56a526a578fe3239$var$historyAnimateBefore,
            beforeSwitch: $56a526a578fe3239$var$historyBeforeSwitch,
            newContent: ()=>$b7c88863cbfbcd57$export$5e830c5f3cd8a610({
                    prepareFaderForViewTransition: $183c77cc0773b3dc$export$60de2f8f1539cec2
                }),
            afterSetScroll: ()=>$b7c88863cbfbcd57$export$dfdac01fb43f2195({
                    prepareFaderForViewTransition: $183c77cc0773b3dc$export$60de2f8f1539cec2
                }),
            loadEventDelay: 0,
            resetLineDelay: 0 + $183c77cc0773b3dc$export$35a4a76088200152
        });
        $56a526a578fe3239$export$55abd4691b317664.init();
    } else $56a526a578fe3239$export$55abd4691b317664 = undefined;
    // output name for devvers ----------------------------------
    console.log('%cSite by', 'color: #999; font-size: 16px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
    console.log('%cLittle Fragments', 'color: #999; font-size: 24px; font-family: "Arial"; font-weight: bold; text-transform: uppercase;');
};
// functions -------------------------------------------------------------------
// for history -----------------------------------------------
const $56a526a578fe3239$var$historySamePage = (href)=>{
    // document.body.classList.remove('body--nav');
    if ($historySelector === '.popover') $b5ee8e0943d4762a$export$60388f6293022a1f.animateScrollTop(0, {
        element: document.querySelector('.popover')
    });
    else {
        if (href.indexOf('#') === -1) $b5ee8e0943d4762a$export$60388f6293022a1f.animateScrollTop(0);
        else if ($56a526a578fe3239$export$c60327b420936b9e) {
            const anchorElement = document.getElementById(href.split('#')[1]);
            if (anchorElement) $b5ee8e0943d4762a$export$9e22b9da3b459613(anchorElement);
        }
    }
};
const $56a526a578fe3239$var$historyAnimateBefore = (setDoneAnimating)=>{
    if ($183c77cc0773b3dc$export$60de2f8f1539cec2) setDoneAnimating();
    else setTimeout(setDoneAnimating, $183c77cc0773b3dc$export$34977f05af4bf228); // allow content to fade out, because there is no VT
};
const $56a526a578fe3239$var$historyBeforeSwitch = ()=>{
    // document.body.classList.remove('body--nav');
    // removes selector from old page so it doesn't interfere with new page
    if ($56a526a578fe3239$export$a424a0aa8f687495 && typeof $56a526a578fe3239$export$a424a0aa8f687495.resetFollowMouseClasses === 'function') $56a526a578fe3239$export$a424a0aa8f687495.resetFollowMouseClasses();
    // sync check so vt names are set before the browser takes the snapshot
    if ($56a526a578fe3239$export$8f2aa2ab7b76b0d5 && typeof $56a526a578fe3239$export$8f2aa2ab7b76b0d5.checkSync === 'function') $56a526a578fe3239$export$8f2aa2ab7b76b0d5.checkSync();
    $56a526a578fe3239$export$2f5ac5bcfd51f435(); // so observers don't call resize while replacing content
};
const $56a526a578fe3239$export$2f5ac5bcfd51f435 = ()=>{
    // console.log('observerBlocker');
    $41264c54ad2c6427$export$6e2267417cad2903(true);
    if (typeof $56a526a578fe3239$export$760c9eb46059594c !== 'undefined' && $56a526a578fe3239$export$760c9eb46059594c) $56a526a578fe3239$export$760c9eb46059594c.setBlockResizeObserver(true);
    if (typeof $56a526a578fe3239$export$a424a0aa8f687495 !== 'undefined' && $56a526a578fe3239$export$a424a0aa8f687495) $56a526a578fe3239$export$a424a0aa8f687495.blockResizeObserver = true;
};
const $56a526a578fe3239$export$5a0a8e9ff7c0e4a7 = ()=>{
    // console.log('observerUnblocker');  
    $41264c54ad2c6427$export$6e2267417cad2903(false);
    $41264c54ad2c6427$export$1871afb4a41ded14(true);
    if (typeof $56a526a578fe3239$export$760c9eb46059594c !== 'undefined' && $56a526a578fe3239$export$760c9eb46059594c) {
        $56a526a578fe3239$export$760c9eb46059594c.setBlockResizeObserver(false);
        $56a526a578fe3239$export$760c9eb46059594c.setFaders();
    }
    if (typeof $56a526a578fe3239$export$a424a0aa8f687495 !== 'undefined' && $56a526a578fe3239$export$a424a0aa8f687495) {
        $56a526a578fe3239$export$a424a0aa8f687495.blockResizeObserver = false;
        $56a526a578fe3239$export$a424a0aa8f687495.resizeHandler(true);
    }
} // const frameHandler = () => {
 //   // console.log('frameHandler');
 //   // browser color
 //   if (browserColorEl) {
 //     const background = getComputedStyle(browserColorEl).getPropertyValue('background-color');
 //     document.querySelector('meta[name="theme-color"]').setAttribute('content', background);
 //   }
 // };
;



// set user variables ---------------------------------------------------------
const $41264c54ad2c6427$var$resizeHolders = [
    '.main',
    '.popover'
]; // comment to turn off resize observer
let $41264c54ad2c6427$export$c99e242bffb864af = 0;
let $41264c54ad2c6427$export$c2f81cb82ec2bad8 = 0;
let $41264c54ad2c6427$export$83c62512efb68338 = 0;
let $41264c54ad2c6427$export$5a628068c28e339f = 0;
let $41264c54ad2c6427$export$b5aee153f48e3586 = 0;
let $41264c54ad2c6427$export$f3ad53fe9668839f = 0;
let $41264c54ad2c6427$export$95704ce82a7378af = 0;
let $41264c54ad2c6427$export$a0f5451bfdace5c4 = true;
let $41264c54ad2c6427$export$d9a4610da62f362e = 0;
let $41264c54ad2c6427$export$b3948ff9ea48227b = 0;
let $41264c54ad2c6427$export$47e578be7ea7065c = 0;
let $41264c54ad2c6427$export$6d541604d001cc1d = 0;
let $41264c54ad2c6427$export$90901bcb70c82302 = 0;
let $41264c54ad2c6427$export$104dfeb21e8f6f17 = false; // set to true during animations to not call setResize
let $41264c54ad2c6427$export$24f4c7f1d039d0b6 = 0;
let $41264c54ad2c6427$export$19b14ce01af68523 = 0;
function $41264c54ad2c6427$export$6e2267417cad2903(value) {
    $41264c54ad2c6427$export$104dfeb21e8f6f17 = value;
}
const $41264c54ad2c6427$var$rootStyle = document.documentElement.style;
let $41264c54ad2c6427$var$prevInnerWidth = 0;
let $41264c54ad2c6427$var$prevObserverWidth = 0;
let $41264c54ad2c6427$var$prevObserverHeight = 0;
let $41264c54ad2c6427$var$footerSocialsWidth = 0;
let $41264c54ad2c6427$var$first = true;
let $41264c54ad2c6427$var$observerResizeTimer = null;
const $41264c54ad2c6427$export$1a8cec7304e4a7df = ()=>{
    // visual viewport resize listener
    window.visualViewport.addEventListener('resize', $41264c54ad2c6427$export$1871afb4a41ded14);
    $183c77cc0773b3dc$export$dd32b77e25b56ab8.addEventListener('change', ()=>{
        setTimeout($41264c54ad2c6427$export$1871afb4a41ded14, 100);
    });
    // resize observer
    if (typeof $41264c54ad2c6427$var$resizeHolders !== 'undefined') for(let i = 0; i < $41264c54ad2c6427$var$resizeHolders.length; i++){
        // add an observer for each holder that resizes
        const observedEls = document.querySelectorAll($41264c54ad2c6427$var$resizeHolders[i]);
        observedEls.forEach((observedEl)=>{
            if (observedEl !== null) new ResizeObserver($41264c54ad2c6427$var$observerResize).observe(observedEl);
        });
    }
    // run once even if body is fixed
    $41264c54ad2c6427$var$doSaveOffsets();
};
const $41264c54ad2c6427$export$1871afb4a41ded14 = (force = false)=>{
    if (typeof force === 'object') force = false;
    // console.log('setResize', force);
    // do resizing actions
    const ftEl = document.querySelector('.full-touch');
    if (!ftEl) return;
    $41264c54ad2c6427$export$f3ad53fe9668839f = ftEl.offsetHeight; // height including navbar on touch
    $41264c54ad2c6427$export$5a628068c28e339f = window.innerHeight; // height minus current navbar on touch
    $41264c54ad2c6427$export$d9a4610da62f362e = $41264c54ad2c6427$export$f3ad53fe9668839f - $41264c54ad2c6427$export$5a628068c28e339f; // current navbar on touch
    if ($41264c54ad2c6427$var$first) $41264c54ad2c6427$export$95704ce82a7378af = $41264c54ad2c6427$export$d9a4610da62f362e; // navbar height
    $41264c54ad2c6427$var$first = false;
    $41264c54ad2c6427$export$83c62512efb68338 = $41264c54ad2c6427$export$f3ad53fe9668839f - $41264c54ad2c6427$export$95704ce82a7378af; // height minus navbar on touch
    $41264c54ad2c6427$export$c99e242bffb864af = document.documentElement.clientWidth; // width without scrollbar
    $41264c54ad2c6427$export$c2f81cb82ec2bad8 = window.innerWidth; // width with scrollbar
    $41264c54ad2c6427$export$b5aee153f48e3586 = window.visualViewport.height; // height minus current navbar and keyboard on touch
    $41264c54ad2c6427$export$a0f5451bfdace5c4 = $41264c54ad2c6427$export$5a628068c28e339f === $41264c54ad2c6427$export$83c62512efb68338 ? 1 : 0;
    $41264c54ad2c6427$var$rootStyle.setProperty('--window-width', $41264c54ad2c6427$export$c99e242bffb864af + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--window-height', $41264c54ad2c6427$export$83c62512efb68338 + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--inner-height', $41264c54ad2c6427$export$5a628068c28e339f + 'px'); // sometimes wrong on android
    $41264c54ad2c6427$var$rootStyle.setProperty('--viewport-height', $41264c54ad2c6427$export$b5aee153f48e3586 + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--navbar-height', $41264c54ad2c6427$export$95704ce82a7378af + 'px');
    $41264c54ad2c6427$var$rootStyle.setProperty('--current-navbar-height', $41264c54ad2c6427$export$d9a4610da62f362e + 'px');
    // on touch, if the body is fixed, menu is always present
    // so adding height: 100% is the way to add a correct size popover
    // or by setting height to windowHeight with js
    if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll(); // before resizing
    // when resizing width or height ---------------------------------------------
    // resize things
    // save sizes for css, use Rect because of subpixel values!!
    const headerEl = document.querySelector('.header');
    if (headerEl) {
        $41264c54ad2c6427$export$24f4c7f1d039d0b6 = headerEl.getBoundingClientRect().height;
        $41264c54ad2c6427$var$rootStyle.setProperty('--header-height', $41264c54ad2c6427$export$24f4c7f1d039d0b6 + 'px');
    }
    const afmEl = document.querySelector('.afm');
    if (afmEl) {
        $41264c54ad2c6427$export$19b14ce01af68523 = afmEl.getBoundingClientRect().height;
        $41264c54ad2c6427$var$rootStyle.setProperty('--afm-height', $41264c54ad2c6427$export$19b14ce01af68523 + 'px');
    }
    const footerSocialsEl = document.querySelector('.footer__socials');
    if (footerSocialsEl) {
        $41264c54ad2c6427$var$footerSocialsWidth = footerSocialsEl.getBoundingClientRect().width;
        $41264c54ad2c6427$var$rootStyle.setProperty('--footer-socials-width', $41264c54ad2c6427$var$footerSocialsWidth + 'px');
    }
    // check if resize width or forced
    if ($41264c54ad2c6427$export$c2f81cb82ec2bad8 === $41264c54ad2c6427$var$prevInnerWidth && force === false) {
        $41264c54ad2c6427$export$11d57d7ff6599491();
        $b5ee8e0943d4762a$exports.setScroll();
        return;
    }
    $41264c54ad2c6427$var$prevInnerWidth = $41264c54ad2c6427$export$c2f81cb82ec2bad8;
    // from here is skipped when only resizing height ----------------------------
    // console.log('resizing width');
    // logo repeater speed
    const repeaterEls = document.querySelectorAll('.ticker__repeater');
    repeaterEls.forEach((repeaterEl)=>{
        const rect = repeaterEl.getBoundingClientRect();
        const { width: width } = rect;
        // set css animation duration based on width
        const duration = width / 100;
        repeaterEl.style.setProperty('--duration', duration + 's');
    });
    // last
    $41264c54ad2c6427$export$11d57d7ff6599491();
    $b5ee8e0943d4762a$exports.setScroll();
};
const $41264c54ad2c6427$export$11d57d7ff6599491 = ()=>{
    // console.log('saveOffsets');
    if ('fixer' in $56a526a578fe3239$exports && typeof $56a526a578fe3239$exports.fixer?.bodyFixed !== 'undefined') {
        if ($56a526a578fe3239$exports.fixer.bodyFixed !== true) $41264c54ad2c6427$var$doSaveOffsets();
    } else $41264c54ad2c6427$var$doSaveOffsets();
};
const $41264c54ad2c6427$var$doSaveOffsets = ()=>{
    // console.log('doSaveOffsets'); 
    // always call this through saveOffsets
    // save offsets here
    $41264c54ad2c6427$export$47e578be7ea7065c = document.documentElement.scrollHeight; // entire document height
    $41264c54ad2c6427$export$6d541604d001cc1d = $41264c54ad2c6427$export$47e578be7ea7065c - $41264c54ad2c6427$export$5a628068c28e339f;
    $41264c54ad2c6427$var$rootStyle.setProperty('--document-height', $41264c54ad2c6427$export$47e578be7ea7065c + 'px');
    $41264c54ad2c6427$export$b3948ff9ea48227b = document.documentElement.scrollWidth; // entire document width
    $41264c54ad2c6427$export$90901bcb70c82302 = $41264c54ad2c6427$export$b3948ff9ea48227b - $41264c54ad2c6427$export$c99e242bffb864af;
    // documentHeight based calculations
    const headerBtnsEl = document.querySelector('.buttons--header');
    const headerLogoEl = document.querySelector('.header__logo');
    if (headerBtnsEl && headerLogoEl) {
        const rect = headerBtnsEl.getBoundingClientRect();
        headerLogoEl.style.setProperty('--header-btns-width', rect.width + 'px');
    }
};
// check for resizing of holders
const $41264c54ad2c6427$var$observerResize = ()=>{
    clearTimeout($41264c54ad2c6427$var$observerResizeTimer);
    // in timeout to prevent multiple calls when resizing window
    $41264c54ad2c6427$var$observerResizeTimer = setTimeout(()=>{
        // console.log('observerResize', blockResizeObserver, windowWidth, prevObserverWidth, windowHeight, prevObserverHeight);
        // prevent double resize when resizing window
        if (($41264c54ad2c6427$export$c99e242bffb864af !== $41264c54ad2c6427$var$prevObserverWidth || $41264c54ad2c6427$export$83c62512efb68338 !== $41264c54ad2c6427$var$prevObserverHeight) && $41264c54ad2c6427$var$prevObserverWidth !== 0) {
            $41264c54ad2c6427$var$prevObserverWidth = $41264c54ad2c6427$export$c99e242bffb864af;
            $41264c54ad2c6427$var$prevObserverHeight = $41264c54ad2c6427$export$83c62512efb68338;
            return;
        }
        $41264c54ad2c6427$var$prevObserverWidth = $41264c54ad2c6427$export$c99e242bffb864af;
        $41264c54ad2c6427$var$prevObserverHeight = $41264c54ad2c6427$export$83c62512efb68338;
        // not animating? do resize
        if (!$41264c54ad2c6427$export$104dfeb21e8f6f17) $41264c54ad2c6427$export$1871afb4a41ded14(true);
    }, 0);
};



const $d1dffb77f2e2cbfc$export$da79f85e8b84a959 = 'bb'; // for instance a project code
// local variables ------------------------------------------------------------
const $d1dffb77f2e2cbfc$var$cookiesBlockPage = true; // do the cookies overlay the entire page?
const $d1dffb77f2e2cbfc$var$cookiesCursorEl = document.querySelector('.cookies-cursor');
let $d1dffb77f2e2cbfc$export$b6695554533f9b1e = true; // when there is no cookie popup, iframes are allowed
// local variables ------------------------------------------------------------
let $d1dffb77f2e2cbfc$var$cookiesSetIframes = false; // so you know if applying cookies should reset video embeds
const $d1dffb77f2e2cbfc$var$cookiePopover1El = document.querySelector('.popover--cookies-1');
const $d1dffb77f2e2cbfc$var$cookiePopover2El = document.querySelector('.popover--cookies-2');
const $d1dffb77f2e2cbfc$export$a2cf2b09102a656b = (shouldOpenBanner = true)=>{
    // console.log('initCookies');
    document.body.addEventListener('click', (event)=>{
        let el = event.target.closest('.blocked-iframe__button');
        if (el) {
            if ($d1dffb77f2e2cbfc$var$cookiePopover2El) $d1dffb77f2e2cbfc$var$cookiePopover2El.classList.add('popover--active');
            if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
        }
        el = event.target.closest('.cookies .toggle__btn');
        if (el) {
            const toggleEl = el.closest('.toggle');
            if (toggleEl) toggleEl.classList.toggle('toggle--off');
        }
        let acceptAllSelector = '.js-cookies-accept-all';
        if ($d1dffb77f2e2cbfc$var$cookiesCursorEl && !$183c77cc0773b3dc$export$507ba88fae84526c) {
            acceptAllSelector += ', .popover--cookies-1 .popover__bg-btn';
            acceptAllSelector += ', .popover--cookies-2 .popover__bg-btn';
        }
        el = event.target.closest(acceptAllSelector);
        if (el) {
            localStorage.setItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'SetCookies', 1);
            for(let i = 0; i < $cookies.length; i++)$cookies[i].accepted = true;
            localStorage.setItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'Cookies', JSON.stringify($cookies));
            $d1dffb77f2e2cbfc$var$checkReload();
        }
        el = event.target.closest('.js-cookies-reject-all');
        if (el) {
            localStorage.setItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'SetCookies', 1);
            for(let i = 0; i < $cookies.length; i++)$cookies[i].accepted = false;
            localStorage.setItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'Cookies', JSON.stringify($cookies));
            $d1dffb77f2e2cbfc$var$checkReload();
        }
        el = event.target.closest('.cookies__settings, .js-cookies-btn');
        if (el && $d1dffb77f2e2cbfc$var$cookiePopover1El && $d1dffb77f2e2cbfc$var$cookiePopover2El) {
            $d1dffb77f2e2cbfc$var$cookiePopover1El.classList.remove('popover--active');
            $d1dffb77f2e2cbfc$var$cookiePopover2El.classList.add('popover--active');
            if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
        }
        el = event.target.closest('.cookies__selected');
        if (el) {
            localStorage.setItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'SetCookies', 1);
            const cookieToggleEls = document.querySelectorAll('.cookies .toggle');
            if ($cookies) {
                for(let i = 0; i < $cookies.length; i++)if (cookieToggleEls[i] && cookieToggleEls[i].classList.contains('toggle--off')) $cookies[i].accepted = false;
                else $cookies[i].accepted = true;
            }
            localStorage.setItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'Cookies', JSON.stringify($cookies));
            $d1dffb77f2e2cbfc$var$checkReload();
        }
    });
    if ($d1dffb77f2e2cbfc$var$cookiesCursorEl) {
        // mouse and keyboard --------------------------------
        // mouseout, focusout listeners
        const outHandler = (event)=>{
            if ($183c77cc0773b3dc$export$507ba88fae84526c) return;
            let el = event.target.closest('.popover--cookies-1 .popover__bg-btn, .popover--cookies-2 .popover__bg-btn');
            if (el) $d1dffb77f2e2cbfc$var$cookiesCursorEl.classList.remove('cookies-cursor--active');
        };
        document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
        // mouseover, focusin listeners
        const inHandler = (event)=>{
            if ($183c77cc0773b3dc$export$507ba88fae84526c) return;
            let el = event.target.closest('.popover--cookies-1 .popover__bg-btn, .popover--cookies-2 .popover__bg-btn');
            if (el) $d1dffb77f2e2cbfc$var$cookiesCursorEl.classList.add('cookies-cursor--active');
        };
        document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
        // mouse move listener
        document.body.addEventListener('mousemove', (event)=>{
            const x = event.clientX;
            const y = event.clientY;
            const el = event.target.closest('.popover--cookies-1 .popover__bg-btn, .popover--cookies-2 .popover__bg-btn');
            if (el) $d1dffb77f2e2cbfc$var$cookiesCursorEl.style.transform = `translate(${x}px, ${y}px)`;
        });
    }
    // if cookies are set, always do openBanner, because that handles your settings
    if (shouldOpenBanner || localStorage.getItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'SetCookies') !== null) $d1dffb77f2e2cbfc$export$d9841960328045f4();
};
const $d1dffb77f2e2cbfc$export$d9841960328045f4 = ()=>{
    const cookiesEl = document.querySelector('.cookies');
    if (!cookiesEl) return;
    // functional cookies
    $d1dffb77f2e2cbfc$export$3d6d112e1c42474a($cookiesFunctional.head);
    $d1dffb77f2e2cbfc$export$3d6d112e1c42474a($cookiesFunctional.body);
    // so it's done before body fix, when it can still be done
    $41264c54ad2c6427$export$1871afb4a41ded14(true);
    // additional cookies
    if (localStorage.getItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'SetCookies') === null) // console.log('additional cookies not set prevously');
    $d1dffb77f2e2cbfc$var$showCookies();
    else if (typeof $cookies != 'undefined') {
        // console.log('additional cookies are set previously', {$cookies});
        // get saved cookies
        const jsonCookies = JSON.parse(localStorage.getItem($d1dffb77f2e2cbfc$export$da79f85e8b84a959 + 'Cookies'));
        // compare saved and cms cookies
        if ($cookies.length == jsonCookies.length) {
            let cookiesChanged = false;
            for(let i = 0; i < $cookies.length; i++)if ($cookies[i].head != jsonCookies[i].head || $cookies[i].body != jsonCookies[i].body) {
                cookiesChanged = true;
                break;
            }
            // console.log({cookiesChanged});
            if (cookiesChanged) $d1dffb77f2e2cbfc$var$showCookies();
            else {
                $cookies = jsonCookies; // get accepted boolean per cookie
                $d1dffb77f2e2cbfc$var$applyCookies();
            }
        } else // new length, show cookies
        $d1dffb77f2e2cbfc$var$showCookies();
    }
};
// functions -------------------------------------------------------------------
const $d1dffb77f2e2cbfc$var$showCookies = ()=>{
    // console.log('showCookies');
    if ($d1dffb77f2e2cbfc$var$cookiePopover1El) $d1dffb77f2e2cbfc$var$cookiePopover1El.classList.add('popover--active');
    if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
    // if there is a iframe toggle, don't accept iframes for now
    if ($cookies) {
        for(let i = 0; i < $cookies.length; i++)if ($cookies[i].type == 'iframes') {
            $d1dffb77f2e2cbfc$var$cookiesSetIframes = true;
            $d1dffb77f2e2cbfc$export$b6695554533f9b1e = false;
        }
    }
};
const $d1dffb77f2e2cbfc$var$closeCookies = ()=>{
    // console.log('closeCookies');
    if ($d1dffb77f2e2cbfc$var$cookiePopover1El) $d1dffb77f2e2cbfc$var$cookiePopover1El.classList.remove('popover--active');
    if ($d1dffb77f2e2cbfc$var$cookiePopover2El) $d1dffb77f2e2cbfc$var$cookiePopover2El.classList.remove('popover--active');
    if ('checkBlockScroll' in $b5ee8e0943d4762a$exports) $b5ee8e0943d4762a$exports.checkBlockScroll();
};
const $d1dffb77f2e2cbfc$var$checkReload = ()=>{
    // console.log('checkReload', $cookies);
    if ($cookies) {
        for(let i = 0; i < $cookies.length; i++)if ($cookies[i].type == 'script' && $cookies[i].reload_page && $cookies[i].accepted) {
            // reload page is needed for this cookie to work correctly and it is accepted
            // console.log('reload page needed');
            window.location.reload();
            return;
        }
    }
    $d1dffb77f2e2cbfc$var$applyCookies();
};
const $d1dffb77f2e2cbfc$var$applyCookies = ()=>{
    // console.log('applyCookies');
    $d1dffb77f2e2cbfc$export$b6695554533f9b1e = true;
    if ($cookies) for(let i = 0; i < $cookies.length; i++){
        if ($cookies[i].type == 'iframes') {
            $d1dffb77f2e2cbfc$var$cookiesSetIframes = true;
            if (!$cookies[i].accepted) // don't accept iframes
            $d1dffb77f2e2cbfc$export$b6695554533f9b1e = false;
        } else if ($cookies[i].type == 'script') {
            if ($cookies[i].accepted) {
                // add script to page
                $d1dffb77f2e2cbfc$export$3d6d112e1c42474a($cookies[i].head);
                $d1dffb77f2e2cbfc$export$3d6d112e1c42474a($cookies[i].body);
            }
        }
    }
    $d1dffb77f2e2cbfc$var$closeCookies();
    // console.log({cookiesSetIframes, cookiesAcceptIframes});
    $d1dffb77f2e2cbfc$export$d4ef740ab7d8e5af();
};
const $d1dffb77f2e2cbfc$export$3d6d112e1c42474a = (html)=>{
    // console.log('cookiesAddHTML', html);
    const elm = document.createElement('div');
    document.body.appendChild(elm);
    elm.innerHTML = html;
    Array.from(elm.querySelectorAll('script')).forEach((oldScript)=>{
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr)=>newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
    });
};
const $d1dffb77f2e2cbfc$export$9247c17b52f5af42 = ()=>{
    // console.log('openIframes', {cookiesAcceptIframes});
    if (typeof $d1dffb77f2e2cbfc$export$b6695554533f9b1e === 'undefined' || $d1dffb77f2e2cbfc$export$b6695554533f9b1e) document.body.classList.add('body--iframes-accepted');
    else document.body.classList.remove('body--iframes-accepted');
};
const $d1dffb77f2e2cbfc$export$d4ef740ab7d8e5af = ()=>{
    // open iframes that were blocked
    if ($d1dffb77f2e2cbfc$var$cookiesSetIframes) {
        const blockedIframeEls = document.querySelectorAll('.blocked-iframe--visible');
        blockedIframeEls.forEach((blockedIframeEl)=>{
            const videoEmbedEl = blockedIframeEl.closest('.video-embed');
            // console.log({videoEmbedEl});
            if (videoEmbedEl && 'openVideoEmbed' in VideoEmbed) VideoEmbed.openVideoEmbed(videoEmbedEl, false); // don't autoplay when accepting cookies after clicking play on a video, because that would be annoying
            // embeds
            const embedEl = blockedIframeEl.closest('[data-code]');
            if (embedEl) {
                const code = embedEl.dataset.code;
                // console.log({code, cookiesAcceptIframes});
                if (code && $d1dffb77f2e2cbfc$export$b6695554533f9b1e && !embedEl.querySelector('iframe')) {
                    // Parse the HTML to separate script tags
                    const temp = document.createElement('div');
                    temp.innerHTML = code;
                    // Insert all non-script content
                    const scripts = temp.querySelectorAll('script');
                    scripts.forEach((script)=>script.remove());
                    embedEl.insertAdjacentHTML('afterbegin', temp.innerHTML);
                    // Execute any script tags
                    const parser = new DOMParser();
                    const parsed = parser.parseFromString(code, 'text/html');
                    parsed.querySelectorAll('script').forEach((script)=>{
                        const newScript = document.createElement('script');
                        Array.from(script.attributes).forEach((attr)=>newScript.setAttribute(attr.name, attr.value));
                        if (!script.src) newScript.textContent = script.textContent;
                        embedEl.appendChild(newScript);
                    });
                    blockedIframeEl.classList.remove('blocked-iframe--visible');
                }
            }
        });
        if ($cookies) {
            for(let i = 0; i < $cookies.length; i++)if ($cookies[i].type == 'iframes' && $d1dffb77f2e2cbfc$export$b6695554533f9b1e) // console.log({cookiesAcceptIframes}, $cookies[i]);
            $d1dffb77f2e2cbfc$export$3d6d112e1c42474a($cookies[i].script_tags);
        }
        $d1dffb77f2e2cbfc$export$9247c17b52f5af42();
    }
};








// do this when loading everything
// so after loading all (non lazyloaded) images
// imports --------------------------------------------------------------------
// import * as Listeners from './1-listeners.js';


const $c8dbe1d1968f1b0e$export$1d4b3c81d8e95c45 = ()=>{
    // sets all the pages after loading
    // console.log('loadedPage');
    // into frame so it's not called before onready (which Firefox and Safari do)
    requestAnimationFrame(()=>{
        // because things might've changed after font/img loading
        $41264c54ad2c6427$export$1871afb4a41ded14(true);
        // scroll to hash?
        const hash = window.location.hash.substring(1);
        const el = document.querySelector('.button--filter[data-filter="' + hash + '"]');
        // console.log('hash', hash, el);
        if (el) el.click();
    // if (hash && el) Scroll.scrollToEl(el); // maybe turn off if using view-transitions instead of history API
    });
};



// video embed 2.4
// starts loading a video iframe
// when you click the play button
// or choose to do openVideoEmbeds(holderEl); in page.js
// works with youtube and vimeo
// also copy _video-embed-X.scss
// copy video-embed  html element for correct usage
// can use fader (fader--loader fader--lazy) on .video-embed
// changelog
// 2.1 add option to not open all video embeds with preview image
// 2.2 closes all other videos when opening a video
// 2.3 close all video embeds option
// 2.4 add new vimeo iframe code
// 2.5 remove elFromEvent
// imports --------------------------------------------------------------------

// local variables ------------------------------------------------------------
let $996ad0891643a26e$var$videoEmbedHolderEl;
const $996ad0891643a26e$export$b4fb5688eb6f3fc5 = ()=>{
    // click listener --------------------------------
    document.body.addEventListener('click', (event)=>{
        // video embed play
        let el = event.target.closest('.video-embed__play');
        if (el) {
            $996ad0891643a26e$var$closeAllVideoEmbeds();
            $996ad0891643a26e$export$8e5309565ce5f618(el.closest('.video-embed'));
        }
    });
};
const $996ad0891643a26e$export$8e5309565ce5f618 = (videoEl, autoplay = false)=>{
    // console.log('openVideoEmbed', { videoEl }, { autoplay });
    if (!videoEl) return;
    // if cookiesAcceptIframes is not set (no cookie popup) or iframes are accepted by cookies
    // console.log('cookiesAcceptIframes', Cookies.cookiesAcceptIframes);
    if (typeof $d1dffb77f2e2cbfc$exports === 'undefined' || 'cookiesAcceptIframes' in $d1dffb77f2e2cbfc$exports && $d1dffb77f2e2cbfc$exports.cookiesAcceptIframes) {
        // show video's
        const type = videoEl.getAttribute('data-type');
        const id = videoEl.getAttribute('data-id');
        const foldout = videoEl.closest('.fold-out');
        // console.log({type, id, foldout});
        if (!type || !id || foldout && !foldout.classList.contains('fold-out--opened')) return;
        videoEl.classList.add('video-embed--show-iframe');
        let iframeHtml = '';
        if (type === 'youtube') iframeHtml += `<iframe src="//www.youtube.com/embed/${id}${autoplay ? '?autoplay=1&mute=1' : ''}"></iframe>`;
        else if (type === 'vimeo') iframeHtml += `<iframe src="//player.vimeo.com/video/${id}?title=0&byline=0&loop=true${autoplay ? '&autoplay=1&muted=1' : ''}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
        videoEl.insertAdjacentHTML('afterbegin', iframeHtml);
        const blockedIframeEl = videoEl.querySelector('.blocked-iframe');
        if (blockedIframeEl) blockedIframeEl.classList.remove('blocked-iframe--visible');
    } else {
        // cookiesAcceptIframes is defined and false
        // did not accept iframes
        console.log('show blocked');
        $996ad0891643a26e$var$closeVideoEmbed(videoEl);
        const blockedIframeEl = videoEl.querySelector('.blocked-iframe');
        if (blockedIframeEl) blockedIframeEl.classList.add('blocked-iframe--visible');
    }
};
const $996ad0891643a26e$var$closeVideoEmbed = (videoEl)=>{
    // console.log('closeVideoEmbed', { videoEl });
    if (!videoEl) return;
    videoEl.classList.remove('video-embed--show-iframe');
    const iframeEl = videoEl.querySelector('iframe');
    if (iframeEl) iframeEl.remove();
};
const $996ad0891643a26e$export$ba23807b151d9452 = (holderEl, openWithPreview = true)=>{
    // console.log('openVideoEmbeds', holderEl);
    if (!holderEl) return;
    $996ad0891643a26e$var$videoEmbedHolderEl = holderEl; // save for possible use in other scripts
    // skips closed foldouts
    const videoEmbedEls = holderEl.querySelectorAll('.video-embed');
    videoEmbedEls.forEach((videoEmbedEl)=>{
        const imgEl = videoEmbedEl.querySelector('img');
        if (openWithPreview || !imgEl) $996ad0891643a26e$export$8e5309565ce5f618(videoEmbedEl, false);
    });
};
const $996ad0891643a26e$var$closeVideoEmbeds = (holderEl)=>{
    // console.log('closeVideoEmbeds', holderEl);
    if (!holderEl) return;
    const videoEmbeds = holderEl.querySelectorAll('.video-embed');
    videoEmbeds.forEach($996ad0891643a26e$var$closeVideoEmbed);
};
const $996ad0891643a26e$var$closeAllVideoEmbeds = ()=>{
    // close other video embeds
    const videoEmbedEls = document.querySelectorAll('.video-embed--show-iframe');
    videoEmbedEls.forEach((videoEmbedEl)=>{
        $996ad0891643a26e$var$closeVideoEmbed(videoEmbedEl);
    });
};


// import * as MyHistory from './wb-history-v2.0.js';
// exported variables ---------------------------------------------------------
// local variables ------------------------------------------------------------
let $cba3eb2abed8e80a$var$domReady = false;
// functions -------------------------------------------------------------------
const $cba3eb2abed8e80a$var$init = ()=>{
    // console.log("init", Date.now());
    $d1dffb77f2e2cbfc$export$a2cf2b09102a656b();
    $183c77cc0773b3dc$export$90d0ea046136e3ed();
    $592a2eb60fbd4a62$export$f699d83c57fc51d7();
    $56a526a578fe3239$export$caa6e1ba6b757214();
    $b7c88863cbfbcd57$export$5e830c5f3cd8a610();
    if ($56a526a578fe3239$export$9d68b6ad9acc2308) $b7c88863cbfbcd57$export$dfdac01fb43f2195({
        prepareFaderForViewTransition: false,
        delay: false
    });
    $41264c54ad2c6427$export$1a8cec7304e4a7df();
    $b5ee8e0943d4762a$export$44e7c48d94f0a708();
    $eab0398616e9ffb4$export$4ea236338c7d64ed();
    $996ad0891643a26e$export$b4fb5688eb6f3fc5();
// MyHistory.initHistory();
// console.log('init done');
};
const $cba3eb2abed8e80a$var$tryInit = ()=>{
    if ($cba3eb2abed8e80a$var$domReady && window.blPageRevealed) $cba3eb2abed8e80a$var$init();
};
// register tryInit so render-blocking.js can call it
window.blTryInit = $cba3eb2abed8e80a$var$tryInit;
document.addEventListener('DOMContentLoaded', ()=>{
    // console.log('DOMContentLoaded', Date.now(), {pageRevealed: window.blPageRevealed});
    $cba3eb2abed8e80a$var$domReady = true;
    $cba3eb2abed8e80a$var$tryInit();
});
window.addEventListener('load', $c8dbe1d1968f1b0e$export$1d4b3c81d8e95c45); // console.log('This is the main JavaScript file.');


//# sourceMappingURL=bbcapital.1b12686a.js.map
